/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 * @portal-middleware/hooks
 * react-query hooks for interacting with portal-middleware
 * OpenAPI spec version: 2.264.0
 */ import { useMutation, useQuery } from "@tanstack/react-query";
import { faker } from "@faker-js/faker";
import { HttpResponse, delay, http } from "msw";
import { client } from "./client";
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOnboardingExistsSchemaType = {
    abbreviated_onboarding: 'abbreviated_onboarding',
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    starter_onboarding: 'starter_onboarding',
    state_onboarding: 'state_onboarding',
    state_conversion: 'state_conversion',
    voya_onboarding: 'voya_onboarding',
    vw_conversion: 'vw_conversion',
    workplace_onboarding: 'workplace_onboarding'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostOnboardingSchemaType = {
    abbreviated_onboarding: 'abbreviated_onboarding',
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    starter_onboarding: 'starter_onboarding',
    state_onboarding: 'state_onboarding',
    state_conversion: 'state_conversion',
    voya_onboarding: 'voya_onboarding',
    vw_conversion: 'vw_conversion',
    workplace_onboarding: 'workplace_onboarding'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOnboardingSchemaType = {
    abbreviated_onboarding: 'abbreviated_onboarding',
    digital_onboarding: 'digital_onboarding',
    esa_onboarding: 'esa_onboarding',
    jpm_conversion: 'jpm_conversion',
    starter_onboarding: 'starter_onboarding',
    state_onboarding: 'state_onboarding',
    state_conversion: 'state_conversion',
    voya_onboarding: 'voya_onboarding',
    vw_conversion: 'vw_conversion',
    workplace_onboarding: 'workplace_onboarding'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRegistrationResetEntity = {
    advisor: 'advisor',
    accessCode: 'accessCode',
    participant: 'participant',
    sponsor: 'sponsor'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeePendingTransactionsExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeePerformanceExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeeLoansExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetEmployeeHoldingsExcludeDistributionMethods = {
    FULL_CASH: 'FULL_CASH',
    PARTIAL_CASH: 'PARTIAL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER',
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SponsorRegistrationProgram = {
    register: 'register',
    exempt: 'exempt'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RegistrationStateDtoProgram = {
    register: 'register',
    exempt: 'exempt'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReasonBodyDtoExemptionReason = {
    '401a': '401a',
    '403a': '403a',
    '403b': '403b',
    '408k': '408k',
    '408p': '408p',
    '457b': '457b'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostWithdrawalBodyDtoReason = {
    ACP_CORRECTIVE: 'ACP_CORRECTIVE',
    ADP_CORRECTIVE: 'ADP_CORRECTIVE',
    CASH_OUT: 'CASH_OUT',
    CHILD: 'CHILD',
    DEATH: 'DEATH',
    DISABILITY: 'DISABILITY',
    EACA: 'EACA',
    FEE_OUT: 'FEE_OUT',
    FORCE_OUT: 'FORCE_OUT',
    HARDSHIP: 'HARDSHIP',
    IN_SERVICE: 'IN_SERVICE',
    PARTICIPANT_TERMINATION: 'PARTICIPANT_TERMINATION',
    PLAN_TERMINATION: 'PLAN_TERMINATION',
    QACA: 'QACA',
    QDRO: 'QDRO',
    '402G': '402G',
    NUMBER_415: '415',
    REQUIRED_MINIMUM: 'REQUIRED_MINIMUM',
    RETIREMENT_AGE: 'RETIREMENT_AGE',
    ROLLOVER: 'ROLLOVER',
    ESA: 'ESA'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostWithdrawalBodyDtoDistributionMethod = {
    CASH_AND_ROLLOVER: 'CASH_AND_ROLLOVER',
    FULL_CASH: 'FULL_CASH',
    FULL_ROLLOVER: 'FULL_ROLLOVER',
    PARTIAL_CASH: 'PARTIAL_CASH',
    PARTIAL_ROLLOVER: 'PARTIAL_ROLLOVER'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostRetirementPlannerPreviewAllocationBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostRetirementPlannerActivateBodyDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PostRetirementPlanner401kManagerQuestionnaireResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PersonaResDtoType = {
    advisor: 'advisor',
    participant: 'participant',
    sponsor: 'sponsor'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PdfConfigDtoFormat = {
    letter: 'letter',
    legal: 'legal',
    tabloid: 'tabloid',
    ledger: 'ledger',
    a0: 'a0',
    a1: 'a1',
    a2: 'a2',
    a3: 'a3',
    a4: 'a4',
    a5: 'a5',
    a6: 'a6'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchRegistrationEntityDtoEntity = {
    advisor: 'advisor',
    accessCode: 'accessCode',
    participant: 'participant',
    sponsor: 'sponsor'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PatchEsaWithdrawalBodyDtoEsaReason = {
    AUTOMOBILE: 'AUTOMOBILE',
    FUNERAL: 'FUNERAL',
    MEDICAL: 'MEDICAL',
    NOT_SAY: 'NOT_SAY',
    OTHER: 'OTHER',
    REPAIR_RESIDENCE: 'REPAIR_RESIDENCE',
    TUITION_EDUCATION: 'TUITION_EDUCATION'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ParticipantInvestmentsModelDtoModelType = {
    risk: 'risk',
    target: 'target',
    menu: 'menu',
    pmenu: 'pmenu',
    goal: 'goal',
    ms_rp: 'ms_rp'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetRetirementPlannerPreviewAllocationResDtoRiskTolerance = {
    aggressive: 'aggressive',
    conservative: 'conservative',
    moderate: 'moderate'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetOnboardingDtoStatus = {
    completed_manually: 'completed_manually',
    completed_successfully: 'completed_successfully',
    completed_unsuccessfully: 'completed_unsuccessfully',
    in_progress: 'in_progress',
    needs_attention: 'needs_attention',
    new: 'new',
    ongoing: 'ongoing'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBeneficiariesResDtoRelationship = {
    spouse: 'spouse',
    child: 'child',
    parent: 'parent',
    other: 'other'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetBeneficiariesResDtoBeneficiaryType = {
    person: 'person',
    trust: 'trust',
    organization: 'organization'
};
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContactBodyDtoEntity = {
    advisor: 'advisor',
    accessCode: 'accessCode',
    participant: 'participant',
    sponsor: 'sponsor'
};
export const getAdvisorById = (params, signal)=>{
    return client({
        url: `/api/advisor`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorByIdQueryKey = (params)=>{
    return [
        `/api/advisor`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorByIdQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorById = (params, options)=>{
    const queryOptions = getGetAdvisorByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAdvisorContactCard = (signal)=>{
    return client({
        url: `/api/advisor/contact-card`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorContactCardQueryKey = ()=>{
    return [
        `/api/advisor/contact-card`
    ];
};
export const getGetAdvisorContactCardQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorContactCardQueryKey();
    const queryFn = ({ signal })=>getAdvisorContactCard(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorContactCard = (options)=>{
    const queryOptions = getGetAdvisorContactCardQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putAdvisorContactCard = (advisorContactCardBodyDto)=>{
    return client({
        url: `/api/advisor/contact-card`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: advisorContactCardBodyDto
    });
};
export const getPutAdvisorContactCardMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putAdvisorContactCard(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutAdvisorContactCard = (options)=>{
    const mutationOptions = getPutAdvisorContactCardMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlans = (params, signal)=>{
    return client({
        url: `/api/advisor/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlansQueryKey = (params)=>{
    return [
        `/api/advisor/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlansQueryKey(params);
    const queryFn = ({ signal })=>getPlans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlans = (params, options)=>{
    const queryOptions = getGetPlansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlansTracker = (params, signal)=>{
    return client({
        url: `/api/advisor/plans/tracker`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlansTrackerQueryKey = (params)=>{
    return [
        `/api/advisor/plans/tracker`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlansTrackerQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlansTrackerQueryKey(params);
    const queryFn = ({ signal })=>getPlansTracker(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlansTracker = (params, options)=>{
    const queryOptions = getGetPlansTrackerQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanEmployees = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/employees`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEmployeesQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/employees`
    ];
};
export const getGetPlanEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEmployeesQueryKey();
    const queryFn = ({ signal })=>getPlanEmployees(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanEmployees = (options)=>{
    const queryOptions = getGetPlanEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanEmployee = (planId, employeeId, signal)=>{
    return client({
        url: `/api/advisor/plans/${planId}/employees/${employeeId}`,
        method: 'GET',
        signal
    });
};
export const getGetPlanEmployeeQueryKey = (planId, employeeId)=>{
    return [
        `/api/advisor/plans/${planId}/employees/${employeeId}`
    ];
};
export const getGetPlanEmployeeQueryOptions = (planId, employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanEmployeeQueryKey(planId, employeeId);
    const queryFn = ({ signal })=>getPlanEmployee(planId, employeeId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && employeeId),
        ...queryOptions
    };
};
export const useGetPlanEmployee = (planId, employeeId, options)=>{
    const queryOptions = getGetPlanEmployeeQueryOptions(planId, employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanModelSecurities = (planId, modelId, signal)=>{
    return client({
        url: `/api/plans/${planId}/models/${modelId}/securities`,
        method: 'GET',
        signal
    });
};
export const getGetPlanModelSecuritiesQueryKey = (planId, modelId)=>{
    return [
        `/api/plans/${planId}/models/${modelId}/securities`
    ];
};
export const getGetPlanModelSecuritiesQueryOptions = (planId, modelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanModelSecuritiesQueryKey(planId, modelId);
    const queryFn = ({ signal })=>getPlanModelSecurities(planId, modelId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && modelId),
        ...queryOptions
    };
};
export const useGetPlanModelSecurities = (planId, modelId, options)=>{
    const queryOptions = getGetPlanModelSecuritiesQueryOptions(planId, modelId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanStatistics = (planId, signal)=>{
    return client({
        url: `/api/sponsor/plans/${planId}/stats`,
        method: 'GET',
        signal
    });
};
export const getGetPlanStatisticsQueryKey = (planId)=>{
    return [
        `/api/sponsor/plans/${planId}/stats`
    ];
};
export const getGetPlanStatisticsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanStatisticsQueryKey(planId);
    const queryFn = ({ signal })=>getPlanStatistics(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetPlanStatistics = (planId, options)=>{
    const queryOptions = getGetPlanStatisticsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postLinkSponsor = (advisorSponsorLinksBody)=>{
    return client({
        url: `/api/advisor/sponsors/link`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: advisorSponsorLinksBody
    });
};
export const getPostLinkSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postLinkSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLinkSponsor = (options)=>{
    const mutationOptions = getPostLinkSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAdvisorByIdStats = (params, signal)=>{
    return client({
        url: `/api/advisor/statistics`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorByIdStatsQueryKey = (params)=>{
    return [
        `/api/advisor/statistics`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorByIdStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorByIdStatsQueryKey(params);
    const queryFn = ({ signal })=>getAdvisorByIdStats(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorByIdStats = (params, options)=>{
    const queryOptions = getGetAdvisorByIdStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCarousel = (signal)=>{
    return client({
        url: `/api/carousel`,
        method: 'GET',
        signal
    });
};
export const getGetCarouselQueryKey = ()=>{
    return [
        `/api/carousel`
    ];
};
export const getGetCarouselQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCarouselQueryKey();
    const queryFn = ({ signal })=>getCarousel(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCarousel = (options)=>{
    const queryOptions = getGetCarouselQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getConnectivity = (signal)=>{
    return client({
        url: `/api/connectivity`,
        method: 'GET',
        signal
    });
};
export const getGetConnectivityQueryKey = ()=>{
    return [
        `/api/connectivity`
    ];
};
export const getGetConnectivityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetConnectivityQueryKey();
    const queryFn = ({ signal })=>getConnectivity(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetConnectivity = (options)=>{
    const queryOptions = getGetConnectivityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCsm = (params, signal)=>{
    return client({
        url: `/api/csm`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCsmQueryKey = (params)=>{
    return [
        `/api/csm`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCsmQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCsmQueryKey(params);
    const queryFn = ({ signal })=>getCsm(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCsm = (params, options)=>{
    const queryOptions = getGetCsmQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getLoginDisclosure = (signal)=>{
    return client({
        url: `/api/disclosure/login`,
        method: 'GET',
        signal
    });
};
export const getGetLoginDisclosureQueryKey = ()=>{
    return [
        `/api/disclosure/login`
    ];
};
export const getGetLoginDisclosureQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoginDisclosureQueryKey();
    const queryFn = ({ signal })=>getLoginDisclosure(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetLoginDisclosure = (options)=>{
    const queryOptions = getGetLoginDisclosureQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putLoginDisclosure = (putLoginDisclosureBodyDto)=>{
    return client({
        url: `/api/disclosure/login`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putLoginDisclosureBodyDto
    });
};
export const getPutLoginDisclosureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putLoginDisclosure(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutLoginDisclosure = (options)=>{
    const mutationOptions = getPutLoginDisclosureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getLoginDisclosureAgreement = (signal)=>{
    return client({
        url: `/api/disclosure/login/agreement`,
        method: 'GET',
        signal
    });
};
export const getGetLoginDisclosureAgreementQueryKey = ()=>{
    return [
        `/api/disclosure/login/agreement`
    ];
};
export const getGetLoginDisclosureAgreementQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoginDisclosureAgreementQueryKey();
    const queryFn = ({ signal })=>getLoginDisclosureAgreement(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetLoginDisclosureAgreement = (options)=>{
    const queryOptions = getGetLoginDisclosureAgreementQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentById = (params, signal)=>{
    return client({
        url: `/api/document`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentByIdQueryKey = (params)=>{
    return [
        `/api/document`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentByIdQueryKey(params);
    const queryFn = ({ signal })=>getDocumentById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentById = (params, options)=>{
    const queryOptions = getGetDocumentByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDeleteDocumentById = (documentQueryDto)=>{
    return client({
        url: `/api/document`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: documentQueryDto
    });
};
export const getPatchDeleteDocumentByIdMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchDeleteDocumentById(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDeleteDocumentById = (options)=>{
    const mutationOptions = getPatchDeleteDocumentByIdMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllDocuments = (params, signal)=>{
    return client({
        url: `/api/documents`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAllDocumentsQueryKey = (params)=>{
    return [
        `/api/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAllDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllDocumentsQueryKey(params);
    const queryFn = ({ signal })=>getAllDocuments(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAllDocuments = (params, options)=>{
    const queryOptions = getGetAllDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentAgreement = (params, signal)=>{
    return client({
        url: `/api/documents/agreement`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentAgreementQueryKey = (params)=>{
    return [
        `/api/documents/agreement`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentAgreementQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentAgreementQueryKey(params);
    const queryFn = ({ signal })=>getDocumentAgreement(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentAgreement = (params, options)=>{
    const queryOptions = getGetDocumentAgreementQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postDocumentAgreement = (postDocumentAgreementBodyDto)=>{
    return client({
        url: `/api/documents/agreement`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postDocumentAgreementBodyDto
    });
};
export const getPostDocumentAgreementMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postDocumentAgreement(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostDocumentAgreement = (options)=>{
    const mutationOptions = getPostDocumentAgreementMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDocumentDownloadById = (params, signal)=>{
    return client({
        url: `/api/documents/download`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentDownloadByIdQueryKey = (params)=>{
    return [
        `/api/documents/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentDownloadByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentDownloadByIdQueryKey(params);
    const queryFn = ({ signal })=>getDocumentDownloadById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentDownloadById = (params, options)=>{
    const queryOptions = getGetDocumentDownloadByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentDownloadByKey = (params, signal)=>{
    return client({
        url: `/api/documents/download-by-key`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentDownloadByKeyQueryKey = (params)=>{
    return [
        `/api/documents/download-by-key`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentDownloadByKeyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentDownloadByKeyQueryKey(params);
    const queryFn = ({ signal })=>getDocumentDownloadByKey(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentDownloadByKey = (params, options)=>{
    const queryOptions = getGetDocumentDownloadByKeyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentAsHtml = (params, signal)=>{
    return client({
        url: `/api/documents/html`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetDocumentAsHtmlQueryKey = (params)=>{
    return [
        `/api/documents/html`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentAsHtmlQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentAsHtmlQueryKey(params);
    const queryFn = ({ signal })=>getDocumentAsHtml(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentAsHtml = (params, options)=>{
    const queryOptions = getGetDocumentAsHtmlQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDocumentAsHtmlAndDownload = (params, signal)=>{
    return client({
        url: `/api/documents/html/download`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetDocumentAsHtmlAndDownloadQueryKey = (params)=>{
    return [
        `/api/documents/html/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetDocumentAsHtmlAndDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDocumentAsHtmlAndDownloadQueryKey(params);
    const queryFn = ({ signal })=>getDocumentAsHtmlAndDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDocumentAsHtmlAndDownload = (params, options)=>{
    const queryOptions = getGetDocumentAsHtmlAndDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPdf = (postPdfBodyDto)=>{
    return client({
        url: `/api/documents/pdf`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPdfBodyDto,
        responseType: 'blob'
    });
};
export const getPostPdfMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPdf(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPdf = (options)=>{
    const mutationOptions = getPostPdfMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postUploadDocument = (uploadDocumentDto)=>{
    return client({
        url: `/api/documents/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: uploadDocumentDto
    });
};
export const getPostUploadDocumentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUploadDocument(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUploadDocument = (options)=>{
    const mutationOptions = getPostUploadDocumentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postEmail = (postEmailBodyDto)=>{
    return client({
        url: `/api/email`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postEmailBodyDto
    });
};
export const getPostEmailMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmail(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmail = (options)=>{
    const mutationOptions = getPostEmailMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postEmailPreviewRender = (emailPreviewRenderBodyDto)=>{
    return client({
        url: `/api/email/preview/render`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: emailPreviewRenderBodyDto
    });
};
export const getPostEmailPreviewRenderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEmailPreviewRender(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEmailPreviewRender = (options)=>{
    const mutationOptions = getPostEmailPreviewRenderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEmailPreviewById = (params, signal)=>{
    return client({
        url: `/api/email/previews`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmailPreviewByIdQueryKey = (params)=>{
    return [
        `/api/email/previews`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmailPreviewByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmailPreviewByIdQueryKey(params);
    const queryFn = ({ signal })=>getEmailPreviewById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmailPreviewById = (params, options)=>{
    const queryOptions = getGetEmailPreviewByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeHoldings = (params, signal)=>{
    return client({
        url: `/api/employee/holdings`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeHoldingsQueryKey = (params)=>{
    return [
        `/api/employee/holdings`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeHoldingsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeHoldingsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeHoldings(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeHoldings = (params, options)=>{
    const queryOptions = getGetEmployeeHoldingsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeLoans = (params, signal)=>{
    return client({
        url: `/api/employee/loans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeLoansQueryKey = (params)=>{
    return [
        `/api/employee/loans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeLoansQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeLoansQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeLoans(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeLoans = (params, options)=>{
    const queryOptions = getGetEmployeeLoansQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeePerformance = (params, signal)=>{
    return client({
        url: `/api/employee/performance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeePerformanceQueryKey = (params)=>{
    return [
        `/api/employee/performance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeePerformanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeePerformanceQueryKey(params);
    const queryFn = ({ signal })=>getEmployeePerformance(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeePerformance = (params, options)=>{
    const queryOptions = getGetEmployeePerformanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeTransactions = (params, signal)=>{
    return client({
        url: `/api/employee/transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeTransactionsQueryKey = (params)=>{
    return [
        `/api/employee/transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeTransactions = (params, options)=>{
    const queryOptions = getGetEmployeeTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeePendingTransactions = (params, signal)=>{
    return client({
        url: `/api/employee/transactions/pending`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeePendingTransactionsQueryKey = (params)=>{
    return [
        `/api/employee/transactions/pending`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeePendingTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeePendingTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeePendingTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeePendingTransactions = (params, options)=>{
    const queryOptions = getGetEmployeePendingTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeTransactionsYears = (params, signal)=>{
    return client({
        url: `/api/employee/transactions/years`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeTransactionsYearsQueryKey = (params)=>{
    return [
        `/api/employee/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeTransactionsYears(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeTransactionsYears = (params, options)=>{
    const queryOptions = getGetEmployeeTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProgramModelSecurities = (employeeId, type, signal)=>{
    return client({
        url: `/api/employee/${employeeId}/model-securities/${type}`,
        method: 'GET',
        signal
    });
};
export const getGetProgramModelSecuritiesQueryKey = (employeeId, type)=>{
    return [
        `/api/employee/${employeeId}/model-securities/${type}`
    ];
};
export const getGetProgramModelSecuritiesQueryOptions = (employeeId, type, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProgramModelSecuritiesQueryKey(employeeId, type);
    const queryFn = ({ signal })=>getProgramModelSecurities(employeeId, type, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(employeeId && type),
        ...queryOptions
    };
};
export const useGetProgramModelSecurities = (employeeId, type, options)=>{
    const queryOptions = getGetProgramModelSecuritiesQueryOptions(employeeId, type, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeesWithContributions = (params, signal)=>{
    return client({
        url: `/api/employees/contributions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeesWithContributionsQueryKey = (params)=>{
    return [
        `/api/employees/contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeesWithContributionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeesWithContributionsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeesWithContributions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeesWithContributions = (params, options)=>{
    const queryOptions = getGetEmployeesWithContributionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeLoanDetails = (params, signal)=>{
    return client({
        url: `/api/employees/loans/details`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeLoanDetailsQueryKey = (params)=>{
    return [
        `/api/employees/loans/details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeLoanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeLoanDetailsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeeLoanDetails(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeeLoanDetails = (params, options)=>{
    const queryOptions = getGetEmployeeLoanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeesTransactionsYears = (params, signal)=>{
    return client({
        url: `/api/employees/transactions/years`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeesTransactionsYearsQueryKey = (params)=>{
    return [
        `/api/employees/transactions/years`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeesTransactionsYearsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeesTransactionsYearsQueryKey(params);
    const queryFn = ({ signal })=>getEmployeesTransactionsYears(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployeesTransactionsYears = (params, options)=>{
    const queryOptions = getGetEmployeesTransactionsYearsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchEsaParticipantGoal = (patchEsaParticipantGoalBodyDto)=>{
    return client({
        url: `/api/esa/participant/goal`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchEsaParticipantGoalBodyDto
    });
};
export const getPatchEsaParticipantGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchEsaParticipantGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchEsaParticipantGoal = (options)=>{
    const mutationOptions = getPatchEsaParticipantGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEsaParticipantGoals = (signal)=>{
    return client({
        url: `/api/esa/participant/goals`,
        method: 'GET',
        signal
    });
};
export const getGetEsaParticipantGoalsQueryKey = ()=>{
    return [
        `/api/esa/participant/goals`
    ];
};
export const getGetEsaParticipantGoalsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaParticipantGoalsQueryKey();
    const queryFn = ({ signal })=>getEsaParticipantGoals(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaParticipantGoals = (options)=>{
    const queryOptions = getGetEsaParticipantGoalsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaParticipantIncentives = (signal)=>{
    return client({
        url: `/api/esa/participant/incentives`,
        method: 'GET',
        signal
    });
};
export const getGetEsaParticipantIncentivesQueryKey = ()=>{
    return [
        `/api/esa/participant/incentives`
    ];
};
export const getGetEsaParticipantIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaParticipantIncentivesQueryKey();
    const queryFn = ({ signal })=>getEsaParticipantIncentives(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaParticipantIncentives = (options)=>{
    const queryOptions = getGetEsaParticipantIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanCashInterestRate = (signal)=>{
    return client({
        url: `/api/esa/plan/cash-interest-rate`,
        method: 'GET',
        signal
    });
};
export const getGetEsaPlanCashInterestRateQueryKey = ()=>{
    return [
        `/api/esa/plan/cash-interest-rate`
    ];
};
export const getGetEsaPlanCashInterestRateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanCashInterestRateQueryKey();
    const queryFn = ({ signal })=>getEsaPlanCashInterestRate(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanCashInterestRate = (options)=>{
    const queryOptions = getGetEsaPlanCashInterestRateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanGroupBalanceOverTime = (params, signal)=>{
    return client({
        url: `/api/esa/plan/group-balance-over-time`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEsaPlanGroupBalanceOverTimeQueryKey = (params)=>{
    return [
        `/api/esa/plan/group-balance-over-time`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEsaPlanGroupBalanceOverTimeQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanGroupBalanceOverTimeQueryKey(params);
    const queryFn = ({ signal })=>getEsaPlanGroupBalanceOverTime(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanGroupBalanceOverTime = (params, options)=>{
    const queryOptions = getGetEsaPlanGroupBalanceOverTimeQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanGroupStats = (params, signal)=>{
    return client({
        url: `/api/esa/plan/group-stats`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEsaPlanGroupStatsQueryKey = (params)=>{
    return [
        `/api/esa/plan/group-stats`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEsaPlanGroupStatsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanGroupStatsQueryKey(params);
    const queryFn = ({ signal })=>getEsaPlanGroupStats(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanGroupStats = (params, options)=>{
    const queryOptions = getGetEsaPlanGroupStatsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanGroups = (signal)=>{
    return client({
        url: `/api/esa/plan/groups`,
        method: 'GET',
        signal
    });
};
export const getGetEsaPlanGroupsQueryKey = ()=>{
    return [
        `/api/esa/plan/groups`
    ];
};
export const getGetEsaPlanGroupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanGroupsQueryKey();
    const queryFn = ({ signal })=>getEsaPlanGroups(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanGroups = (options)=>{
    const queryOptions = getGetEsaPlanGroupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEsaPlanIncentives = (signal)=>{
    return client({
        url: `/api/esa/plan/incentives`,
        method: 'GET',
        signal
    });
};
export const getGetEsaPlanIncentivesQueryKey = ()=>{
    return [
        `/api/esa/plan/incentives`
    ];
};
export const getGetEsaPlanIncentivesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEsaPlanIncentivesQueryKey();
    const queryFn = ({ signal })=>getEsaPlanIncentives(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEsaPlanIncentives = (options)=>{
    const queryOptions = getGetEsaPlanIncentivesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchEsaWithdrawal = (patchEsaWithdrawalBodyDto)=>{
    return client({
        url: `/api/esa/withdrawal`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchEsaWithdrawalBodyDto
    });
};
export const getPatchEsaWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchEsaWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchEsaWithdrawal = (options)=>{
    const mutationOptions = getPatchEsaWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorExemptionConfirmation = (confirmBodyDto)=>{
    return client({
        url: `/api/exempt/confirmation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: confirmBodyDto
    });
};
export const getPostSponsorExemptionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorExemptionConfirmation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorExemptionConfirmation = (options)=>{
    const mutationOptions = getPostSponsorExemptionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorExemptionReason = (reasonBodyDto)=>{
    return client({
        url: `/api/exempt/reason`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: reasonBodyDto
    });
};
export const getPostSponsorExemptionReasonMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorExemptionReason(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorExemptionReason = (options)=>{
    const mutationOptions = getPostSponsorExemptionReasonMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getFi360Download = (params, signal)=>{
    return client({
        url: `/api/fact-sheets`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFi360DownloadQueryKey = (params)=>{
    return [
        `/api/fact-sheets`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFi360DownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFi360DownloadQueryKey(params);
    const queryFn = ({ signal })=>getFi360Download(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFi360Download = (params, options)=>{
    const queryOptions = getGetFi360DownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getFeatureToggles = (signal)=>{
    return client({
        url: `/api/feature-toggle`,
        method: 'GET',
        signal
    });
};
export const getGetFeatureTogglesQueryKey = ()=>{
    return [
        `/api/feature-toggle`
    ];
};
export const getGetFeatureTogglesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFeatureTogglesQueryKey();
    const queryFn = ({ signal })=>getFeatureToggles(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFeatureToggles = (options)=>{
    const queryOptions = getGetFeatureTogglesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getFeatureTogglesList = (signal)=>{
    return client({
        url: `/api/feature-toggle/list`,
        method: 'GET',
        signal
    });
};
export const getGetFeatureTogglesListQueryKey = ()=>{
    return [
        `/api/feature-toggle/list`
    ];
};
export const getGetFeatureTogglesListQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFeatureTogglesListQueryKey();
    const queryFn = ({ signal })=>getFeatureTogglesList(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFeatureTogglesList = (options)=>{
    const queryOptions = getGetFeatureTogglesListQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getFirmById = (params, signal)=>{
    return client({
        url: `/api/firm/entity`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetFirmByIdQueryKey = (params)=>{
    return [
        `/api/firm/entity`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetFirmByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetFirmByIdQueryKey(params);
    const queryFn = ({ signal })=>getFirmById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetFirmById = (params, options)=>{
    const queryOptions = getGetFirmByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getHealth = (signal)=>{
    return client({
        url: `/api/health`,
        method: 'GET',
        signal
    });
};
export const getGetHealthQueryKey = ()=>{
    return [
        `/api/health`
    ];
};
export const getGetHealthQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();
    const queryFn = ({ signal })=>getHealth(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetHealth = (options)=>{
    const queryOptions = getGetHealthQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getLoanAmortizationPdf = (params, signal)=>{
    return client({
        url: `/api/loans/amortization/pdf`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetLoanAmortizationPdfQueryKey = (params)=>{
    return [
        `/api/loans/amortization/pdf`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetLoanAmortizationPdfQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetLoanAmortizationPdfQueryKey(params);
    const queryFn = ({ signal })=>getLoanAmortizationPdf(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetLoanAmortizationPdf = (params, options)=>{
    const queryOptions = getGetLoanAmortizationPdfQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getManagedAccountsPlaidToken = (signal)=>{
    return client({
        url: `/api/managed-accounts/plaid-link-token`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountsPlaidTokenQueryKey = ()=>{
    return [
        `/api/managed-accounts/plaid-link-token`
    ];
};
export const getGetManagedAccountsPlaidTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountsPlaidTokenQueryKey();
    const queryFn = ({ signal })=>getManagedAccountsPlaidToken(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetManagedAccountsPlaidToken = (options)=>{
    const queryOptions = getGetManagedAccountsPlaidTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const deleteManagedAccountsPlaidLinks = (deletePlaidLinkBodyDto)=>{
    return client({
        url: `/api/managed-accounts/plaid-links`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlaidLinkBodyDto
    });
};
export const getDeleteManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deleteManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeleteManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getDeleteManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getManagedAccountsPlaidLinks = (signal)=>{
    return client({
        url: `/api/managed-accounts/plaid-links`,
        method: 'GET',
        signal
    });
};
export const getGetManagedAccountsPlaidLinksQueryKey = ()=>{
    return [
        `/api/managed-accounts/plaid-links`
    ];
};
export const getGetManagedAccountsPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetManagedAccountsPlaidLinksQueryKey();
    const queryFn = ({ signal })=>getManagedAccountsPlaidLinks(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetManagedAccountsPlaidLinks = (options)=>{
    const queryOptions = getGetManagedAccountsPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postManagedAccountsPlaidLinks = (postPlaidLinkBodyDto)=>{
    return client({
        url: `/api/managed-accounts/plaid-links`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlaidLinkBodyDto
    });
};
export const getPostManagedAccountsPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postManagedAccountsPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManagedAccountsPlaidLinks = (options)=>{
    const mutationOptions = getPostManagedAccountsPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postManagedAccountsPlaidBalances = (postPlaidBalancesBodyDto)=>{
    return client({
        url: `/api/managed-accounts/plaid-links/balance/get`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlaidBalancesBodyDto
    });
};
export const getPostManagedAccountsPlaidBalancesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postManagedAccountsPlaidBalances(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostManagedAccountsPlaidBalances = (options)=>{
    const mutationOptions = getPostManagedAccountsPlaidBalancesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getModelPerformance = (modelId, signal)=>{
    return client({
        url: `/api/model/${modelId}/performance`,
        method: 'GET',
        signal
    });
};
export const getGetModelPerformanceQueryKey = (modelId)=>{
    return [
        `/api/model/${modelId}/performance`
    ];
};
export const getGetModelPerformanceQueryOptions = (modelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetModelPerformanceQueryKey(modelId);
    const queryFn = ({ signal })=>getModelPerformance(modelId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!modelId,
        ...queryOptions
    };
};
export const useGetModelPerformance = (modelId, options)=>{
    const queryOptions = getGetModelPerformanceQueryOptions(modelId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantById = (params, signal)=>{
    return client({
        url: `/api/participant`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantByIdQueryKey = (params)=>{
    return [
        `/api/participant`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantByIdQueryKey(params);
    const queryFn = ({ signal })=>getParticipantById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantById = (params, options)=>{
    const queryOptions = getGetParticipantByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipant = (participantDto)=>{
    return client({
        url: `/api/participant`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantDto
    });
};
export const getPatchParticipantMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipant(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipant = (options)=>{
    const mutationOptions = getPatchParticipantMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantAccountBalanceById = (params, signal)=>{
    return client({
        url: `/api/participant/account-balance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantAccountBalanceByIdQueryKey = (params)=>{
    return [
        `/api/participant/account-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantAccountBalanceByIdQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAccountBalanceByIdQueryKey(params);
    const queryFn = ({ signal })=>getParticipantAccountBalanceById(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAccountBalanceById = (params, options)=>{
    const queryOptions = getGetParticipantAccountBalanceByIdQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantLoan = (loanBodyDto)=>{
    return client({
        url: `/api/participant/account/loans`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: loanBodyDto
    });
};
export const getPostParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantLoan(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantLoan = (options)=>{
    const mutationOptions = getPostParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantPlaidLinkToken = (params, signal)=>{
    return client({
        url: `/api/participant/account/loans/plaid-link-token`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantPlaidLinkTokenQueryKey = (params)=>{
    return [
        `/api/participant/account/loans/plaid-link-token`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantPlaidLinkTokenQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlaidLinkTokenQueryKey(params);
    const queryFn = ({ signal })=>getParticipantPlaidLinkToken(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantPlaidLinkToken = (params, options)=>{
    const queryOptions = getGetParticipantPlaidLinkTokenQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantPlaidLinks = (signal)=>{
    return client({
        url: `/api/participant/account/loans/plaid-links`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantPlaidLinksQueryKey = ()=>{
    return [
        `/api/participant/account/loans/plaid-links`
    ];
};
export const getGetParticipantPlaidLinksQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantPlaidLinksQueryKey();
    const queryFn = ({ signal })=>getParticipantPlaidLinks(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantPlaidLinks = (options)=>{
    const queryOptions = getGetParticipantPlaidLinksQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantPlaidLinks = (plaidLinkBodyDto)=>{
    return client({
        url: `/api/participant/account/loans/plaid-links`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: plaidLinkBodyDto
    });
};
export const getPostParticipantPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantPlaidLinks(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantPlaidLinks = (options)=>{
    const mutationOptions = getPostParticipantPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantLoanCreate = (signal)=>{
    return client({
        url: `/api/participant/account/loans/request`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantLoanCreateQueryKey = ()=>{
    return [
        `/api/participant/account/loans/request`
    ];
};
export const getGetParticipantLoanCreateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantLoanCreateQueryKey();
    const queryFn = ({ signal })=>getParticipantLoanCreate(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantLoanCreate = (options)=>{
    const queryOptions = getGetParticipantLoanCreateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantLoan = (loanId, loanAgreementBodyDto)=>{
    return client({
        url: `/api/participant/account/loans/${loanId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: loanAgreementBodyDto
    });
};
export const getPatchParticipantLoanMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return patchParticipantLoan(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantLoan = (options)=>{
    const mutationOptions = getPatchParticipantLoanMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postLoanManualRepayment = (loanId, bankAccountIdDto)=>{
    return client({
        url: `/api/participant/account/loans/${loanId}/payment`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: bankAccountIdDto
    });
};
export const getPostLoanManualRepaymentMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { loanId, data } = props ?? {};
        return postLoanManualRepayment(loanId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostLoanManualRepayment = (options)=>{
    const mutationOptions = getPostLoanManualRepaymentMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantAccounts = (params, signal)=>{
    return client({
        url: `/api/participant/accounts`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantAccountsQueryKey = (params)=>{
    return [
        `/api/participant/accounts`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantAccountsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAccountsQueryKey(params);
    const queryFn = ({ signal })=>getParticipantAccounts(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAccounts = (params, options)=>{
    const queryOptions = getGetParticipantAccountsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantBalanceOverTime = (signal)=>{
    return client({
        url: `/api/participant/balance-over-time`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantBalanceOverTimeQueryKey = ()=>{
    return [
        `/api/participant/balance-over-time`
    ];
};
export const getGetParticipantBalanceOverTimeQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantBalanceOverTimeQueryKey();
    const queryFn = ({ signal })=>getParticipantBalanceOverTime(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantBalanceOverTime = (options)=>{
    const queryOptions = getGetParticipantBalanceOverTimeQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantBankAccounts = (signal)=>{
    return client({
        url: `/api/participant/bank-accounts`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantBankAccountsQueryKey = ()=>{
    return [
        `/api/participant/bank-accounts`
    ];
};
export const getGetParticipantBankAccountsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantBankAccountsQueryKey();
    const queryFn = ({ signal })=>getParticipantBankAccounts(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantBankAccounts = (options)=>{
    const queryOptions = getGetParticipantBankAccountsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getBeneficiaries = (signal)=>{
    return client({
        url: `/api/participant/beneficiaries`,
        method: 'GET',
        signal
    });
};
export const getGetBeneficiariesQueryKey = ()=>{
    return [
        `/api/participant/beneficiaries`
    ];
};
export const getGetBeneficiariesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetBeneficiariesQueryKey();
    const queryFn = ({ signal })=>getBeneficiaries(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetBeneficiaries = (options)=>{
    const queryOptions = getGetBeneficiariesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putParticipantBeneficiaries = ()=>{
    return client({
        url: `/api/participant/beneficiaries`,
        method: 'PUT'
    });
};
export const getPutParticipantBeneficiariesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putParticipantBeneficiaries();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipantBeneficiaries = (options)=>{
    const mutationOptions = getPutParticipantBeneficiariesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRecentParticipantDocuments = (signal)=>{
    return client({
        url: `/api/participant/documents/recent`,
        method: 'GET',
        signal
    });
};
export const getGetRecentParticipantDocumentsQueryKey = ()=>{
    return [
        `/api/participant/documents/recent`
    ];
};
export const getGetRecentParticipantDocumentsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRecentParticipantDocumentsQueryKey();
    const queryFn = ({ signal })=>getRecentParticipantDocuments(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRecentParticipantDocuments = (options)=>{
    const queryOptions = getGetRecentParticipantDocumentsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postEsaGoal = (participantEsaGoalDto)=>{
    return client({
        url: `/api/participant/esa/goal`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantEsaGoalDto
    });
};
export const getPostEsaGoalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postEsaGoal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostEsaGoal = (options)=>{
    const mutationOptions = getPostEsaGoalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantIdentityVerification = (signal)=>{
    return client({
        url: `/api/participant/identity-verification`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantIdentityVerificationQueryKey = ()=>{
    return [
        `/api/participant/identity-verification`
    ];
};
export const getGetParticipantIdentityVerificationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantIdentityVerificationQueryKey();
    const queryFn = ({ signal })=>getParticipantIdentityVerification(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantIdentityVerification = (options)=>{
    const queryOptions = getGetParticipantIdentityVerificationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantInfoWithEmails = (participantDto)=>{
    return client({
        url: `/api/participant/info`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantDto
    });
};
export const getPatchParticipantInfoWithEmailsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipantInfoWithEmails(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantInfoWithEmails = (options)=>{
    const mutationOptions = getPatchParticipantInfoWithEmailsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getGoalFeedback = (signal)=>{
    return client({
        url: `/api/participant/investment-election`,
        method: 'GET',
        signal
    });
};
export const getGetGoalFeedbackQueryKey = ()=>{
    return [
        `/api/participant/investment-election`
    ];
};
export const getGetGoalFeedbackQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGoalFeedbackQueryKey();
    const queryFn = ({ signal })=>getGoalFeedback(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetGoalFeedback = (options)=>{
    const queryOptions = getGetGoalFeedbackQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postElectionAgeSuggestion = ()=>{
    return client({
        url: `/api/participant/investment-election/age-suggestion`,
        method: 'POST'
    });
};
export const getPostElectionAgeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postElectionAgeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostElectionAgeSuggestion = (options)=>{
    const mutationOptions = getPostElectionAgeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postElectionRetirementIncomeSuggestion = ()=>{
    return client({
        url: `/api/participant/investment-election/retirement-income-suggestion`,
        method: 'POST'
    });
};
export const getPostElectionRetirementIncomeSuggestionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postElectionRetirementIncomeSuggestion();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostElectionRetirementIncomeSuggestion = (options)=>{
    const mutationOptions = getPostElectionRetirementIncomeSuggestionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getElectionsSetup = (signal)=>{
    return client({
        url: `/api/participant/investment-election/setup`,
        method: 'GET',
        signal
    });
};
export const getGetElectionsSetupQueryKey = ()=>{
    return [
        `/api/participant/investment-election/setup`
    ];
};
export const getGetElectionsSetupQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetElectionsSetupQueryKey();
    const queryFn = ({ signal })=>getElectionsSetup(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetElectionsSetup = (options)=>{
    const queryOptions = getGetElectionsSetupQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postElectionsSetup = (investmentElectionSetupDto)=>{
    return client({
        url: `/api/participant/investment-election/setup`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: investmentElectionSetupDto
    });
};
export const getPostElectionsSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postElectionsSetup(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostElectionsSetup = (options)=>{
    const mutationOptions = getPostElectionsSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getInvestmentsModelDisplay = (signal)=>{
    return client({
        url: `/api/participant/investments/model`,
        method: 'GET',
        signal
    });
};
export const getGetInvestmentsModelDisplayQueryKey = ()=>{
    return [
        `/api/participant/investments/model`
    ];
};
export const getGetInvestmentsModelDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInvestmentsModelDisplayQueryKey();
    const queryFn = ({ signal })=>getInvestmentsModelDisplay(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetInvestmentsModelDisplay = (options)=>{
    const queryOptions = getGetInvestmentsModelDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanParticipantModelSecurities = (planId, modelId, signal)=>{
    return client({
        url: `/api/participant/investments/options/plans/${planId}/models/${modelId}/securities`,
        method: 'GET',
        signal
    });
};
export const getGetPlanParticipantModelSecuritiesQueryKey = (planId, modelId)=>{
    return [
        `/api/participant/investments/options/plans/${planId}/models/${modelId}/securities`
    ];
};
export const getGetPlanParticipantModelSecuritiesQueryOptions = (planId, modelId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantModelSecuritiesQueryKey(planId, modelId);
    const queryFn = ({ signal })=>getPlanParticipantModelSecurities(planId, modelId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && modelId),
        ...queryOptions
    };
};
export const useGetPlanParticipantModelSecurities = (planId, modelId, options)=>{
    const queryOptions = getGetPlanParticipantModelSecuritiesQueryOptions(planId, modelId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanParticipantStats = (planId, signal)=>{
    return client({
        url: `/api/participant/investments/options/plans/${planId}/stats`,
        method: 'GET',
        signal
    });
};
export const getGetPlanParticipantStatsQueryKey = (planId)=>{
    return [
        `/api/participant/investments/options/plans/${planId}/stats`
    ];
};
export const getGetPlanParticipantStatsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantStatsQueryKey(planId);
    const queryFn = ({ signal })=>getPlanParticipantStats(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetPlanParticipantStats = (planId, options)=>{
    const queryOptions = getGetPlanParticipantStatsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postRebalanceRequest = ()=>{
    return client({
        url: `/api/participant/investments/rebalance-request`,
        method: 'POST'
    });
};
export const getPostRebalanceRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postRebalanceRequest();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRebalanceRequest = (options)=>{
    const mutationOptions = getPostRebalanceRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRebalanceSettings = (signal)=>{
    return client({
        url: `/api/participant/investments/rebalance-settings`,
        method: 'GET',
        signal
    });
};
export const getGetRebalanceSettingsQueryKey = ()=>{
    return [
        `/api/participant/investments/rebalance-settings`
    ];
};
export const getGetRebalanceSettingsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRebalanceSettingsQueryKey();
    const queryFn = ({ signal })=>getRebalanceSettings(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRebalanceSettings = (options)=>{
    const queryOptions = getGetRebalanceSettingsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putRebalanceSettings = (rebalanceBodyDto)=>{
    return client({
        url: `/api/participant/investments/rebalance-settings`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: rebalanceBodyDto
    });
};
export const getPutRebalanceSettingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putRebalanceSettings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutRebalanceSettings = (options)=>{
    const mutationOptions = getPutRebalanceSettingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getStrategiesIndex = (signal)=>{
    return client({
        url: `/api/participant/investments/strategies`,
        method: 'GET',
        signal
    });
};
export const getGetStrategiesIndexQueryKey = ()=>{
    return [
        `/api/participant/investments/strategies`
    ];
};
export const getGetStrategiesIndexQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetStrategiesIndexQueryKey();
    const queryFn = ({ signal })=>getStrategiesIndex(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetStrategiesIndex = (options)=>{
    const queryOptions = getGetStrategiesIndexQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAgeBased = (signal)=>{
    return client({
        url: `/api/participant/investments/strategies/age-based`,
        method: 'GET',
        signal
    });
};
export const getGetAgeBasedQueryKey = ()=>{
    return [
        `/api/participant/investments/strategies/age-based`
    ];
};
export const getGetAgeBasedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAgeBasedQueryKey();
    const queryFn = ({ signal })=>getAgeBased(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAgeBased = (options)=>{
    const queryOptions = getGetAgeBasedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putAgeBased = (ageBasedBodyDto)=>{
    return client({
        url: `/api/participant/investments/strategies/age-based`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: ageBasedBodyDto
    });
};
export const getPutAgeBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putAgeBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutAgeBased = (options)=>{
    const mutationOptions = getPutAgeBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putCustomAllocation = (allocationsBodyDto)=>{
    return client({
        url: `/api/participant/investments/strategies/custom-allocation`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: allocationsBodyDto
    });
};
export const getPutCustomAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putCustomAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutCustomAllocation = (options)=>{
    const mutationOptions = getPutCustomAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRiskBased = (signal)=>{
    return client({
        url: `/api/participant/investments/strategies/risk-based`,
        method: 'GET',
        signal
    });
};
export const getGetRiskBasedQueryKey = ()=>{
    return [
        `/api/participant/investments/strategies/risk-based`
    ];
};
export const getGetRiskBasedQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRiskBasedQueryKey();
    const queryFn = ({ signal })=>getRiskBased(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRiskBased = (options)=>{
    const queryOptions = getGetRiskBasedQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putRiskBased = (riskBasedBodyDto)=>{
    return client({
        url: `/api/participant/investments/strategies/risk-based`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: riskBasedBodyDto
    });
};
export const getPutRiskBasedMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putRiskBased(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutRiskBased = (options)=>{
    const mutationOptions = getPutRiskBasedMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRiskModelQuestionnaire = (params, signal)=>{
    return client({
        url: `/api/participant/investments/strategies/risk-based/questionnaire`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRiskModelQuestionnaireQueryKey = (params)=>{
    return [
        `/api/participant/investments/strategies/risk-based/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRiskModelQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRiskModelQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>getRiskModelQuestionnaire(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRiskModelQuestionnaire = (params, options)=>{
    const queryOptions = getGetRiskModelQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getMailPreferences = (signal)=>{
    return client({
        url: `/api/participant/mail-preferences`,
        method: 'GET',
        signal
    });
};
export const getGetMailPreferencesQueryKey = ()=>{
    return [
        `/api/participant/mail-preferences`
    ];
};
export const getGetMailPreferencesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetMailPreferencesQueryKey();
    const queryFn = ({ signal })=>getMailPreferences(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetMailPreferences = (options)=>{
    const queryOptions = getGetMailPreferencesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putMailPreferences = (paperlessNoticesDto)=>{
    return client({
        url: `/api/participant/mail-preferences`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: paperlessNoticesDto
    });
};
export const getPutMailPreferencesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putMailPreferences(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutMailPreferences = (options)=>{
    const mutationOptions = getPutMailPreferencesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantOnboarding = (signal)=>{
    return client({
        url: `/api/participant/onboarding`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantOnboardingQueryKey = ()=>{
    return [
        `/api/participant/onboarding`
    ];
};
export const getGetParticipantOnboardingQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOnboardingQueryKey();
    const queryFn = ({ signal })=>getParticipantOnboarding(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantOnboarding = (options)=>{
    const queryOptions = getGetParticipantOnboardingQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantOverview = (signal)=>{
    return client({
        url: `/api/participant/overview`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantOverviewQueryKey = ()=>{
    return [
        `/api/participant/overview`
    ];
};
export const getGetParticipantOverviewQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantOverviewQueryKey();
    const queryFn = ({ signal })=>getParticipantOverview(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantOverview = (options)=>{
    const queryOptions = getGetParticipantOverviewQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantDiscardPendingPlaidLinks = ()=>{
    return client({
        url: `/api/participant/plaid-links/discard-pending`,
        method: 'POST'
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postParticipantDiscardPendingPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantDiscardPendingPlaidLinks = (options)=>{
    const mutationOptions = getPostParticipantDiscardPendingPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPositions = (signal)=>{
    return client({
        url: `/api/participant/positions`,
        method: 'GET',
        signal
    });
};
export const getGetPositionsQueryKey = ()=>{
    return [
        `/api/participant/positions`
    ];
};
export const getGetPositionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPositionsQueryKey();
    const queryFn = ({ signal })=>getPositions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPositions = (options)=>{
    const queryOptions = getGetPositionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchParticipantRollover = (rolloverBodyDto)=>{
    return client({
        url: `/api/participant/rollovers`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: rolloverBodyDto
    });
};
export const getPatchParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipantRollover(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantRollover = (options)=>{
    const mutationOptions = getPatchParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRolloverInstructions = (signal)=>{
    return client({
        url: `/api/participant/rollovers/instructions`,
        method: 'GET',
        signal
    });
};
export const getGetRolloverInstructionsQueryKey = ()=>{
    return [
        `/api/participant/rollovers/instructions`
    ];
};
export const getGetRolloverInstructionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverInstructionsQueryKey();
    const queryFn = ({ signal })=>getRolloverInstructions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRolloverInstructions = (options)=>{
    const queryOptions = getGetRolloverInstructionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRolloverEligibility = (signal)=>{
    return client({
        url: `/api/participant/rollovers/request`,
        method: 'GET',
        signal
    });
};
export const getGetRolloverEligibilityQueryKey = ()=>{
    return [
        `/api/participant/rollovers/request`
    ];
};
export const getGetRolloverEligibilityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRolloverEligibilityQueryKey();
    const queryFn = ({ signal })=>getRolloverEligibility(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRolloverEligibility = (options)=>{
    const queryOptions = getGetRolloverEligibilityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantRollover = ()=>{
    return client({
        url: `/api/participant/rollovers/request`,
        method: 'POST'
    });
};
export const getPostParticipantRolloverMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postParticipantRollover();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantRollover = (options)=>{
    const mutationOptions = getPostParticipantRolloverMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantRollover = (rolloverId, signal)=>{
    return client({
        url: `/api/participant/rollovers/${rolloverId}`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantRolloverQueryKey = (rolloverId)=>{
    return [
        `/api/participant/rollovers/${rolloverId}`
    ];
};
export const getGetParticipantRolloverQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantRolloverQueryKey(rolloverId);
    const queryFn = ({ signal })=>getParticipantRollover(rolloverId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!rolloverId,
        ...queryOptions
    };
};
export const useGetParticipantRollover = (rolloverId, options)=>{
    const queryOptions = getGetParticipantRolloverQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGenerateRolloverLetter = (rolloverId, signal)=>{
    return client({
        url: `/api/participant/rollovers/${rolloverId}/letter`,
        method: 'GET',
        signal
    });
};
export const getGetGenerateRolloverLetterQueryKey = (rolloverId)=>{
    return [
        `/api/participant/rollovers/${rolloverId}/letter`
    ];
};
export const getGetGenerateRolloverLetterQueryOptions = (rolloverId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGenerateRolloverLetterQueryKey(rolloverId);
    const queryFn = ({ signal })=>getGenerateRolloverLetter(rolloverId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!rolloverId,
        ...queryOptions
    };
};
export const useGetGenerateRolloverLetter = (rolloverId, options)=>{
    const queryOptions = getGetGenerateRolloverLetterQueryOptions(rolloverId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSavingsDisplay = (signal)=>{
    return client({
        url: `/api/participant/savings`,
        method: 'GET',
        signal
    });
};
export const getGetSavingsDisplayQueryKey = ()=>{
    return [
        `/api/participant/savings`
    ];
};
export const getGetSavingsDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSavingsDisplayQueryKey();
    const queryFn = ({ signal })=>getSavingsDisplay(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSavingsDisplay = (options)=>{
    const queryOptions = getGetSavingsDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putSavings = (savingsBodyDto)=>{
    return client({
        url: `/api/participant/savings`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: savingsBodyDto
    });
};
export const getPutSavingsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putSavings(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutSavings = (options)=>{
    const mutationOptions = getPutSavingsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSurveyLink = (signal)=>{
    return client({
        url: `/api/participant/survey/link`,
        method: 'GET',
        signal
    });
};
export const getGetSurveyLinkQueryKey = ()=>{
    return [
        `/api/participant/survey/link`
    ];
};
export const getGetSurveyLinkQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSurveyLinkQueryKey();
    const queryFn = ({ signal })=>getSurveyLink(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSurveyLink = (options)=>{
    const queryOptions = getGetSurveyLinkQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantAggregatedByCategoryTransactions = (signal)=>{
    return client({
        url: `/api/participant/transactions/aggregated-by-category`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsQueryKey = ()=>{
    return [
        `/api/participant/transactions/aggregated-by-category`
    ];
};
export const getGetParticipantAggregatedByCategoryTransactionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAggregatedByCategoryTransactionsQueryKey();
    const queryFn = ({ signal })=>getParticipantAggregatedByCategoryTransactions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAggregatedByCategoryTransactions = (options)=>{
    const queryOptions = getGetParticipantAggregatedByCategoryTransactionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getAllowedWithdrawalReasons = (signal)=>{
    return client({
        url: `/api/participant/withdrawals`,
        method: 'GET',
        signal
    });
};
export const getGetAllowedWithdrawalReasonsQueryKey = ()=>{
    return [
        `/api/participant/withdrawals`
    ];
};
export const getGetAllowedWithdrawalReasonsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllowedWithdrawalReasonsQueryKey();
    const queryFn = ({ signal })=>getAllowedWithdrawalReasons(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAllowedWithdrawalReasons = (options)=>{
    const queryOptions = getGetAllowedWithdrawalReasonsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postWithdrawal = ()=>{
    return client({
        url: `/api/participant/withdrawals`,
        method: 'POST'
    });
};
export const getPostWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postWithdrawal();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostWithdrawal = (options)=>{
    const mutationOptions = getPostWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getUnregisteredParticipants = (params, signal)=>{
    return client({
        url: `/api/participants/unregistered`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUnregisteredParticipantsQueryKey = (params)=>{
    return [
        `/api/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUnregisteredParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUnregisteredParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getUnregisteredParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUnregisteredParticipants = (params, options)=>{
    const queryOptions = getGetUnregisteredParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getUnregisteredParticipantsCount = (params, signal)=>{
    return client({
        url: `/api/participants/unregistered/count`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUnregisteredParticipantsCountQueryKey = (params)=>{
    return [
        `/api/participants/unregistered/count`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUnregisteredParticipantsCountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUnregisteredParticipantsCountQueryKey(params);
    const queryFn = ({ signal })=>getUnregisteredParticipantsCount(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUnregisteredParticipantsCount = (params, options)=>{
    const queryOptions = getGetUnregisteredParticipantsCountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantWelcomeEmailDownload = (params, signal)=>{
    return client({
        url: `/api/participants/welcome-emails/download`,
        method: 'GET',
        params,
        responseType: 'blob',
        signal
    });
};
export const getGetParticipantWelcomeEmailDownloadQueryKey = (params)=>{
    return [
        `/api/participants/welcome-emails/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantWelcomeEmailDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantWelcomeEmailDownloadQueryKey(params);
    const queryFn = ({ signal })=>getParticipantWelcomeEmailDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantWelcomeEmailDownload = (params, options)=>{
    const queryOptions = getGetParticipantWelcomeEmailDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantWelcomeEmailsHistory = (params, signal)=>{
    return client({
        url: `/api/participants/welcome-emails/history`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetParticipantWelcomeEmailsHistoryQueryKey = (params)=>{
    return [
        `/api/participants/welcome-emails/history`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetParticipantWelcomeEmailsHistoryQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantWelcomeEmailsHistoryQueryKey(params);
    const queryFn = ({ signal })=>getParticipantWelcomeEmailsHistory(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantWelcomeEmailsHistory = (params, options)=>{
    const queryOptions = getGetParticipantWelcomeEmailsHistoryQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCalculatedEsaEmployerContributions = (participantId, params, signal)=>{
    return client({
        url: `/api/participants/${participantId}/calculate-employer-contributions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCalculatedEsaEmployerContributionsQueryKey = (participantId, params)=>{
    return [
        `/api/participants/${participantId}/calculate-employer-contributions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCalculatedEsaEmployerContributionsQueryOptions = (participantId, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCalculatedEsaEmployerContributionsQueryKey(participantId, params);
    const queryFn = ({ signal })=>getCalculatedEsaEmployerContributions(participantId, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!participantId,
        ...queryOptions
    };
};
export const useGetCalculatedEsaEmployerContributions = (participantId, params, options)=>{
    const queryOptions = getGetCalculatedEsaEmployerContributionsQueryOptions(participantId, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPersonas = (params, signal)=>{
    return client({
        url: `/api/personas`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPersonasQueryKey = (params)=>{
    return [
        `/api/personas`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPersonasQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPersonasQueryKey(params);
    const queryFn = ({ signal })=>getPersonas(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPersonas = (params, options)=>{
    const queryOptions = getGetPersonasQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanParticipants = (params, signal)=>{
    return client({
        url: `/api/plan/participants`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanParticipantsQueryKey = (params)=>{
    return [
        `/api/plan/participants`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanParticipantsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanParticipantsQueryKey(params);
    const queryFn = ({ signal })=>getPlanParticipants(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanParticipants = (params, options)=>{
    const queryOptions = getGetPlanParticipantsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanModel = (params, signal)=>{
    return client({
        url: `/api/plans/models`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanModelQueryKey = (params)=>{
    return [
        `/api/plans/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanModelQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanModelQueryKey(params);
    const queryFn = ({ signal })=>getPlanModel(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanModel = (params, options)=>{
    const queryOptions = getGetPlanModelQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanInvestments = (planId, signal)=>{
    return client({
        url: `/api/plans/${planId}/investments`,
        method: 'GET',
        signal
    });
};
export const getGetPlanInvestmentsQueryKey = (planId)=>{
    return [
        `/api/plans/${planId}/investments`
    ];
};
export const getGetPlanInvestmentsQueryOptions = (planId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanInvestmentsQueryKey(planId);
    const queryFn = ({ signal })=>getPlanInvestments(planId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!planId,
        ...queryOptions
    };
};
export const useGetPlanInvestments = (planId, options)=>{
    const queryOptions = getGetPlanInvestmentsQueryOptions(planId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProgramFunds = (params, signal)=>{
    return client({
        url: `/api/program/funds`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetProgramFundsQueryKey = (params)=>{
    return [
        `/api/program/funds`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetProgramFundsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProgramFundsQueryKey(params);
    const queryFn = ({ signal })=>getProgramFunds(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetProgramFunds = (params, options)=>{
    const queryOptions = getGetProgramFundsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProgramModels = (params, signal)=>{
    return client({
        url: `/api/program/models`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetProgramModelsQueryKey = (params)=>{
    return [
        `/api/program/models`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetProgramModelsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProgramModelsQueryKey(params);
    const queryFn = ({ signal })=>getProgramModels(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetProgramModels = (params, options)=>{
    const queryOptions = getGetProgramModelsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getProspectusUrlParts = (signal)=>{
    return client({
        url: `/api/prospectus/url`,
        method: 'GET',
        signal
    });
};
export const getGetProspectusUrlPartsQueryKey = ()=>{
    return [
        `/api/prospectus/url`
    ];
};
export const getGetProspectusUrlPartsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetProspectusUrlPartsQueryKey();
    const queryFn = ({ signal })=>getProspectusUrlParts(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetProspectusUrlParts = (options)=>{
    const queryOptions = getGetProspectusUrlPartsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRedirectToPersonas = (signal)=>{
    return client({
        url: `/api/redirect/personas`,
        method: 'GET',
        signal
    });
};
export const getGetRedirectToPersonasQueryKey = ()=>{
    return [
        `/api/redirect/personas`
    ];
};
export const getGetRedirectToPersonasQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRedirectToPersonasQueryKey();
    const queryFn = ({ signal })=>getRedirectToPersonas(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRedirectToPersonas = (options)=>{
    const queryOptions = getGetRedirectToPersonasQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getParticipantAddressOptions = (signal)=>{
    return client({
        url: `/api/register/address/options`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantAddressOptionsQueryKey = ()=>{
    return [
        `/api/register/address/options`
    ];
};
export const getGetParticipantAddressOptionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantAddressOptionsQueryKey();
    const queryFn = ({ signal })=>getParticipantAddressOptions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantAddressOptions = (options)=>{
    const queryOptions = getGetParticipantAddressOptionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantAddressVerify = (participantVerifyAddressBody)=>{
    return client({
        url: `/api/register/address/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantVerifyAddressBody
    });
};
export const getPostParticipantAddressVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantAddressVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantAddressVerify = (options)=>{
    const mutationOptions = getPostParticipantAddressVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postAdvisorConnect = (connectBodyDto)=>{
    return client({
        url: `/api/register/advisor/connect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: connectBodyDto
    });
};
export const getPostAdvisorConnectMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorConnect(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorConnect = (options)=>{
    const mutationOptions = getPostAdvisorConnectMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAdvisorFinish = (signal)=>{
    return client({
        url: `/api/register/advisor/finish`,
        method: 'GET',
        signal
    });
};
export const getGetAdvisorFinishQueryKey = ()=>{
    return [
        `/api/register/advisor/finish`
    ];
};
export const getGetAdvisorFinishQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorFinishQueryKey();
    const queryFn = ({ signal })=>getAdvisorFinish(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAdvisorFinish = (options)=>{
    const queryOptions = getGetAdvisorFinishQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postAdvisorPassword = (passwordBodyDto)=>{
    return client({
        url: `/api/register/advisor/password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: passwordBodyDto
    });
};
export const getPostAdvisorPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorPassword = (options)=>{
    const mutationOptions = getPostAdvisorPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postAdvisorVerify = (verifyBodyDto)=>{
    return client({
        url: `/api/register/advisor/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: verifyBodyDto
    });
};
export const getPostAdvisorVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postAdvisorVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostAdvisorVerify = (options)=>{
    const mutationOptions = getPostAdvisorVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantCompanyOptions = (signal)=>{
    return client({
        url: `/api/register/company/options`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantCompanyOptionsQueryKey = ()=>{
    return [
        `/api/register/company/options`
    ];
};
export const getGetParticipantCompanyOptionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantCompanyOptionsQueryKey();
    const queryFn = ({ signal })=>getParticipantCompanyOptions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantCompanyOptions = (options)=>{
    const queryOptions = getGetParticipantCompanyOptionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantCompanyVerify = (participantVerifyCompanyBody)=>{
    return client({
        url: `/api/register/company/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantVerifyCompanyBody
    });
};
export const getPostParticipantCompanyVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantCompanyVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantCompanyVerify = (options)=>{
    const mutationOptions = getPostParticipantCompanyVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postParticipantConnectVerify = (connectVerifyBody)=>{
    return client({
        url: `/api/register/connect/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: connectVerifyBody
    });
};
export const getPostParticipantConnectVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantConnectVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantConnectVerify = (options)=>{
    const mutationOptions = getPostParticipantConnectVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchParticipantContact = (contactDto)=>{
    return client({
        url: `/api/register/contact`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: contactDto
    });
};
export const getPatchParticipantContactMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchParticipantContact(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchParticipantContact = (options)=>{
    const mutationOptions = getPatchParticipantContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRegistrationContact = (contactBodyDto)=>{
    return client({
        url: `/api/register/contact`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: contactBodyDto
    });
};
export const getPostRegistrationContactMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRegistrationContact(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRegistrationContact = (options)=>{
    const mutationOptions = getPostRegistrationContactMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorVerify = (sponsorVerifyBody)=>{
    return client({
        url: `/api/register/employer`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorVerifyBody
    });
};
export const getPostSponsorVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorVerify = (options)=>{
    const mutationOptions = getPostSponsorVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorAccessCodeRequest = (sponsorAccessCodeRequestBody)=>{
    return client({
        url: `/api/register/employer/access-code-request`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorAccessCodeRequestBody
    });
};
export const getPostSponsorAccessCodeRequestMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorAccessCodeRequest(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorAccessCodeRequest = (options)=>{
    const mutationOptions = getPostSponsorAccessCodeRequestMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSponsorConnect = (sponsorContactBody)=>{
    return client({
        url: `/api/register/employer/connect`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorContactBody
    });
};
export const getPostSponsorConnectMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorConnect(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorConnect = (options)=>{
    const mutationOptions = getPostSponsorConnectMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorFinish = (signal)=>{
    return client({
        url: `/api/register/employer/finish`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorFinishQueryKey = ()=>{
    return [
        `/api/register/employer/finish`
    ];
};
export const getGetSponsorFinishQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorFinishQueryKey();
    const queryFn = ({ signal })=>getSponsorFinish(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorFinish = (options)=>{
    const queryOptions = getGetSponsorFinishQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postSponsorPassword = (sponsorPasswordBody)=>{
    return client({
        url: `/api/register/employer/password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: sponsorPasswordBody
    });
};
export const getPostSponsorPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postSponsorPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorPassword = (options)=>{
    const mutationOptions = getPostSponsorPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantFinish = (signal)=>{
    return client({
        url: `/api/register/finish`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantFinishQueryKey = ()=>{
    return [
        `/api/register/finish`
    ];
};
export const getGetParticipantFinishQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantFinishQueryKey();
    const queryFn = ({ signal })=>getParticipantFinish(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantFinish = (options)=>{
    const queryOptions = getGetParticipantFinishQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantPassword = (passwordDto)=>{
    return client({
        url: `/api/register/password`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: passwordDto
    });
};
export const getPostParticipantPasswordMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantPassword(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantPassword = (options)=>{
    const mutationOptions = getPostParticipantPasswordMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRegistrationReset = (params, signal)=>{
    return client({
        url: `/api/register/reset`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRegistrationResetQueryKey = (params)=>{
    return [
        `/api/register/reset`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRegistrationResetQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRegistrationResetQueryKey(params);
    const queryFn = ({ signal })=>getRegistrationReset(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRegistrationReset = (params, options)=>{
    const queryOptions = getGetRegistrationResetQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postParticipantVerify = (participantVerifyBody)=>{
    return client({
        url: `/api/register/verify`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: participantVerifyBody
    });
};
export const getPostParticipantVerifyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postParticipantVerify(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostParticipantVerify = (options)=>{
    const mutationOptions = getPostParticipantVerifyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRegistrationState = (signal)=>{
    return client({
        url: `/api/registration/state`,
        method: 'GET',
        signal
    });
};
export const getGetRegistrationStateQueryKey = ()=>{
    return [
        `/api/registration/state`
    ];
};
export const getGetRegistrationStateQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRegistrationStateQueryKey();
    const queryFn = ({ signal })=>getRegistrationState(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRegistrationState = (options)=>{
    const queryOptions = getGetRegistrationStateQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchRegistrationState = (patchRegistrationEntityDto)=>{
    return client({
        url: `/api/registration/state`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchRegistrationEntityDto
    });
};
export const getPatchRegistrationStateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchRegistrationState(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchRegistrationState = (options)=>{
    const mutationOptions = getPatchRegistrationStateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAdvisorReport = (advisorId, reportType, fileName, params, signal)=>{
    return client({
        url: `/api/reports/advisors/${advisorId}/${reportType}/${fileName}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetAdvisorReportQueryKey = (advisorId, reportType, fileName, params)=>{
    return [
        `/api/reports/advisors/${advisorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetAdvisorReportQueryOptions = (advisorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAdvisorReportQueryKey(advisorId, reportType, fileName, params);
    const queryFn = ({ signal })=>getAdvisorReport(advisorId, reportType, fileName, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(advisorId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetAdvisorReport = (advisorId, reportType, fileName, params, options)=>{
    const queryOptions = getGetAdvisorReportQueryOptions(advisorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEmployeeReport = (employeeId, reportType, fileName, params, signal)=>{
    return client({
        url: `/api/reports/employees/${employeeId}/${reportType}/${fileName}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetEmployeeReportQueryKey = (employeeId, reportType, fileName, params)=>{
    return [
        `/api/reports/employees/${employeeId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetEmployeeReportQueryOptions = (employeeId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeReportQueryKey(employeeId, reportType, fileName, params);
    const queryFn = ({ signal })=>getEmployeeReport(employeeId, reportType, fileName, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(employeeId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetEmployeeReport = (employeeId, reportType, fileName, params, options)=>{
    const queryOptions = getGetEmployeeReportQueryOptions(employeeId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getUnregisteredParticipantsReport = (params, signal)=>{
    return client({
        url: `/api/reports/participants/unregistered`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetUnregisteredParticipantsReportQueryKey = (params)=>{
    return [
        `/api/reports/participants/unregistered`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetUnregisteredParticipantsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetUnregisteredParticipantsReportQueryKey(params);
    const queryFn = ({ signal })=>getUnregisteredParticipantsReport(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetUnregisteredParticipantsReport = (params, options)=>{
    const queryOptions = getGetUnregisteredParticipantsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanReport = (planId, reportType, fileName, signal)=>{
    return client({
        url: `/api/reports/plans/${planId}/${reportType}/${fileName}`,
        method: 'GET',
        signal
    });
};
export const getGetPlanReportQueryKey = (planId, reportType, fileName)=>{
    return [
        `/api/reports/plans/${planId}/${reportType}/${fileName}`
    ];
};
export const getGetPlanReportQueryOptions = (planId, reportType, fileName, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanReportQueryKey(planId, reportType, fileName);
    const queryFn = ({ signal })=>getPlanReport(planId, reportType, fileName, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(planId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetPlanReport = (planId, reportType, fileName, options)=>{
    const queryOptions = getGetPlanReportQueryOptions(planId, reportType, fileName, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorReport = (sponsorId, reportType, fileName, params, signal)=>{
    return client({
        url: `/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSponsorReportQueryKey = (sponsorId, reportType, fileName, params)=>{
    return [
        `/api/reports/sponsors/${sponsorId}/${reportType}/${fileName}`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSponsorReportQueryOptions = (sponsorId, reportType, fileName, params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorReportQueryKey(sponsorId, reportType, fileName, params);
    const queryFn = ({ signal })=>getSponsorReport(sponsorId, reportType, fileName, params, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!(sponsorId && reportType && fileName),
        ...queryOptions
    };
};
export const useGetSponsorReport = (sponsorId, reportType, fileName, params, options)=>{
    const queryOptions = getGetSponsorReportQueryOptions(sponsorId, reportType, fileName, params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaTransactionsReport = (params, signal)=>{
    return client({
        url: `/api/reports/suba-transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaTransactionsReportQueryKey = (params)=>{
    return [
        `/api/reports/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaTransactionsReportQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaTransactionsReportQueryKey(params);
    const queryFn = ({ signal })=>getSubaTransactionsReport(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaTransactionsReport = (params, options)=>{
    const queryOptions = getGetSubaTransactionsReportQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postRetirementPlanner401kManagerQuestionnaire = (postRetirementPlanner401kManagerQuestionnaireBodyDto)=>{
    return client({
        url: `/api/retirement-planner/401k-manager-questionnaire`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRetirementPlanner401kManagerQuestionnaireBodyDto
    });
};
export const getPostRetirementPlanner401kManagerQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRetirementPlanner401kManagerQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRetirementPlanner401kManagerQuestionnaire = (options)=>{
    const mutationOptions = getPostRetirementPlanner401kManagerQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRetirementPlannerActivate = (postRetirementPlannerActivateBodyDto)=>{
    return client({
        url: `/api/retirement-planner/activate`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRetirementPlannerActivateBodyDto
    });
};
export const getPostRetirementPlannerActivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRetirementPlannerActivate(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRetirementPlannerActivate = (options)=>{
    const mutationOptions = getPostRetirementPlannerActivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRetirementPlannerDeactivate = ()=>{
    return client({
        url: `/api/retirement-planner/deactivate`,
        method: 'POST'
    });
};
export const getPostRetirementPlannerDeactivateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postRetirementPlannerDeactivate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRetirementPlannerDeactivate = (options)=>{
    const mutationOptions = getPostRetirementPlannerDeactivateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRetirementPlannerPreviewAllocation = (signal)=>{
    return client({
        url: `/api/retirement-planner/preview-allocation`,
        method: 'GET',
        signal
    });
};
export const getGetRetirementPlannerPreviewAllocationQueryKey = ()=>{
    return [
        `/api/retirement-planner/preview-allocation`
    ];
};
export const getGetRetirementPlannerPreviewAllocationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRetirementPlannerPreviewAllocationQueryKey();
    const queryFn = ({ signal })=>getRetirementPlannerPreviewAllocation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRetirementPlannerPreviewAllocation = (options)=>{
    const queryOptions = getGetRetirementPlannerPreviewAllocationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postRetirementPlannerPreviewAllocation = (postRetirementPlannerPreviewAllocationBodyDto)=>{
    return client({
        url: `/api/retirement-planner/preview-allocation`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRetirementPlannerPreviewAllocationBodyDto
    });
};
export const getPostRetirementPlannerPreviewAllocationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRetirementPlannerPreviewAllocation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRetirementPlannerPreviewAllocation = (options)=>{
    const mutationOptions = getPostRetirementPlannerPreviewAllocationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getAllSafeHarborContributionTypes = (signal)=>{
    return client({
        url: `/api/safe-harbor-contribution-types`,
        method: 'GET',
        signal
    });
};
export const getGetAllSafeHarborContributionTypesQueryKey = ()=>{
    return [
        `/api/safe-harbor-contribution-types`
    ];
};
export const getGetAllSafeHarborContributionTypesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetAllSafeHarborContributionTypesQueryKey();
    const queryFn = ({ signal })=>getAllSafeHarborContributionTypes(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetAllSafeHarborContributionTypes = (options)=>{
    const queryOptions = getGetAllSafeHarborContributionTypesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSession = (signal)=>{
    return client({
        url: `/api/session`,
        method: 'GET',
        signal
    });
};
export const getGetSessionQueryKey = ()=>{
    return [
        `/api/session`
    ];
};
export const getGetSessionQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSessionQueryKey();
    const queryFn = ({ signal })=>getSession(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSession = (options)=>{
    const queryOptions = getGetSessionQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorAbilities = (signal)=>{
    return client({
        url: `/api/sponsor/abilities`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorAbilitiesQueryKey = ()=>{
    return [
        `/api/sponsor/abilities`
    ];
};
export const getGetSponsorAbilitiesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorAbilitiesQueryKey();
    const queryFn = ({ signal })=>getSponsorAbilities(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorAbilities = (options)=>{
    const queryOptions = getGetSponsorAbilitiesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getCensusParticipants = (signal)=>{
    return client({
        url: `/api/sponsor/census/participants`,
        method: 'GET',
        signal
    });
};
export const getGetCensusParticipantsQueryKey = ()=>{
    return [
        `/api/sponsor/census/participants`
    ];
};
export const getGetCensusParticipantsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCensusParticipantsQueryKey();
    const queryFn = ({ signal })=>getCensusParticipants(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCensusParticipants = (options)=>{
    const queryOptions = getGetCensusParticipantsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getBankAccount = (signal)=>{
    return client({
        url: `/api/sponsor/company/bank-account`,
        method: 'GET',
        signal
    });
};
export const getGetBankAccountQueryKey = ()=>{
    return [
        `/api/sponsor/company/bank-account`
    ];
};
export const getGetBankAccountQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetBankAccountQueryKey();
    const queryFn = ({ signal })=>getBankAccount(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetBankAccount = (options)=>{
    const queryOptions = getGetBankAccountQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postBankAccount = ()=>{
    return client({
        url: `/api/sponsor/company/bank-account`,
        method: 'POST'
    });
};
export const getPostBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postBankAccount();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostBankAccount = (options)=>{
    const mutationOptions = getPostBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putBankAccount = (postBankAccountDto)=>{
    return client({
        url: `/api/sponsor/company/bank-account`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postBankAccountDto
    });
};
export const getPutBankAccountMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putBankAccount(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutBankAccount = (options)=>{
    const mutationOptions = getPutBankAccountMutationOptions(options);
    return useMutation(mutationOptions);
};
export const patchSponsor = (companyInfoBodyDto)=>{
    return client({
        url: `/api/sponsor/company/company-info`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: companyInfoBodyDto
    });
};
export const getPatchSponsorMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchSponsor(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchSponsor = (options)=>{
    const mutationOptions = getPatchSponsorMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorTeammates = (signal)=>{
    return client({
        url: `/api/sponsor/company/manage-teammate`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorTeammatesQueryKey = ()=>{
    return [
        `/api/sponsor/company/manage-teammate`
    ];
};
export const getGetSponsorTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorTeammatesQueryKey();
    const queryFn = ({ signal })=>getSponsorTeammates(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorTeammates = (options)=>{
    const queryOptions = getGetSponsorTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDeleteTeammate = ()=>{
    return client({
        url: `/api/sponsor/company/manage-teammate`,
        method: 'PATCH'
    });
};
export const getPatchDeleteTeammateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return patchDeleteTeammate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDeleteTeammate = (options)=>{
    const mutationOptions = getPatchDeleteTeammateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postSendUserInvite = ()=>{
    return client({
        url: `/api/sponsor/company/manage-teammate`,
        method: 'POST'
    });
};
export const getPostSendUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postSendUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSendUserInvite = (options)=>{
    const mutationOptions = getPostSendUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postFileHeadersUpdate = ()=>{
    return client({
        url: `/api/sponsor/contribution/headers/mapping`,
        method: 'POST'
    });
};
export const getPostFileHeadersUpdateMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postFileHeadersUpdate();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFileHeadersUpdate = (options)=>{
    const mutationOptions = getPostFileHeadersUpdateMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionsLandingPageDisplay = (signal)=>{
    return client({
        url: `/api/sponsor/contributions`,
        method: 'GET',
        signal
    });
};
export const getGetContributionsLandingPageDisplayQueryKey = ()=>{
    return [
        `/api/sponsor/contributions`
    ];
};
export const getGetContributionsLandingPageDisplayQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionsLandingPageDisplayQueryKey();
    const queryFn = ({ signal })=>getContributionsLandingPageDisplay(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetContributionsLandingPageDisplay = (options)=>{
    const queryOptions = getGetContributionsLandingPageDisplayQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContribution = ()=>{
    return client({
        url: `/api/sponsor/contributions`,
        method: 'POST'
    });
};
export const getPostContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContribution = (options)=>{
    const mutationOptions = getPostContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postCancelSubmission = ()=>{
    return client({
        url: `/api/sponsor/contributions/cancel`,
        method: 'POST'
    });
};
export const getPostCancelSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postCancelSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCancelSubmission = (options)=>{
    const mutationOptions = getPostCancelSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postCancellationSubmission = ()=>{
    return client({
        url: `/api/sponsor/contributions/cancellation`,
        method: 'POST'
    });
};
export const getPostCancellationSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postCancellationSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCancellationSubmission = (options)=>{
    const mutationOptions = getPostCancellationSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getParticipantsLoans = (signal)=>{
    return client({
        url: `/api/sponsor/contributions/loans`,
        method: 'GET',
        signal
    });
};
export const getGetParticipantsLoansQueryKey = ()=>{
    return [
        `/api/sponsor/contributions/loans`
    ];
};
export const getGetParticipantsLoansQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetParticipantsLoansQueryKey();
    const queryFn = ({ signal })=>getParticipantsLoans(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetParticipantsLoans = (options)=>{
    const queryOptions = getGetParticipantsLoansQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postOffCycleContribution = ()=>{
    return client({
        url: `/api/sponsor/contributions/offcycle`,
        method: 'POST'
    });
};
export const getPostOffCycleContributionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postOffCycleContribution();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOffCycleContribution = (options)=>{
    const mutationOptions = getPostOffCycleContributionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postResumeSubmission = ()=>{
    return client({
        url: `/api/sponsor/contributions/resume`,
        method: 'POST'
    });
};
export const getPostResumeSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postResumeSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostResumeSubmission = (options)=>{
    const mutationOptions = getPostResumeSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postIngestionFlowValidation = ()=>{
    return client({
        url: `/api/sponsor/contributions/validate`,
        method: 'POST'
    });
};
export const getPostIngestionFlowValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postIngestionFlowValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIngestionFlowValidation = (options)=>{
    const mutationOptions = getPostIngestionFlowValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postContributionValidation = ()=>{
    return client({
        url: `/api/sponsor/contributions/validation`,
        method: 'POST'
    });
};
export const getPostContributionValidationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postContributionValidation();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionValidation = (options)=>{
    const mutationOptions = getPostContributionValidationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionSubmissionDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}`,
        method: 'GET',
        signal
    });
};
export const getGetContributionSubmissionDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}`
    ];
};
export const getGetContributionSubmissionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionSubmissionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionSubmissionDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionSubmissionDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionSubmissionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionConfirmation = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/confirm`,
        method: 'POST'
    });
};
export const getPostContributionConfirmationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postContributionConfirmation(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionConfirmation = (options)=>{
    const mutationOptions = getPostContributionConfirmationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionConfirmationDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/confirmation`,
        method: 'GET',
        signal
    });
};
export const getGetContributionConfirmationDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/confirmation`
    ];
};
export const getGetContributionConfirmationDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionConfirmationDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionConfirmationDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionConfirmationDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionConfirmationDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionCorrection = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/correction`,
        method: 'POST'
    });
};
export const getPostContributionCorrectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postContributionCorrection(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionCorrection = (options)=>{
    const mutationOptions = getPostContributionCorrectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionCorrections = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/corrections`,
        method: 'GET',
        signal
    });
};
export const getGetContributionCorrectionsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/corrections`
    ];
};
export const getGetContributionCorrectionsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionCorrectionsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionCorrections(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionCorrections = (ucid, options)=>{
    const queryOptions = getGetContributionCorrectionsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionDetails = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/details`,
        method: 'GET',
        signal
    });
};
export const getGetContributionDetailsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/details`
    ];
};
export const getGetContributionDetailsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionDetailsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionDetails(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionDetails = (ucid, options)=>{
    const queryOptions = getGetContributionDetailsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/display`,
        method: 'GET',
        signal
    });
};
export const getGetContributionDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/display`
    ];
};
export const getGetContributionDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionUpload = (ucid, categoryId)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/document-category/${categoryId}/upload`,
        method: 'POST'
    });
};
export const getPostContributionUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid, categoryId } = props ?? {};
        return postContributionUpload(ucid, categoryId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionUpload = (options)=>{
    const mutationOptions = getPostContributionUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDownloadContributionFile = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/file`,
        method: 'GET',
        signal
    });
};
export const getGetDownloadContributionFileQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/file`
    ];
};
export const getGetDownloadContributionFileQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadContributionFileQueryKey(ucid);
    const queryFn = ({ signal })=>getDownloadContributionFile(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetDownloadContributionFile = (ucid, options)=>{
    const queryOptions = getGetDownloadContributionFileQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getForfeiture = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/forfeiture`,
        method: 'GET',
        signal
    });
};
export const getGetForfeitureQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/forfeiture`
    ];
};
export const getGetForfeitureQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetForfeitureQueryKey(ucid);
    const queryFn = ({ signal })=>getForfeiture(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetForfeiture = (ucid, options)=>{
    const queryOptions = getGetForfeitureQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postForfeiture = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/forfeiture`,
        method: 'POST'
    });
};
export const getPostForfeitureMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postForfeiture(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostForfeiture = (options)=>{
    const mutationOptions = getPostForfeitureMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getContributionHeaderValidations = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/headers`,
        method: 'GET',
        signal
    });
};
export const getGetContributionHeaderValidationsQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/headers`
    ];
};
export const getGetContributionHeaderValidationsQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionHeaderValidationsQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionHeaderValidations(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionHeaderValidations = (ucid, options)=>{
    const queryOptions = getGetContributionHeaderValidationsQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getNormalizedContributionData = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/normalized`,
        method: 'GET',
        signal
    });
};
export const getGetNormalizedContributionDataQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/normalized`
    ];
};
export const getGetNormalizedContributionDataQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNormalizedContributionDataQueryKey(ucid);
    const queryFn = ({ signal })=>getNormalizedContributionData(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetNormalizedContributionData = (ucid, options)=>{
    const queryOptions = getGetNormalizedContributionDataQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postIngestionFlowStart = (ucid)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/start`,
        method: 'POST'
    });
};
export const getPostIngestionFlowStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { ucid } = props ?? {};
        return postIngestionFlowStart(ucid);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostIngestionFlowStart = (options)=>{
    const mutationOptions = getPostIngestionFlowStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getDownloadContributionTemplate = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/template.xlsx`,
        method: 'GET',
        signal
    });
};
export const getGetDownloadContributionTemplateQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/template.xlsx`
    ];
};
export const getGetDownloadContributionTemplateQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDownloadContributionTemplateQueryKey(ucid);
    const queryFn = ({ signal })=>getDownloadContributionTemplate(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetDownloadContributionTemplate = (ucid, options)=>{
    const queryOptions = getGetDownloadContributionTemplateQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionValidationPageDisplay = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/validate`,
        method: 'GET',
        signal
    });
};
export const getGetContributionValidationPageDisplayQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/validate`
    ];
};
export const getGetContributionValidationPageDisplayQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionValidationPageDisplayQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionValidationPageDisplay(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionValidationPageDisplay = (ucid, options)=>{
    const queryOptions = getGetContributionValidationPageDisplayQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributionValidation = (ucid, signal)=>{
    return client({
        url: `/api/sponsor/contributions/${ucid}/validation`,
        method: 'GET',
        signal
    });
};
export const getGetContributionValidationQueryKey = (ucid)=>{
    return [
        `/api/sponsor/contributions/${ucid}/validation`
    ];
};
export const getGetContributionValidationQueryOptions = (ucid, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionValidationQueryKey(ucid);
    const queryFn = ({ signal })=>getContributionValidation(ucid, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!ucid,
        ...queryOptions
    };
};
export const useGetContributionValidation = (ucid, options)=>{
    const queryOptions = getGetContributionValidationQueryOptions(ucid, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getDeferralChanges = (signal)=>{
    return client({
        url: `/api/sponsor/deferral/changes`,
        method: 'GET',
        signal
    });
};
export const getGetDeferralChangesQueryKey = ()=>{
    return [
        `/api/sponsor/deferral/changes`
    ];
};
export const getGetDeferralChangesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetDeferralChangesQueryKey();
    const queryFn = ({ signal })=>getDeferralChanges(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetDeferralChanges = (options)=>{
    const queryOptions = getGetDeferralChangesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchDeferralChangesActivities = ()=>{
    return client({
        url: `/api/sponsor/deferral/changes`,
        method: 'PATCH'
    });
};
export const getPatchDeferralChangesActivitiesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return patchDeferralChangesActivities();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchDeferralChangesActivities = (options)=>{
    const mutationOptions = getPatchDeferralChangesActivitiesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putParticipant = ()=>{
    return client({
        url: `/api/sponsor/employee`,
        method: 'PUT'
    });
};
export const getPutParticipantMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putParticipant();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipant = (options)=>{
    const mutationOptions = getPutParticipantMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEmployees = (signal)=>{
    return client({
        url: `/api/sponsor/employees`,
        method: 'GET',
        signal
    });
};
export const getGetEmployeesQueryKey = ()=>{
    return [
        `/api/sponsor/employees`
    ];
};
export const getGetEmployeesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeesQueryKey();
    const queryFn = ({ signal })=>getEmployees(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetEmployees = (options)=>{
    const queryOptions = getGetEmployeesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putParticipants = ()=>{
    return client({
        url: `/api/sponsor/employees`,
        method: 'PUT'
    });
};
export const getPutParticipantsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putParticipants();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipants = (options)=>{
    const mutationOptions = getPutParticipantsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postValidateEmployee = ()=>{
    return client({
        url: `/api/sponsor/employees/validate`,
        method: 'POST'
    });
};
export const getPostValidateEmployeeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postValidateEmployee();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostValidateEmployee = (options)=>{
    const mutationOptions = getPostValidateEmployeeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getEmployeeDetails = (employeeId, signal)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}`,
        method: 'GET',
        signal
    });
};
export const getGetEmployeeDetailsQueryKey = (employeeId)=>{
    return [
        `/api/sponsor/employees/${employeeId}`
    ];
};
export const getGetEmployeeDetailsQueryOptions = (employeeId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEmployeeDetailsQueryKey(employeeId);
    const queryFn = ({ signal })=>getEmployeeDetails(employeeId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!employeeId,
        ...queryOptions
    };
};
export const useGetEmployeeDetails = (employeeId, options)=>{
    const queryOptions = getGetEmployeeDetailsQueryOptions(employeeId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchEmployee = (employeeId, patchEmployeeIdBodyDto)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchEmployeeIdBodyDto
    });
};
export const getPatchEmployeeMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId, data } = props ?? {};
        return patchEmployee(employeeId, data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchEmployee = (options)=>{
    const mutationOptions = getPatchEmployeeMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postContactInfo = (employeeId)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}/address`,
        method: 'POST'
    });
};
export const getPostContactInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return postContactInfo(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContactInfo = (options)=>{
    const mutationOptions = getPostContactInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putParticipantContributions = (employeeId)=>{
    return client({
        url: `/api/sponsor/employees/${employeeId}/contributions`,
        method: 'PUT'
    });
};
export const getPutParticipantContributionsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { employeeId } = props ?? {};
        return putParticipantContributions(employeeId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutParticipantContributions = (options)=>{
    const mutationOptions = getPutParticipantContributionsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorEntity = (signal)=>{
    return client({
        url: `/api/sponsor/entity`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorEntityQueryKey = ()=>{
    return [
        `/api/sponsor/entity`
    ];
};
export const getGetSponsorEntityQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorEntityQueryKey();
    const queryFn = ({ signal })=>getSponsorEntity(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorEntity = (options)=>{
    const queryOptions = getGetSponsorEntityQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getForfeiturePreference = (signal)=>{
    return client({
        url: `/api/sponsor/forfeiture-preference`,
        method: 'GET',
        signal
    });
};
export const getGetForfeiturePreferenceQueryKey = ()=>{
    return [
        `/api/sponsor/forfeiture-preference`
    ];
};
export const getGetForfeiturePreferenceQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetForfeiturePreferenceQueryKey();
    const queryFn = ({ signal })=>getForfeiturePreference(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetForfeiturePreference = (options)=>{
    const queryOptions = getGetForfeiturePreferenceQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putForfeiturePreference = (putForfeiturePreferenceBodyDto)=>{
    return client({
        url: `/api/sponsor/forfeiture-preference`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putForfeiturePreferenceBodyDto
    });
};
export const getPutForfeiturePreferenceMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putForfeiturePreference(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutForfeiturePreference = (options)=>{
    const mutationOptions = getPutForfeiturePreferenceMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getHeapData = (signal)=>{
    return client({
        url: `/api/sponsor/heap`,
        method: 'GET',
        signal
    });
};
export const getGetHeapDataQueryKey = ()=>{
    return [
        `/api/sponsor/heap`
    ];
};
export const getGetHeapDataQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetHeapDataQueryKey();
    const queryFn = ({ signal })=>getHeapData(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetHeapData = (options)=>{
    const queryOptions = getGetHeapDataQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getOnboarding = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOnboardingQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOnboardingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnboardingQueryKey(params);
    const queryFn = ({ signal })=>getOnboarding(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetOnboarding = (params, options)=>{
    const queryOptions = getGetOnboardingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postOnboarding = (params)=>{
    return client({
        url: `/api/sponsor/onboarding`,
        method: 'POST',
        params
    });
};
export const getPostOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { params } = props ?? {};
        return postOnboarding(params);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostOnboarding = (options)=>{
    const mutationOptions = getPostOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putOnboarding = ()=>{
    return client({
        url: `/api/sponsor/onboarding`,
        method: 'PUT'
    });
};
export const getPutOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutOnboarding = (options)=>{
    const mutationOptions = getPutOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorOnboardingInformation = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding-information`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorOnboardingInformationQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding-information`
    ];
};
export const getGetSponsorOnboardingInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorOnboardingInformationQueryKey();
    const queryFn = ({ signal })=>getSponsorOnboardingInformation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorOnboardingInformation = (options)=>{
    const queryOptions = getGetSponsorOnboardingInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postUploadCensus = (postCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/onboarding/add-employees`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postCensusBodyDto
    });
};
export const getPostUploadCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postUploadCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostUploadCensus = (options)=>{
    const mutationOptions = getPostUploadCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getInitialCensus = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding/census`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetInitialCensusQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding/census`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetInitialCensusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetInitialCensusQueryKey(params);
    const queryFn = ({ signal })=>getInitialCensus(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetInitialCensus = (params, options)=>{
    const queryOptions = getGetInitialCensusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorEsaProgram = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding/esa-program`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSponsorEsaProgramQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding/esa-program`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSponsorEsaProgramQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorEsaProgramQueryKey(params);
    const queryFn = ({ signal })=>getSponsorEsaProgram(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorEsaProgram = (params, options)=>{
    const queryOptions = getGetSponsorEsaProgramQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getOnboardingExists = (params, signal)=>{
    return client({
        url: `/api/sponsor/onboarding/exists`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetOnboardingExistsQueryKey = (params)=>{
    return [
        `/api/sponsor/onboarding/exists`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetOnboardingExistsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetOnboardingExistsQueryKey(params);
    const queryFn = ({ signal })=>getOnboardingExists(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetOnboardingExists = (params, options)=>{
    const queryOptions = getGetOnboardingExistsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postFinishOnboarding = ()=>{
    return client({
        url: `/api/sponsor/onboarding/finish`,
        method: 'POST'
    });
};
export const getPostFinishOnboardingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postFinishOnboarding();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostFinishOnboarding = (options)=>{
    const mutationOptions = getPostFinishOnboardingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getSponsorOnboardingTeammates = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/manage-teammate`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorOnboardingTeammatesQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/manage-teammate`
    ];
};
export const getGetSponsorOnboardingTeammatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorOnboardingTeammatesQueryKey();
    const queryFn = ({ signal })=>getSponsorOnboardingTeammates(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorOnboardingTeammates = (options)=>{
    const queryOptions = getGetSponsorOnboardingTeammatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postSendOnboardingUserInvite = ()=>{
    return client({
        url: `/api/sponsor/onboarding/manage-teammate`,
        method: 'POST'
    });
};
export const getPostSendOnboardingUserInviteMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postSendOnboardingUserInvite();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSendOnboardingUserInvite = (options)=>{
    const mutationOptions = getPostSendOnboardingUserInviteMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getNextPayrollDates = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/payroll-dates`,
        method: 'GET',
        signal
    });
};
export const getGetNextPayrollDatesQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/payroll-dates`
    ];
};
export const getGetNextPayrollDatesQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetNextPayrollDatesQueryKey();
    const queryFn = ({ signal })=>getNextPayrollDates(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetNextPayrollDates = (options)=>{
    const queryOptions = getGetNextPayrollDatesQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollProviders = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/payroll-providers`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollProvidersQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/payroll-providers`
    ];
};
export const getGetPayrollProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollProvidersQueryKey();
    const queryFn = ({ signal })=>getPayrollProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollProviders = (options)=>{
    const queryOptions = getGetPayrollProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorPlaidLinkToken = (signal)=>{
    return client({
        url: `/api/sponsor/onboarding/plaid-link-token`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorPlaidLinkTokenQueryKey = ()=>{
    return [
        `/api/sponsor/onboarding/plaid-link-token`
    ];
};
export const getGetSponsorPlaidLinkTokenQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorPlaidLinkTokenQueryKey();
    const queryFn = ({ signal })=>getSponsorPlaidLinkToken(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorPlaidLinkToken = (options)=>{
    const queryOptions = getGetSponsorPlaidLinkTokenQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postGetSponsorPlaidLinks = ()=>{
    return client({
        url: `/api/sponsor/onboarding/plaid-links`,
        method: 'POST'
    });
};
export const getPostGetSponsorPlaidLinksMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postGetSponsorPlaidLinks();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostGetSponsorPlaidLinks = (options)=>{
    const mutationOptions = getPostGetSponsorPlaidLinksMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPayrollConnectionStatus = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/connection-status`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollConnectionStatusQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/connection-status`
    ];
};
export const getGetPayrollConnectionStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollConnectionStatusQueryKey();
    const queryFn = ({ signal })=>getPayrollConnectionStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollConnectionStatus = (options)=>{
    const queryOptions = getGetPayrollConnectionStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollDates = (params, signal)=>{
    return client({
        url: `/api/sponsor/payroll/dates`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPayrollDatesQueryKey = (params)=>{
    return [
        `/api/sponsor/payroll/dates`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPayrollDatesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollDatesQueryKey(params);
    const queryFn = ({ signal })=>getPayrollDates(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollDates = (params, options)=>{
    const queryOptions = getGetPayrollDatesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollInfo = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/info`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollInfoQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/info`
    ];
};
export const getGetPayrollInfoQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollInfoQueryKey();
    const queryFn = ({ signal })=>getPayrollInfo(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollInfo = (options)=>{
    const queryOptions = getGetPayrollInfoQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPayrollSetups = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/setup`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollSetupsQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/setup`
    ];
};
export const getGetPayrollSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollSetupsQueryKey();
    const queryFn = ({ signal })=>getPayrollSetups(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollSetups = (options)=>{
    const queryOptions = getGetPayrollSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPayrollSetup = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup`,
        method: 'POST'
    });
};
export const getPostPayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postPayrollSetup();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollSetup = (options)=>{
    const mutationOptions = getPostPayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPayrollFundingSetups = (signal)=>{
    return client({
        url: `/api/sponsor/payroll/setup/funding`,
        method: 'GET',
        signal
    });
};
export const getGetPayrollFundingSetupsQueryKey = ()=>{
    return [
        `/api/sponsor/payroll/setup/funding`
    ];
};
export const getGetPayrollFundingSetupsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPayrollFundingSetupsQueryKey();
    const queryFn = ({ signal })=>getPayrollFundingSetups(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPayrollFundingSetups = (options)=>{
    const queryOptions = getGetPayrollFundingSetupsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPayrollProvider = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup/provider`,
        method: 'PUT'
    });
};
export const getPutPayrollProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putPayrollProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollProvider = (options)=>{
    const mutationOptions = getPutPayrollProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPayrollSkipStatus = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup/skip`,
        method: 'PUT'
    });
};
export const getPutPayrollSkipStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putPayrollSkipStatus();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollSkipStatus = (options)=>{
    const mutationOptions = getPutPayrollSkipStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putSkipSubmission = ()=>{
    return client({
        url: `/api/sponsor/payroll/setup/skipping`,
        method: 'PUT'
    });
};
export const getPutSkipSubmissionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return putSkipSubmission();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutSkipSubmission = (options)=>{
    const mutationOptions = getPutSkipSubmissionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePayrollSetup = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}`,
        method: 'DELETE'
    });
};
export const getDeletePayrollSetupMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return deletePayrollSetup(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePayrollSetup = (options)=>{
    const mutationOptions = getDeletePayrollSetupMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPayrollDates = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}/dates`,
        method: 'PUT'
    });
};
export const getPutPayrollDatesMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return putPayrollDates(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollDates = (options)=>{
    const mutationOptions = getPutPayrollDatesMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPayrollSetupDisconnection = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}/disconnect`,
        method: 'POST'
    });
};
export const getPostPayrollSetupDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return postPayrollSetupDisconnection(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollSetupDisconnection = (options)=>{
    const mutationOptions = getPostPayrollSetupDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPayrollSetupInfo = (payrollSetupId)=>{
    return client({
        url: `/api/sponsor/payroll/setup/${payrollSetupId}/info`,
        method: 'PUT'
    });
};
export const getPutPayrollSetupInfoMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { payrollSetupId } = props ?? {};
        return putPayrollSetupInfo(payrollSetupId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPayrollSetupInfo = (options)=>{
    const mutationOptions = getPutPayrollSetupInfoMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPayrollValidations = ()=>{
    return client({
        url: `/api/sponsor/payroll/validate`,
        method: 'POST'
    });
};
export const getPostPayrollValidationsMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postPayrollValidations();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPayrollValidations = (options)=>{
    const mutationOptions = getPostPayrollValidationsMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanFeatures = (params, signal)=>{
    return client({
        url: `/api/sponsor/plan-features`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanFeaturesQueryKey = (params)=>{
    return [
        `/api/sponsor/plan-features`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanFeaturesQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanFeaturesQueryKey(params);
    const queryFn = ({ signal })=>getPlanFeatures(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanFeatures = (params, options)=>{
    const queryOptions = getGetPlanFeaturesQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanOnboardingStatus = (signal)=>{
    return client({
        url: `/api/sponsor/plan/onboarding/status`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOnboardingStatusQueryKey = ()=>{
    return [
        `/api/sponsor/plan/onboarding/status`
    ];
};
export const getGetPlanOnboardingStatusQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOnboardingStatusQueryKey();
    const queryFn = ({ signal })=>getPlanOnboardingStatus(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOnboardingStatus = (options)=>{
    const queryOptions = getGetPlanOnboardingStatusQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postSponsorPlanDisconnection = (planId)=>{
    return client({
        url: `/api/sponsor/plan/${planId}/disconnect`,
        method: 'POST'
    });
};
export const getPostSponsorPlanDisconnectionMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { planId } = props ?? {};
        return postSponsorPlanDisconnection(planId);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostSponsorPlanDisconnection = (options)=>{
    const mutationOptions = getPostSponsorPlanDisconnectionMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanConfiguration = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/configuration`,
        method: 'GET',
        signal
    });
};
export const getGetPlanConfigurationQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/configuration`
    ];
};
export const getGetPlanConfigurationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanConfigurationQueryKey();
    const queryFn = ({ signal })=>getPlanConfiguration(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanConfiguration = (options)=>{
    const queryOptions = getGetPlanConfigurationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanConfiguration = (putPlanConfigurationBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/configuration`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanConfigurationBodyDto
    });
};
export const getPutPlanConfigurationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanConfiguration(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanConfiguration = (options)=>{
    const mutationOptions = getPutPlanConfigurationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanGrossCompensation = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation`,
        method: 'GET',
        signal
    });
};
export const getGetPlanGrossCompensationQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/gross-compensation`
    ];
};
export const getGetPlanGrossCompensationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanGrossCompensationQueryKey();
    const queryFn = ({ signal })=>getPlanGrossCompensation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanGrossCompensation = (options)=>{
    const queryOptions = getGetPlanGrossCompensationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanEmployeeGrossCompensation = (putPlanGrossCompensationBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanGrossCompensationBodyDto
    });
};
export const getPutPlanEmployeeGrossCompensationMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanEmployeeGrossCompensation(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanEmployeeGrossCompensation = (options)=>{
    const mutationOptions = getPutPlanEmployeeGrossCompensationMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getGrossCompensationTemplate = (params, signal)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation/download/template`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetGrossCompensationTemplateQueryKey = (params)=>{
    return [
        `/api/sponsor/pocet/gross-compensation/download/template`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetGrossCompensationTemplateQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetGrossCompensationTemplateQueryKey(params);
    const queryFn = ({ signal })=>getGrossCompensationTemplate(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetGrossCompensationTemplate = (params, options)=>{
    const queryOptions = getGetGrossCompensationTemplateQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPlanEmployeeGrossCompensationUpload = (postPlanGrossCompensationUploadBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/gross-compensation/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanGrossCompensationUploadBodyDto
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanEmployeeGrossCompensationUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEmployeeGrossCompensationUpload = (options)=>{
    const mutationOptions = getPostPlanEmployeeGrossCompensationUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postPlanNonEmployeeOwner = (postPlanNonEmployeeOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/non-employee-owner`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanNonEmployeeOwnerBodyDto
    });
};
export const getPostPlanNonEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanNonEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanNonEmployeeOwner = (options)=>{
    const mutationOptions = getPostPlanNonEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOfficers = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/officers`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOfficersQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/officers`
    ];
};
export const getGetPlanOfficersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOfficersQueryKey();
    const queryFn = ({ signal })=>getPlanOfficers(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOfficers = (options)=>{
    const queryOptions = getGetPlanOfficersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanOfficerStatus = (putPlanOfficersBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/officers`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanOfficersBodyDto
    });
};
export const getPutPlanOfficerStatusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanOfficerStatus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanOfficerStatus = (options)=>{
    const mutationOptions = getPutPlanOfficerStatusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePlanOwner = (deletePlanOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlanOwnerBodyDto
    });
};
export const getDeletePlanOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deletePlanOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlanOwner = (options)=>{
    const mutationOptions = getDeletePlanOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOwners = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'GET',
        signal
    });
};
export const getGetPlanOwnersQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/owners`
    ];
};
export const getGetPlanOwnersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOwnersQueryKey();
    const queryFn = ({ signal })=>getPlanOwners(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOwners = (options)=>{
    const queryOptions = getGetPlanOwnersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPlanEmployeeOwner = (postPlanEmployeeOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postPlanEmployeeOwnerBodyDto
    });
};
export const getPostPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPostPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const putPlanEmployeeOwner = (putPlanEmployeeOwnerBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanEmployeeOwnerBodyDto
    });
};
export const getPutPlanEmployeeOwnerMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanEmployeeOwner(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanEmployeeOwner = (options)=>{
    const mutationOptions = getPutPlanEmployeeOwnerMutationOptions(options);
    return useMutation(mutationOptions);
};
export const deletePlanOwnersFamily = (deletePlanOwnersFamilyBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners-family`,
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json'
        },
        data: deletePlanOwnersFamilyBodyDto
    });
};
export const getDeletePlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return deletePlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const useDeletePlanOwnersFamily = (options)=>{
    const mutationOptions = getDeletePlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPlanOwnersFamily = (params, signal)=>{
    return client({
        url: `/api/sponsor/pocet/owners-family`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanOwnersFamilyQueryKey = (params)=>{
    return [
        `/api/sponsor/pocet/owners-family`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanOwnersFamilyQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanOwnersFamilyQueryKey(params);
    const queryFn = ({ signal })=>getPlanOwnersFamily(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanOwnersFamily = (params, options)=>{
    const queryOptions = getGetPlanOwnersFamilyQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const putPlanOwnersFamily = (putPlanOwnersFamilyBodyDto)=>{
    return client({
        url: `/api/sponsor/pocet/owners-family`,
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        data: putPlanOwnersFamilyBodyDto
    });
};
export const getPutPlanOwnersFamilyMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return putPlanOwnersFamily(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePutPlanOwnersFamily = (options)=>{
    const mutationOptions = getPutPlanOwnersFamilyMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getTrackerDetails = (signal)=>{
    return client({
        url: `/api/sponsor/pocet/tracker`,
        method: 'GET',
        signal
    });
};
export const getGetTrackerDetailsQueryKey = ()=>{
    return [
        `/api/sponsor/pocet/tracker`
    ];
};
export const getGetTrackerDetailsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetTrackerDetailsQueryKey();
    const queryFn = ({ signal })=>getTrackerDetails(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetTrackerDetails = (options)=>{
    const queryOptions = getGetTrackerDetailsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postPriorProvider = ()=>{
    return client({
        url: `/api/sponsor/prior-provider`,
        method: 'POST'
    });
};
export const getPostPriorProviderMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = ()=>{
        return postPriorProvider();
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostPriorProvider = (options)=>{
    const mutationOptions = getPostPriorProviderMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getPriorProviders = (signal)=>{
    return client({
        url: `/api/sponsor/prior-providers`,
        method: 'GET',
        signal
    });
};
export const getGetPriorProvidersQueryKey = ()=>{
    return [
        `/api/sponsor/prior-providers`
    ];
};
export const getGetPriorProvidersQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPriorProvidersQueryKey();
    const queryFn = ({ signal })=>getPriorProviders(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPriorProviders = (options)=>{
    const queryOptions = getGetPriorProvidersQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorQuestionnaire = (signal)=>{
    return client({
        url: `/api/sponsor/questionnaire`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorQuestionnaireQueryKey = ()=>{
    return [
        `/api/sponsor/questionnaire`
    ];
};
export const getGetSponsorQuestionnaireQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorQuestionnaireQueryKey();
    const queryFn = ({ signal })=>getSponsorQuestionnaire(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSponsorQuestionnaire = (options)=>{
    const queryOptions = getGetSponsorQuestionnaireQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const patchSponsorQuestionnaire = (patchSponsorQuestionnaireDto)=>{
    return client({
        url: `/api/sponsor/questionnaire`,
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json'
        },
        data: patchSponsorQuestionnaireDto
    });
};
export const getPatchSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return patchSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePatchSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPatchSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getQuestionnaireInformation = (signal)=>{
    return client({
        url: `/api/sponsor/questionnaire-information`,
        method: 'GET',
        signal
    });
};
export const getGetQuestionnaireInformationQueryKey = ()=>{
    return [
        `/api/sponsor/questionnaire-information`
    ];
};
export const getGetQuestionnaireInformationQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetQuestionnaireInformationQueryKey();
    const queryFn = ({ signal })=>getQuestionnaireInformation(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetQuestionnaireInformation = (options)=>{
    const queryOptions = getGetQuestionnaireInformationQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getContributions = (signal)=>{
    return client({
        url: `/api/sponsor/sponsor-plan/contributions`,
        method: 'GET',
        signal
    });
};
export const getGetContributionsQueryKey = ()=>{
    return [
        `/api/sponsor/sponsor-plan/contributions`
    ];
};
export const getGetContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetContributionsQueryKey();
    const queryFn = ({ signal })=>getContributions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetContributions = (options)=>{
    const queryOptions = getGetContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaPlanDetails = (params, signal)=>{
    return client({
        url: `/api/sponsor/suba-plan-details`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaPlanDetailsQueryKey = (params)=>{
    return [
        `/api/sponsor/suba-plan-details`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaPlanDetailsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaPlanDetailsQueryKey(params);
    const queryFn = ({ signal })=>getSubaPlanDetails(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaPlanDetails = (params, options)=>{
    const queryOptions = getGetSubaPlanDetailsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSubaTransactions = (params, signal)=>{
    return client({
        url: `/api/sponsor/suba-transactions`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetSubaTransactionsQueryKey = (params)=>{
    return [
        `/api/sponsor/suba-transactions`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetSubaTransactionsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSubaTransactionsQueryKey(params);
    const queryFn = ({ signal })=>getSubaTransactions(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetSubaTransactions = (params, options)=>{
    const queryOptions = getGetSubaTransactionsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postYetCensusAutosave = (postYetCensusAutosaveBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/autosave`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postYetCensusAutosaveBodyDto
    });
};
export const getPostYetCensusAutosaveMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusAutosave(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusAutosave = (options)=>{
    const mutationOptions = getPostYetCensusAutosaveMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetCensusDataDownload = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/census/download`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetCensusDataDownloadQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/census/download`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetCensusDataDownloadQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetCensusDataDownloadQueryKey(params);
    const queryFn = ({ signal })=>getYetCensusDataDownload(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetCensusDataDownload = (params, options)=>{
    const queryOptions = getGetYetCensusDataDownloadQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYetCensusDataPaged = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/census/paged`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetCensusDataPagedQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/census/paged`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetCensusDataPagedQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetCensusDataPagedQueryKey(params);
    const queryFn = ({ signal })=>getYetCensusDataPaged(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetCensusDataPaged = (params, options)=>{
    const queryOptions = getGetYetCensusDataPagedQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postRestartCensus = (postRestartCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/restart`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRestartCensusBodyDto
    });
};
export const getPostRestartCensusMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRestartCensus(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRestartCensus = (options)=>{
    const mutationOptions = getPostRestartCensusMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postYetCensusStart = (yetCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/start`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetCensusBodyDto
    });
};
export const getPostYetCensusStartMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusStart(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusStart = (options)=>{
    const mutationOptions = getPostYetCensusStartMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getCensusStatus = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/census/status`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetCensusStatusQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/census/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetCensusStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetCensusStatusQueryKey(params);
    const queryFn = ({ signal })=>getCensusStatus(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetCensusStatus = (params, options)=>{
    const queryOptions = getGetCensusStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postYetCensusSubmit = (yetCensusBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/submit`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetCensusBodyDto
    });
};
export const getPostYetCensusSubmitMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusSubmit(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusSubmit = (options)=>{
    const mutationOptions = getPostYetCensusSubmitMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postYetCensusUpload = (postYetCensusUploadBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/census/upload`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postYetCensusUploadBodyDto
    });
};
export const getPostYetCensusUploadMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetCensusUpload(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetCensusUpload = (options)=>{
    const mutationOptions = getPostYetCensusUploadMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetChecklist = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/checklist`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetChecklistQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/checklist`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetChecklistQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetChecklistQueryKey(params);
    const queryFn = ({ signal })=>getYetChecklist(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetChecklist = (params, options)=>{
    const queryOptions = getGetYetChecklistQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYetConfig = (signal)=>{
    return client({
        url: `/api/sponsor/yet/config`,
        method: 'GET',
        signal
    });
};
export const getGetYetConfigQueryKey = ()=>{
    return [
        `/api/sponsor/yet/config`
    ];
};
export const getGetYetConfigQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetConfigQueryKey();
    const queryFn = ({ signal })=>getYetConfig(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetConfig = (options)=>{
    const queryOptions = getGetYetConfigQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postContributionsFund = (yetDocumentIdBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/contributions/fund`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetDocumentIdBodyDto
    });
};
export const getPostContributionsFundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postContributionsFund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionsFund = (options)=>{
    const mutationOptions = getPostContributionsFundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postContributionsRefund = (yetDocumentIdBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/contributions/refund`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: yetDocumentIdBodyDto
    });
};
export const getPostContributionsRefundMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postContributionsRefund(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostContributionsRefund = (options)=>{
    const mutationOptions = getPostContributionsRefundMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetDocuments = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/documents`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetDocumentsQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/documents`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetDocumentsQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetDocumentsQueryKey(params);
    const queryFn = ({ signal })=>getYetDocuments(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetDocuments = (params, options)=>{
    const queryOptions = getGetYetDocumentsQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postStartOfPackaging = (getYetChecklistQueryDto)=>{
    return client({
        url: `/api/sponsor/yet/packaging/start`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: getYetChecklistQueryDto
    });
};
export const getPostStartOfPackagingMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postStartOfPackaging(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostStartOfPackaging = (options)=>{
    const mutationOptions = getPostStartOfPackagingMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetSponsorQuestionnaire = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/questionnaire`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetSponsorQuestionnaireQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/questionnaire`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetSponsorQuestionnaireQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetSponsorQuestionnaireQueryKey(params);
    const queryFn = ({ signal })=>getYetSponsorQuestionnaire(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetSponsorQuestionnaire = (params, options)=>{
    const queryOptions = getGetYetSponsorQuestionnaireQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postYetSponsorQuestionnaire = (postYetQuestionnaireDto)=>{
    return client({
        url: `/api/sponsor/yet/questionnaire`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postYetQuestionnaireDto
    });
};
export const getPostYetSponsorQuestionnaireMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postYetSponsorQuestionnaire(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostYetSponsorQuestionnaire = (options)=>{
    const mutationOptions = getPostYetSponsorQuestionnaireMutationOptions(options);
    return useMutation(mutationOptions);
};
export const postRestartTestingProcess = (postRestartTestingProcessBodyDto)=>{
    return client({
        url: `/api/sponsor/yet/restart`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postRestartTestingProcessBodyDto
    });
};
export const getPostRestartTestingProcessMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postRestartTestingProcess(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostRestartTestingProcess = (options)=>{
    const mutationOptions = getPostRestartTestingProcessMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getYetStatus = (params, signal)=>{
    return client({
        url: `/api/sponsor/yet/status`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetYetStatusQueryKey = (params)=>{
    return [
        `/api/sponsor/yet/status`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetYetStatusQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetStatusQueryKey(params);
    const queryFn = ({ signal })=>getYetStatus(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetStatus = (params, options)=>{
    const queryOptions = getGetYetStatusQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYtdContributions = (signal)=>{
    return client({
        url: `/api/sponsor/ytd-contributions`,
        method: 'GET',
        signal
    });
};
export const getGetYtdContributionsQueryKey = ()=>{
    return [
        `/api/sponsor/ytd-contributions`
    ];
};
export const getGetYtdContributionsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYtdContributionsQueryKey();
    const queryFn = ({ signal })=>getYtdContributions(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYtdContributions = (options)=>{
    const queryOptions = getGetYtdContributionsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getSponsorDigitalOnboarding = (sponsorId, signal)=>{
    return client({
        url: `/api/sponsor/${sponsorId}/digital-onboarding`,
        method: 'GET',
        signal
    });
};
export const getGetSponsorDigitalOnboardingQueryKey = (sponsorId)=>{
    return [
        `/api/sponsor/${sponsorId}/digital-onboarding`
    ];
};
export const getGetSponsorDigitalOnboardingQueryOptions = (sponsorId, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetSponsorDigitalOnboardingQueryKey(sponsorId);
    const queryFn = ({ signal })=>getSponsorDigitalOnboarding(sponsorId, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!sponsorId,
        ...queryOptions
    };
};
export const useGetSponsorDigitalOnboarding = (sponsorId, options)=>{
    const queryOptions = getGetSponsorDigitalOnboardingQueryOptions(sponsorId, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getPlanByIdV2 = (params, signal)=>{
    return client({
        url: `/api/v2/plans`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetPlanByIdV2QueryKey = (params)=>{
    return [
        `/api/v2/plans`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetPlanByIdV2QueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetPlanByIdV2QueryKey(params);
    const queryFn = ({ signal })=>getPlanByIdV2(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetPlanByIdV2 = (params, options)=>{
    const queryOptions = getGetPlanByIdV2QueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getWhiteLabel = (signal)=>{
    return client({
        url: `/api/whitelabel`,
        method: 'GET',
        signal
    });
};
export const getGetWhiteLabelQueryKey = ()=>{
    return [
        `/api/whitelabel`
    ];
};
export const getGetWhiteLabelQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWhiteLabelQueryKey();
    const queryFn = ({ signal })=>getWhiteLabel(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWhiteLabel = (options)=>{
    const queryOptions = getGetWhiteLabelQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const postCreateWithdrawal = (postWithdrawalBodyDto)=>{
    return client({
        url: `/api/withdrawal`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        data: postWithdrawalBodyDto
    });
};
export const getPostCreateWithdrawalMutationOptions = (options)=>{
    const { mutation: mutationOptions } = options ?? {};
    const mutationFn = (props)=>{
        const { data } = props ?? {};
        return postCreateWithdrawal(data);
    };
    return {
        mutationFn,
        ...mutationOptions
    };
};
export const usePostCreateWithdrawal = (options)=>{
    const mutationOptions = getPostCreateWithdrawalMutationOptions(options);
    return useMutation(mutationOptions);
};
export const getRmdAmount = (params, signal)=>{
    return client({
        url: `/api/withdrawal/rmd-amount`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRmdAmountQueryKey = (params)=>{
    return [
        `/api/withdrawal/rmd-amount`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRmdAmountQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRmdAmountQueryKey(params);
    const queryFn = ({ signal })=>getRmdAmount(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRmdAmount = (params, options)=>{
    const queryOptions = getGetRmdAmountQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getRmdBalance = (params, signal)=>{
    return client({
        url: `/api/withdrawal/rmd-balance`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetRmdBalanceQueryKey = (params)=>{
    return [
        `/api/withdrawal/rmd-balance`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetRmdBalanceQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetRmdBalanceQueryKey(params);
    const queryFn = ({ signal })=>getRmdBalance(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetRmdBalance = (params, options)=>{
    const queryOptions = getGetRmdBalanceQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getWithholding = (params, signal)=>{
    return client({
        url: `/api/withdrawal/withholding`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetWithholdingQueryKey = (params)=>{
    return [
        `/api/withdrawal/withholding`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetWithholdingQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWithholdingQueryKey(params);
    const queryFn = ({ signal })=>getWithholding(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWithholding = (params, options)=>{
    const queryOptions = getGetWithholdingQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getWithholdingDetail = (params, signal)=>{
    return client({
        url: `/api/withdrawal/withholding/total-estimate`,
        method: 'GET',
        params,
        signal
    });
};
export const getGetWithholdingDetailQueryKey = (params)=>{
    return [
        `/api/withdrawal/withholding/total-estimate`,
        ...params ? [
            params
        ] : []
    ];
};
export const getGetWithholdingDetailQueryOptions = (params, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetWithholdingDetailQueryKey(params);
    const queryFn = ({ signal })=>getWithholdingDetail(params, signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetWithholdingDetail = (params, options)=>{
    const queryOptions = getGetWithholdingDetailQueryOptions(params, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getYetNaics = (signal)=>{
    return client({
        url: `/api/yet/naics`,
        method: 'GET',
        signal
    });
};
export const getGetYetNaicsQueryKey = ()=>{
    return [
        `/api/yet/naics`
    ];
};
export const getGetYetNaicsQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetYetNaicsQueryKey();
    const queryFn = ({ signal })=>getYetNaics(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetYetNaics = (options)=>{
    const queryOptions = getGetYetNaicsQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getZendeskJwt = (signal)=>{
    return client({
        url: `/api/zendesk/jwt`,
        method: 'GET',
        signal
    });
};
export const getGetZendeskJwtQueryKey = ()=>{
    return [
        `/api/zendesk/jwt`
    ];
};
export const getGetZendeskJwtQueryOptions = (options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetZendeskJwtQueryKey();
    const queryFn = ({ signal })=>getZendeskJwt(signal);
    return {
        queryKey,
        queryFn,
        ...queryOptions
    };
};
export const useGetZendeskJwt = (options)=>{
    const queryOptions = getGetZendeskJwtQueryOptions(options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getEntitySession = (entity, signal)=>{
    return client({
        url: `/api/${entity}/session`,
        method: 'GET',
        signal
    });
};
export const getGetEntitySessionQueryKey = (entity)=>{
    return [
        `/api/${entity}/session`
    ];
};
export const getGetEntitySessionQueryOptions = (entity, options)=>{
    const { query: queryOptions } = options ?? {};
    const queryKey = queryOptions?.queryKey ?? getGetEntitySessionQueryKey(entity);
    const queryFn = ({ signal })=>getEntitySession(entity, signal);
    return {
        queryKey,
        queryFn,
        enabled: !!entity,
        ...queryOptions
    };
};
export const useGetEntitySession = (entity, options)=>{
    const queryOptions = getGetEntitySessionQueryOptions(entity, options);
    const query = useQuery(queryOptions);
    query.queryKey = queryOptions.queryKey;
    return query;
};
export const getGetAdvisorByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.word.sample(),
        firmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firstName: faker.word.sample(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        lastName: faker.word.sample(),
        phone: faker.word.sample(),
        ...overrideResponse
    });
export const getGetAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getPutAdvisorContactCardResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        displayName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        image: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isEnabled: faker.datatype.boolean(),
        note: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        ...overrideResponse
    });
export const getGetPlansResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    effectiveDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    eligibleParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    employeeBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    employerBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    forfeitureBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    hasPriorLoans: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    inboundBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    inboundBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isBlackout: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    isOffboardingBlackoutActive: faker.helpers.arrayElement([
                        faker.datatype.boolean(),
                        undefined
                    ]),
                    loanBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutEndDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    offboardingBlackoutStartDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    participantsWithBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    participantsWithDeferrals: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    readyToEnrollParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    recordkeeper: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    registeredParticipants: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    rolloverBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    sponsorCompanyName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    statefulSchemaTrackingState: faker.helpers.arrayElement([
                        {
                            attributes: faker.helpers.arrayElement([
                                {
                                    createdAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    status: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    updatedAt: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    status: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    totalBalance: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    type: faker.helpers.arrayElement([
                        {},
                        undefined
                    ])
                },
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                relationships: {
                    advisor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    firm: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    program: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    sponsor: faker.helpers.arrayElement([
                        {
                            data: faker.helpers.arrayElement([
                                {
                                    id: faker.helpers.arrayElement([
                                        faker.number.int({
                                            min: undefined,
                                            max: undefined
                                        }),
                                        undefined
                                    ]),
                                    name: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ]),
                                    type: faker.helpers.arrayElement([
                                        faker.word.sample(),
                                        undefined
                                    ])
                                },
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    tpa: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                data: faker.helpers.arrayElement([
                                    {
                                        id: faker.helpers.arrayElement([
                                            faker.number.int({
                                                min: undefined,
                                                max: undefined
                                            }),
                                            undefined
                                        ]),
                                        name: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        type: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    },
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                }
            })),
        ...overrideResponse
    });
export const getGetPlanEmployeesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetAdvisorByIdStatsResponseMock = (overrideResponse = {})=>({
        eligibleParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalPlans: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetCarouselResponseMock = (overrideResponse = {})=>({
        esaItems: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        items: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    alt: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    path: faker.word.sample(),
                    pdf: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetConnectivityResponseMock = (overrideResponse = {})=>({
        details: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        error: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        info: faker.helpers.arrayElement([
            {
                [faker.string.alphanumeric(5)]: {
                    status: faker.word.sample()
                }
            },
            undefined
        ]),
        status: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetCsmResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        csmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        email: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        name: faker.word.sample(),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetLoginDisclosureResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        ...overrideResponse
    });
export const getGetLoginDisclosureAgreementResponseMock = (overrideResponse = {})=>({
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetAllDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            uploadPath: faker.word.sample()
        }));
export const getGetDocumentAgreementResponseMock = (overrideResponse = {})=>({
        date: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isAccepted: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlResponseMock = (overrideResponse = {})=>({
        document: faker.word.sample(),
        documentId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        originalFileName: faker.word.sample(),
        ...overrideResponse
    });
export const getGetDocumentAsHtmlAndDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getPostPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetProgramModelSecuritiesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            assetAllocations: faker.helpers.arrayElement([
                {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            assetClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            broadCategory: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            category: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cusip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expenseRatioPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fi360FactsheetPath: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            fiveYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiveYearPerformancePct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            inceptionDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            itdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            itdPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            oneYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            oneYearPerformancePct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            performanceUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            securityTypeName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            shareClass: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            targetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tenYearPerformancePct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ticker: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            weightPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdBenchmarkPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ytdPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getGetEsaParticipantGoalsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            goalAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            priority: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getGetEsaParticipantIncentivesResponseMock = (overrideResponse = {})=>({
        employerMatch: {
            dollarCap: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lifetimeCap: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        initialBonusAmount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        initialBonusMinimum: faker.number.int({
            min: undefined,
            max: undefined
        }),
        milestoneBonus: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                bonusAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bonusThreshold: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getGetEsaPlanCashInterestRateResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            cashInterestProgramId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            effectiveStartDate: faker.word.sample(),
            rate: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEsaPlanGroupBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getGetEsaPlanGroupStatsResponseMock = (overrideResponse = {})=>({
        averageSavingsRateDollars: faker.number.int({
            min: undefined,
            max: undefined
        }),
        averageSavingsRatePct: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsAccessingSavings: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participatingParticipantsNumber: faker.number.int({
            min: undefined,
            max: undefined
        }),
        savingsRateDollarsParticipantsCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        savingsRatePctParticipantsCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalParticipantsNumber: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetEsaPlanGroupsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            description: faker.word.sample(),
            groupId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonus: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusThreshold: faker.number.int({
                min: undefined,
                max: undefined
            }),
            match: {
                dollarAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                lifetimeAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                percent: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            milestoneBonus: {
                amount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                threshold: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            name: faker.word.sample(),
            participantCount: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetEsaPlanIncentivesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            allowInitialBonus: faker.datatype.boolean(),
            allowMatch: faker.datatype.boolean(),
            allowMilestoneBonus: faker.datatype.boolean(),
            bonusAmount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            bonusThreshold: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            dollarCap: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employeeGroupId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            initialBonusMinimum: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lifetimeCap: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        }));
export const getPostSponsorExemptionReasonResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetFeatureTogglesResponseMock = ()=>({
        [faker.string.alphanumeric(5)]: faker.datatype.boolean()
    });
export const getGetFeatureTogglesListResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            isExperiment: faker.datatype.boolean(),
            name: faker.word.sample(),
            variation: faker.helpers.arrayElement([
                {
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    name: faker.word.sample()
                },
                undefined
            ])
        }));
export const getGetFirmByIdResponseMock = (overrideResponse = {})=>({
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firmId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firmType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        phoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        website: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetLoanAmortizationPdfResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetManagedAccountsPlaidTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        ...overrideResponse
    });
export const getDeleteManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidLinksResponseMock = (overrideResponse = {})=>({
        links: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                availableBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                bankAccountName: faker.word.sample(),
                currentBalance: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                id: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                plaidAccountType: faker.word.sample(),
                updatedAt: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getPostManagedAccountsPlaidBalancesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            availableBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            currentBalance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            institutionId: faker.word.sample(),
            itemId: faker.word.sample(),
            plaidAccountId: faker.word.sample(),
            plaidAccountSubtype: faker.word.sample(),
            plaidAccountType: faker.word.sample()
        }));
export const getGetModelPerformanceResponseMock = (overrideResponse = {})=>({
        expenseRatio: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        fiveYearReturn: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        inceptionDate: faker.word.sample(),
        inceptionToDateReturn: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        modelId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        oneYearReturn: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        tenYearReturn: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        yearToDateReturn: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantByIdResponseMock = (overrideResponse = {})=>({
        accountId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        activationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        addressUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        afterTaxContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        afterTaxContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        autorebalance: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contactInformation: {
            address: {
                address1: faker.word.sample(),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.word.sample(),
                country: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.word.sample(),
                zip: faker.word.sample()
            },
            mailingAddress: faker.helpers.arrayElement([
                {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                undefined
            ]),
            personalEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            physicalSameAsMailing: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            workEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        contributesToRoth: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contributions: faker.helpers.arrayElement([
            {
                irsLimit: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        createdAt: faker.word.sample(),
        dateOfTermination: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferralChanged: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        deferralElections: {
            afterTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            afterTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            preTaxAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            preTaxType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rothAmt: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        eligibility: faker.helpers.arrayElement([
            {
                ageRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                entryDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isLtpt: faker.datatype.boolean(),
                isOverride: faker.datatype.boolean(),
                overrideNotes: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                serviceRequirementDetail: faker.helpers.arrayElement([
                    {
                        isMet: faker.datatype.boolean()
                    },
                    undefined
                ]),
                status: faker.word.sample()
            },
            undefined
        ]),
        emailUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employeeStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employmentStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        esaGroupId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        esaGroupName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        externalId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        gender: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inRmdAge: faker.datatype.boolean(),
        isDeceased: faker.datatype.boolean(),
        isDisabled: faker.datatype.boolean(),
        isVerified: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        maritalStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        middleName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        model: faker.helpers.arrayElement([
            {
                modelId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                modelName: faker.word.sample(),
                modelType: faker.word.sample(),
                modelViewName: faker.word.sample()
            },
            undefined
        ]),
        nameUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        onboardingWizardCompletedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        password: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        registeredOn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        rehireDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        savesForRetirement: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sendEmailUpdate: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        sponsorId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ssn: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraAccountStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraCipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        stateIraPerEmployerStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        updatedAt: faker.word.sample(),
        updatedBy: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        yearsToRetire: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantAccountBalanceByIdResponseMock = (overrideResponse = {})=>({
        employeeBalance: {
            afterTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            roth: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        employerBalance: {
            match: faker.number.int({
                min: undefined,
                max: undefined
            }),
            profitSharing: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        loanBalance: {
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        rolloverBalance: {
            preTax: faker.number.int({
                min: undefined,
                max: undefined
            }),
            roth: faker.number.int({
                min: undefined,
                max: undefined
            }),
            total: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        updatedOn: faker.word.sample(),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinkTokenResponseMock = (overrideResponse = {})=>({
        linkToken: faker.word.sample(),
        verificationStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantPlaidLinksResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            attributes: faker.helpers.arrayElement([
                {
                    accountNumber: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    accountVerificationStatus: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    bankAccountName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    holdReason: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    institutionName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    plaidMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    routingNumberMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    wireRoutingMask: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            id: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getPostParticipantPlaidLinksResponseMock = (overrideResponse = {})=>({
        attributes: faker.helpers.arrayElement([
            {
                accountNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                accountVerificationStatus: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                bankAccountName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                holdReason: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                institutionName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                plaidMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                routingNumberMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                wireRoutingMask: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantAccountsResponseMock = (overrideResponse = {})=>({
        data: faker.helpers.arrayElement([
            {
                attributes: faker.helpers.arrayElement([
                    {
                        code: faker.word.sample(),
                        source: faker.word.sample(),
                        tax: faker.word.sample()
                    },
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                type: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        stats: faker.helpers.arrayElement([
            {
                allocations: faker.helpers.arrayElement([
                    {
                        assetClass: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        cusip: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        fundName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        targetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        ticker: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                balance: faker.helpers.arrayElement([
                    {
                        afterTax: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employee: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        employer: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        loan: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        preTax: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        profitSharing: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        rollover: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        roth: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        total: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                vesting: faker.helpers.arrayElement([
                    {
                        blendedNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        blendedVariablePct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        EMNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        EMVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        PSNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        PSVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHMNotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHMVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHNENotVested: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        QSHNEVestedPct: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        total: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        vestedTotal: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantBalanceOverTimeResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            balance: faker.number.int({
                min: undefined,
                max: undefined
            }),
            dateOf: faker.word.sample()
        }));
export const getGetParticipantBankAccountsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            accountName: faker.word.sample(),
            accountNumberMasked: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            plaidMask: faker.word.sample(),
            routingNumberMasked: faker.word.sample()
        }));
export const getGetBeneficiariesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            allocationPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            beneficiaryType: faker.helpers.arrayElement([
                'person',
                'trust',
                'organization'
            ]),
            businessName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ein: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            email: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            holdingFinancialInstitution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isPrimary: faker.datatype.boolean(),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            phoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            relationship: faker.helpers.arrayElement([
                faker.helpers.arrayElement([
                    'spouse',
                    'child',
                    'parent',
                    'other'
                ]),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            trustName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            type: faker.word.sample(),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetParticipantIdentityVerificationResponseMock = (overrideResponse = {})=>({
        beacon: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                updatedAt: faker.word.sample()
            },
            undefined
        ]),
        cipStatus: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        idVerResponse: faker.helpers.arrayElement([
            {
                clientId: faker.word.sample(),
                completedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                createdAt: faker.word.sample(),
                id: faker.word.sample(),
                requestId: faker.word.sample(),
                status: faker.word.sample(),
                steps: {
                    acceptTos: faker.word.sample(),
                    documentaryVerification: faker.word.sample(),
                    kycCheck: faker.word.sample(),
                    riskCheck: faker.word.sample(),
                    selfieCheck: faker.word.sample(),
                    verifySms: faker.word.sample(),
                    watchlistScreening: faker.word.sample()
                },
                token: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                verificationUrl: faker.word.sample()
            },
            undefined
        ]),
        requiredDocUploads: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetGoalFeedbackResponseMock = (overrideResponse = {})=>({
        data: {
            election: {
                age: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                currentGoalProbability: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                goalStrategyAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                outsideAccountsAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                retireAtAge: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                retirementIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                riskProfile: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                saveMorePerMonth: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                socialSecurityAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                spendLess: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                totalProjectedAnnualIncome: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            participant: {
                age: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            portfolio: {
                pieChart: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        label: faker.word.sample(),
                        value: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    })),
                table: Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        allocation: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        assetClass: faker.word.sample(),
                        id: faker.word.sample(),
                        targetAllocations: Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                allocation: faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                assetClass: faker.word.sample(),
                                fundName: faker.word.sample(),
                                id: faker.word.sample(),
                                securityId: faker.word.sample()
                            }))
                    }))
            }
        },
        ...overrideResponse
    });
export const getGetElectionsSetupResponseMock = (overrideResponse = {})=>({
        data: {
            document: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            election: faker.helpers.arrayElement([
                {
                    age: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    ageToDrawSocialSecurity: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    annualIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    retirementIncome: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: {
                currentAge: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            }
        },
        ...overrideResponse
    });
export const getGetInvestmentsModelDisplayResponseMock = (overrideResponse = {})=>({
        benchmarkName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        expenseRatioPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        fi360FactsheetPath: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiveYearBenchmarkPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        fiveYearPerformancePct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        inceptionDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isDefault: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        itdBenchmarkPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        itdPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        metaAssetAllocations: faker.helpers.arrayElement([
            {
                bondNetPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                cashNetPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                otherNetPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stockNetPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        modelBoundaries: faker.helpers.arrayElement([
            {
                riskLevel: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                riskValueHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                riskValueLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                targetRetireYearHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                targetRetireYearLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                yearsToRetireHigh: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                yearsToRetireLow: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            undefined
        ]),
        modelDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelType: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'risk',
                'target',
                'menu',
                'pmenu',
                'goal',
                'ms_rp'
            ]),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        oneYearBenchmarkPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        oneYearPerformancePct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        performanceUpdatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        primaryFiveYearReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        primaryInceptionToDateReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        primaryOneYearReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        primaryTenYearReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        primaryYearToDateReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        prospectusFiveYearReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        prospectusInceptionToDateReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        prospectusOneYearReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        prospectusTenYearReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        prospectusWeight: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        prospectusYearToDateReturnBenchmark: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        securityAllocations: {
            bondNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            cashNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            otherNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stockNetPct: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        symbol: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        tenYearBenchmarkPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        tenYearPerformancePct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        viewName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ytdBenchmarkPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ytdPct: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRebalanceSettingsResponseMock = (overrideResponse = {})=>({
        autoRebalance: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetStrategiesIndexResponseMock = (overrideResponse = {})=>({
        currentlyInUse: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        defaultType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        modelTypes: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
        ...overrideResponse
    });
export const getGetAgeBasedResponseMock = (overrideResponse = {})=>({
        birthDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        models: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                benchmarkName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                inceptionDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isDefault: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelBoundaries: faker.helpers.arrayElement([
                    {
                        riskLevel: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        riskValueHigh: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        riskValueLow: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        targetRetireYearHigh: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        targetRetireYearLow: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        yearsToRetireHigh: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        yearsToRetireLow: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'risk',
                        'target',
                        'menu',
                        'pmenu',
                        'goal',
                        'ms_rp'
                    ]),
                    undefined
                ]),
                name: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                primaryFiveYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryInceptionToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryOneYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryTenYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryYearToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusFiveYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusInceptionToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusOneYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusTenYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusWeight: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusYearToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                symbol: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                viewName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            })),
        participantAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        retirementAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskBasedResponseMock = (overrideResponse = {})=>({
        models: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                benchmarkName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                expenseRatioPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fi360FactsheetPath: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                fiveYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                fiveYearPerformancePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                id: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                inceptionDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                isDefault: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                itdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                itdPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                metaAssetAllocations: faker.helpers.arrayElement([
                    {
                        bondNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        cashNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        otherNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        stockNetPct: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelBoundaries: faker.helpers.arrayElement([
                    {
                        riskLevel: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        riskValueHigh: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        riskValueLow: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        targetRetireYearHigh: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        targetRetireYearLow: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        yearsToRetireHigh: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        yearsToRetireLow: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                modelDescription: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                modelType: faker.helpers.arrayElement([
                    faker.helpers.arrayElement([
                        'risk',
                        'target',
                        'menu',
                        'pmenu',
                        'goal',
                        'ms_rp'
                    ]),
                    undefined
                ]),
                name: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                oneYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                oneYearPerformancePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                performanceUpdatedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                primaryFiveYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryInceptionToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryOneYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryTenYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                primaryYearToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusFiveYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusInceptionToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusOneYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusTenYearReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusWeight: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                prospectusYearToDateReturnBenchmark: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                securityAllocations: {
                    bondNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    cashNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    otherNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    stockNetPct: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ])
                },
                symbol: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tenYearBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                tenYearPerformancePct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                viewName: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                ytdBenchmarkPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                ytdPct: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            })),
        programId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRiskModelQuestionnaireResponseMock = (overrideResponse = {})=>({
        modelId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        name: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        riskValue1High: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskValue1Low: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetMailPreferencesResponseMock = (overrideResponse = {})=>({
        isWiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        paperlessNotices: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantOnboardingResponseMock = (overrideResponse = {})=>({
        autoEnrollAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        contributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        deferInDollars: faker.datatype.boolean(),
        keepExistingRate: faker.datatype.boolean(),
        participantChangedDeferralAt: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                faker.word.sample(),
                null
            ]),
            undefined
        ]),
        rothContribution: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        rothContributionType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborStrategy: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetParticipantRolloverResponseMock = (overrideResponse = {})=>({
        attributes: {
            accountProvider: faker.word.sample(),
            accountType: {},
            createdAt: faker.word.sample(),
            letterDocumentId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            preTaxAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothCostBasis: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothStartDate: faker.word.sample(),
            status: {}
        },
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetSavingsDisplayResponseMock = (overrideResponse = {})=>({
        afterTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        age: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        allowDollarAmounts: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        allowRothDeferrals: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        catchUpLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        employeeLimit: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        preTaxAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        rothAmount: {
            amount: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            type: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        safeHarborMatchType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        safeHarborMatchTypeDescription: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ytdContributions: {
            limit: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            total: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            year: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetParticipantAggregatedByCategoryTransactionsResponseMock = (overrideResponse = {})=>({
        asOfDate: faker.word.sample(),
        transactions: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    amount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    category: faker.word.sample()
                })),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetAllowedWithdrawalReasonsResponseMock = (overrideResponse = {})=>({
        allowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    afterTaxAvailableAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    afterTaxMaxAmount: faker.helpers.arrayElement([
                        faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        undefined
                    ]),
                    disabled: faker.datatype.boolean(),
                    distributionMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                        undefined
                    ]),
                    fee: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    maxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    preTaxAvailableAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    preTaxMaxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    reason: faker.word.sample(),
                    rothAvailableAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    rothMaxAmount: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                })),
            undefined
        ]),
        disallowedReasons: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        fullyVestedPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        fullyVestedRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        overnightCheckFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        totalRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        vestedPreTaxBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        vestedRothBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        wireFee: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsResponseMock = (overrideResponse = {})=>({
        participants: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    emailInfo: faker.helpers.arrayElement([
                        {
                            messageId: faker.word.sample(),
                            sentOn: faker.word.sample(),
                            sentTo: faker.word.sample()
                        },
                        undefined
                    ]),
                    emailType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    firstName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    id: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    lastName: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ssn: faker.word.sample()
                })),
            undefined
        ]),
        totalCount: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetUnregisteredParticipantsCountResponseMock = (overrideResponse = {})=>({
        count: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantWelcomeEmailDownloadResponseMock = ()=>new Blob(faker.helpers.arrayElements(faker.word.words(10).split(' ')));
export const getGetParticipantWelcomeEmailsHistoryResponseMock = (overrideResponse = {})=>({
        firstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        history: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    eventType: faker.word.sample(),
                    messageId: faker.word.sample(),
                    sentOn: faker.word.sample(),
                    sentTo: faker.word.sample()
                })),
            undefined
        ]),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        lastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ssn: faker.word.sample(),
        ...overrideResponse
    });
export const getGetCalculatedEsaEmployerContributionsResponseMock = (overrideResponse = {})=>({
        data: {
            atTotal: faker.number.int({
                min: undefined,
                max: undefined
            }),
            employerMatch: faker.number.int({
                min: undefined,
                max: undefined
            }),
            esaGroupId: faker.word.sample(),
            initialBonus: faker.number.int({
                min: undefined,
                max: undefined
            }),
            milestoneBonusAmount: faker.number.int({
                min: undefined,
                max: undefined
            }),
            milestoneBonusId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            participantId: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        error: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        success: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetPersonasResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            advisorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            company: faker.word.sample(),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firmCompanyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            loginUrl: faker.word.sample(),
            name: faker.word.sample(),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            recordKeeperId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            sponsorId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            type: faker.helpers.arrayElement([
                'advisor',
                'participant',
                'sponsor'
            ]),
            whitelabelId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetProgramFundsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            asOfDate: faker.word.sample(),
            categoryName: faker.word.sample(),
            expenseRatio: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fundId: faker.word.sample(),
            fundName: faker.word.sample(),
            inceptionDate: faker.word.sample(),
            inceptionToDateReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            oneYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryFiveYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryInceptionToDateReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryIndexName: faker.word.sample(),
            primaryOneYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryTenYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryYearToDateReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            programId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusFiveYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusInceptionToDateReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusOneYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusResponse: {
                _id: faker.word.sample(),
                'AAB-BondNet': faker.word.sample(),
                'AAB-CashNet': faker.word.sample(),
                'AAB-ConvertibleNet': faker.word.sample(),
                'AAB-OtherNet': faker.word.sample(),
                'AAB-PreferredNet': faker.word.sample(),
                'AAB-StockNet': faker.word.sample(),
                'ARF-NetExpenseRatio': faker.word.sample(),
                'FB-PrimaryIndexId': faker.word.sample(),
                'FB-PrimaryIndexName': faker.word.sample(),
                'FB-PrimaryProspectusBenchmarks': Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        IndexId: faker.word.sample(),
                        IndexName: faker.word.sample(),
                        Weighting: faker.word.sample()
                    })),
                'FSCBI-BrandingName': faker.word.sample(),
                'FSCBI-BroadAssetClass': faker.word.sample(),
                'FSCBI-BroadCategoryGroup': faker.word.sample(),
                'FSCBI-CategoryName': faker.word.sample(),
                'FSCBI-CUSIP': faker.word.sample(),
                'FSCBI-ExchangeID': faker.word.sample(),
                'FSCBI-FundId': faker.word.sample(),
                'FSCBI-FundName': faker.word.sample(),
                'FSCBI-FundStandardName': faker.word.sample(),
                'FSCBI-InceptionDate': faker.word.sample(),
                'FSCBI-LegalName': faker.word.sample(),
                'FSCBI-MorningstarIndexId': faker.word.sample(),
                'FSCBI-MorningstarIndexName': faker.word.sample(),
                'FSCBI-MStarID': faker.word.sample(),
                'FSCBI-ProviderCompanyID': faker.word.sample(),
                'FSCBI-ProviderCompanyName': faker.word.sample(),
                'FSCBI-SecurityType': faker.word.sample(),
                'FSCBI-Ticker': faker.word.sample(),
                'PF-NetExpenseRatio': faker.word.sample()
            },
            prospectusTenYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusUrl: faker.word.sample(),
            prospectusWeight: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusYearToDateReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            securityId: faker.word.sample(),
            securityType: faker.word.sample(),
            symbol: faker.word.sample(),
            tenYearReturn: faker.number.int({
                min: undefined,
                max: undefined
            }),
            yearToDateReturn: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetProgramModelsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            asOfDate: faker.word.sample(),
            benchmarkName: faker.word.sample(),
            expenseRatioPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fi360FactsheetPath: faker.word.sample(),
            fiveYearBenchmarkPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            fiveYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            inceptionDate: faker.word.sample(),
            isDefault: faker.datatype.boolean(),
            itdBenchmarkPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            itdPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            metaAssetAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            modelBoundaries: {},
            modelDescription: faker.word.sample(),
            modelType: {},
            name: faker.word.sample(),
            oneYearBenchmarkPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            oneYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            performanceUpdatedAt: faker.word.sample(),
            primaryFiveYearReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryInceptionToDateReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryOneYearReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryTenYearReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            primaryYearToDateReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusFiveYearReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusInceptionToDateReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusOneYearReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusTenYearReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusWeight: faker.number.int({
                min: undefined,
                max: undefined
            }),
            prospectusYearToDateReturnBenchmark: faker.number.int({
                min: undefined,
                max: undefined
            }),
            securityAllocations: {
                bondNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                cashNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                otherNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                stockNetPct: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            },
            symbol: faker.word.sample(),
            tenYearBenchmarkPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tenYearPerformancePct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            type: faker.word.sample(),
            viewName: faker.word.sample(),
            ytdBenchmarkPct: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ytdPct: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetParticipantAddressOptionsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, ()=>faker.word.sample());
export const getPostParticipantAddressVerifyResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostAdvisorConnectResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        matched: faker.datatype.boolean(),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostAdvisorPasswordResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        matched: faker.datatype.boolean(),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostAdvisorVerifyResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        matched: faker.datatype.boolean(),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetParticipantCompanyOptionsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, ()=>faker.word.sample());
export const getPostParticipantCompanyVerifyResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchParticipantContactResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRegistrationContactResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        addressVerified: faker.datatype.boolean(),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        companyVerified: faker.datatype.boolean(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorVerifyResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostSponsorAccessCodeRequestResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.word.sample(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        matched: faker.datatype.boolean(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostParticipantVerifyResponseMock = (overrideResponse = {})=>({
        addressVerified: faker.datatype.boolean(),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyVerified: faker.datatype.boolean(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetRegistrationStateResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        addressVerified: faker.datatype.boolean(),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        companyVerified: faker.datatype.boolean(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPatchRegistrationStateResponseMock = (overrideResponse = {})=>({
        accessCodeRequest: faker.datatype.boolean(),
        addressVerified: faker.datatype.boolean(),
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        alternateEmployerId: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        attemptsLeft: faker.number.int({
            min: undefined,
            max: undefined
        }),
        companyName: faker.word.sample(),
        companyVerified: faker.datatype.boolean(),
        confirmationCode: faker.word.sample(),
        email: faker.word.sample(),
        firstName: faker.word.sample(),
        hasPassword: faker.datatype.boolean(),
        inviteCode: faker.word.sample(),
        inviteEmail: faker.word.sample(),
        isState: faker.datatype.boolean(),
        lastName: faker.word.sample(),
        matched: faker.datatype.boolean(),
        participantId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participants: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                companyName: faker.word.sample(),
                firstName: faker.word.sample(),
                isLockedOut: faker.datatype.boolean(),
                lastName: faker.word.sample(),
                participantId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                recordKeeperId: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        personalEmail: faker.word.sample(),
        phoneNumber: faker.word.sample(),
        planId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        planName: faker.word.sample(),
        planType: faker.word.sample(),
        program: faker.helpers.arrayElement([
            'register',
            'exempt'
        ]),
        reason: faker.datatype.boolean(),
        recordKeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        subdomain: faker.word.sample(),
        token: faker.word.sample(),
        type: faker.word.sample(),
        userId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostRetirementPlanner401kManagerQuestionnaireResponseMock = (overrideResponse = {})=>({
        riskTolerance: faker.helpers.arrayElement([
            'aggressive',
            'conservative',
            'moderate'
        ]),
        ...overrideResponse
    });
export const getPostRetirementPlannerActivateResponseMock = (overrideResponse = {})=>({
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetClass: faker.word.sample(),
                cusip: faker.word.sample(),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                morningStarId: faker.word.sample(),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getPostRetirementPlannerDeactivateResponseMock = (overrideResponse = {})=>({
        deactivateStatus: faker.word.sample(),
        failureReason: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRetirementPlannerPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetClass: faker.word.sample(),
                cusip: faker.word.sample(),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                morningStarId: faker.word.sample(),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getPostRetirementPlannerPreviewAllocationResponseMock = (overrideResponse = {})=>({
        currentAge: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isActivated: faker.datatype.boolean(),
        lastUpdated: faker.word.sample(),
        retirementAge: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        riskTolerance: faker.helpers.arrayElement([
            faker.helpers.arrayElement([
                'aggressive',
                'conservative',
                'moderate'
            ]),
            undefined
        ]),
        targetAllocations: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                assetClass: faker.word.sample(),
                cusip: faker.word.sample(),
                fundName: faker.word.sample(),
                fundType: faker.word.sample(),
                morningStarId: faker.word.sample(),
                percentageAllocation: faker.number.int({
                    min: undefined,
                    max: undefined
                })
            })),
        ...overrideResponse
    });
export const getGetAllSafeHarborContributionTypesResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            name: faker.word.sample(),
            nonElectivePercent: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tierOneMatchMax: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierOneMatchPercent: faker.number.int({
                min: undefined,
                max: undefined
            }),
            tierTwoMatchMax: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierTwoMatchMin: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ]),
            tierTwoMatchPercent: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                null
            ])
        }));
export const getGetEmployeeDetailsResponseMock = (overrideResponse = {})=>({
        contributions: {
            employeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employerYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stateEmployeeYTDContributions: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            totalDollars: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        editAccess: {
            isAllowedToUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            message: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        employee: {
            accountId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            activationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            addressUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            afterTaxContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            afterTaxContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            autorebalance: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            birthDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            cipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contactInformation: {
                address: {
                    address1: faker.word.sample(),
                    address2: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    city: faker.word.sample(),
                    country: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    state: faker.word.sample(),
                    zip: faker.word.sample()
                },
                mailingAddress: faker.helpers.arrayElement([
                    {
                        address1: faker.word.sample(),
                        address2: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        city: faker.word.sample(),
                        country: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        state: faker.word.sample(),
                        zip: faker.word.sample()
                    },
                    undefined
                ]),
                personalEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                phoneNumber: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                physicalSameAsMailing: faker.helpers.arrayElement([
                    faker.datatype.boolean(),
                    undefined
                ]),
                workEmail: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            contributesToRoth: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            contribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            contributions: faker.helpers.arrayElement([
                {
                    irsLimit: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                },
                undefined
            ]),
            contributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            createdAt: faker.word.sample(),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            deferralChanged: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            deferralElections: {
                afterTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                afterTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                preTaxAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                preTaxType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                rothAmt: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                rothType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            eligibility: faker.helpers.arrayElement([
                {
                    ageRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    entryDate: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    isLtpt: faker.datatype.boolean(),
                    isOverride: faker.datatype.boolean(),
                    overrideNotes: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    serviceRequirementDetail: faker.helpers.arrayElement([
                        {
                            isMet: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    status: faker.word.sample()
                },
                undefined
            ]),
            emailUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employeeStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employmentStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            esaGroupId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            esaGroupName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            externalId: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            firstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gender: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            inRmdAge: faker.datatype.boolean(),
            isDeceased: faker.datatype.boolean(),
            isDisabled: faker.datatype.boolean(),
            isVerified: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            lastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            maritalStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            middleName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            model: faker.helpers.arrayElement([
                {
                    modelId: faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    modelName: faker.word.sample(),
                    modelType: faker.word.sample(),
                    modelViewName: faker.word.sample()
                },
                undefined
            ]),
            nameUpdatedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            onboardingWizardCompletedAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participantChangedDeferralAt: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            password: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            registeredOn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            rehireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            riskValue: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            rothContributionType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            savesForRetirement: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sendEmailUpdate: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            sponsorId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraAccountStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraCipStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateIraPerEmployerStatus: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            updatedAt: faker.word.sample(),
            updatedBy: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            yearsToRetire: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getGetSponsorEntityResponseMock = (overrideResponse = {})=>({
        data: {
            attributes: {
                isConvert: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            relationships: {
                firm: {
                    data: {
                        id: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    }
                }
            }
        },
        included: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                attributes: {
                    recordKeeperId: faker.number.int({
                        min: undefined,
                        max: undefined
                    })
                }
            })),
        ...overrideResponse
    });
export const getGetForfeiturePreferenceResponseMock = (overrideResponse = {})=>({
        createdAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        id: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        offsetEmployerContribution: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        payPlanFees: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        updatedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetOnboardingResponseMock = (overrideResponse = {})=>({
        schemaState: {
            censusInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            companyInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            conversionInfo: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            employeeGroups: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>({
                        description: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dollarCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        incentivesOptOut: faker.helpers.arrayElement([
                            faker.datatype.boolean(),
                            undefined
                        ]),
                        initialBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        initialBonusMinimum: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        lifetimeCap: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        localId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusAmount: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        milestoneBonusThreshold: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ]),
                        name: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        percent: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    })),
                undefined
            ]),
            paymentSetup: faker.helpers.arrayElement([
                {
                    bankAccounts: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ]),
                    feePayment: faker.helpers.arrayElement([
                        {
                            bankAccountLocalId: faker.helpers.arrayElement([
                                faker.number.int({
                                    min: undefined,
                                    max: undefined
                                }),
                                null
                            ]),
                            isPayingWithCreditCard: faker.datatype.boolean()
                        },
                        undefined
                    ]),
                    forfeiturePreferences: faker.helpers.arrayElement([
                        {},
                        undefined
                    ]),
                    fundingMethods: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({})),
                        undefined
                    ])
                },
                undefined
            ]),
            payrollSetup: {
                payrollSchedules: faker.helpers.arrayElement([
                    Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({})),
                    undefined
                ]),
                payrollSystem: faker.helpers.arrayElement([
                    {},
                    undefined
                ])
            },
            planAdministration: faker.helpers.arrayElement([
                {},
                undefined
            ]),
            planOptions: faker.helpers.arrayElement([
                {},
                undefined
            ])
        },
        status: faker.helpers.arrayElement([
            'completed_manually',
            'completed_successfully',
            'completed_unsuccessfully',
            'in_progress',
            'needs_attention',
            'new',
            'ongoing'
        ]),
        ...overrideResponse
    });
export const getGetSponsorOnboardingInformationResponseMock = (overrideResponse = {})=>({
        fields: {
            above10M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            address1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            address2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisorsFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            advisoryServiceId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            articlesOfIncorporationLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            assetBasedFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authorizedSignerEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress1: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerAddress2: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerCity: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerDateOfBirth: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerResidenceCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerSSN: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerWorkPhone: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            authSignerZip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            billingContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            censusLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            chargesOffPlatform: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            citizenshipType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            city: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            comment: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyEntityType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            companyPhoneNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            controlGroupBusinesses: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    business: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    ein: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            conversionParticipantDetailsLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateSubmittedToRecordkeeper: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            disablePlanDesign: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            doingBusinessAs: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerIdentificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanAssets: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanCustodian: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanParticipants: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            existingPlanProvider: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            expectedAnnualContributions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feePaymentMethod: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            feesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            first3M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            fiscalYearEnd: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            form5500Link: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            hasCensus: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasMultiplePayrollGroups: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasUnion: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hqCountry: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            identificationCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationExpirationDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationIssueDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationNumber: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationState: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            identificationType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            investmentProductId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            isActive: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isAuthorizedSigner: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isConvertedPlan: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            leasedEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            newOnboarding: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            next2M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            next5M: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            offsetEmployerContribution: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerForeignDignitaryCountry: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownerIsForeignDignitary: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ownersFamilyMembersEmployees: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    name: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    taxFormType: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            ownersOver5Percent: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            paaLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            participationAgreementLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            partTimeEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            payPlanFees: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            perParticipantFeesPaidBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planTier: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            planType: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            planYear: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactEmail: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactFirstName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactLastName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            primaryContactTitle: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            standardIndustrialClassification: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            state: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            stateOfIncorporation: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            summaryPlanDescriptionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            teamMemberEmails: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            totalEmployeesNumber: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            tpaId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            updatedBy: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            wiredAtWork: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            zip: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        ...overrideResponse
    });
export const getPostUploadCensusResponseMock = (overrideResponse = {})=>({
        createdAt: faker.word.sample(),
        documentKey: faker.word.sample(),
        entity: faker.word.sample(),
        entityId: faker.word.sample(),
        etag: faker.word.sample(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        isEnabled: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        originalFileName: faker.word.sample(),
        uploadPath: faker.word.sample(),
        ...overrideResponse
    });
export const getGetSponsorEsaProgramResponseMock = (overrideResponse = {})=>({
        allowInitialBonus: faker.datatype.boolean(),
        allowMatch: faker.datatype.boolean(),
        allowMilestoneBonus: faker.datatype.boolean(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetOnboardingExistsResponseMock = (overrideResponse = {})=>({
        exists: faker.datatype.boolean(),
        ...overrideResponse
    });
export const getGetPayrollProvidersResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            dateFormat: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            defaultAdapterId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            instructionLink: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            integrationTypeId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            isApproved: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isPiIntegrated: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            level: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            name: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            subName: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            useCatchupFields: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useK1: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            useTiredMatch: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ])
        }));
export const getGetPlanConfigurationResponseMock = (overrideResponse = {})=>({
        configurationId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        hasCompleted: faker.datatype.boolean(),
        hasOfficers: faker.datatype.boolean(),
        hasOwners: faker.datatype.boolean(),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanGrossCompensationResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecorsdId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            grossCompensation: faker.number.int({
                min: undefined,
                max: undefined
            }),
            grosscompInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            lastName: faker.word.sample(),
            ssn: faker.word.sample()
        }));
export const getGetPlanOfficersResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            censusRecordsId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isOfficer: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            officerInformationId: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ssn: faker.word.sample()
        }));
export const getGetPlanOwnersResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthYear: faker.number.int({
                min: undefined,
                max: undefined
            }),
            firstName: faker.word.sample(),
            hireDate: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            isEmployee: faker.datatype.boolean(),
            lastName: faker.word.sample(),
            ownership: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            ownersId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ownerSince: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            ssn: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        }));
export const getGetPlanOwnersFamilyResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            employee: {
                birthYear: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                censusRecordsId: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                firstName: faker.word.sample(),
                hireDate: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                lastName: faker.word.sample(),
                ssn: faker.word.sample()
            },
            ownersFamilyId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            relationship: faker.word.sample()
        }));
export const getGetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        onboarding: faker.helpers.arrayElement([
            {
                questionnaireSubmittedAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        ...overrideResponse
    });
export const getGetQuestionnaireInformationResponseMock = (overrideResponse = {})=>({
        address: faker.helpers.arrayElement([
            {
                address1: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                address2: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                city: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                state: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                zip: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            undefined
        ]),
        anticipatedHires: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        authorizedSignerEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerFirstName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        authSignerWorkPhone: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyEntityType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        companyPhoneNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        contributionScenario: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        controlGroupBusinesses: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        currentComplianceIssues: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.word.sample()),
            undefined
        ]),
        dayToDayContactEmail: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactLastName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        dayToDayContactNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        doingBusinessAs: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        employerIdentificationNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanProvider: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        existingPlanType: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        fiscalYearEnd: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        hasOtherBusinesses: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        highlyCompensatedEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        industryGroup: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isConvert: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isPartOfControlGroup: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ownerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        payrollProviderId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        payrollProviderOther: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        questionnaireSubmittedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        relativesOfOwnerEmployees: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        retirementObjectives: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorPlan: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    pooledPlan: faker.helpers.arrayElement([
                        {
                            pooledPlanType: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ]),
                    thirdPartyAdminPlan: faker.helpers.arrayElement([
                        Array.from({
                            length: faker.number.int({
                                min: 1,
                                max: 10
                            })
                        }, (_, i)=>i + 1).map(()=>({
                                thirdPartyAdminId: faker.helpers.arrayElement([
                                    faker.number.int({
                                        min: undefined,
                                        max: undefined
                                    }),
                                    undefined
                                ])
                            })),
                        undefined
                    ])
                })),
            undefined
        ]),
        stateOfIncorporation: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        totalEmployeesNumber: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        wiredAtWork: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSubaPlanDetailsResponseMock = (overrideResponse = {})=>({
        forfeituresBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        migrationDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetSubaTransactionsResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                accountId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                actionType: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                amount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                createdAt: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                forfeitedBalance: faker.helpers.arrayElement([
                    {
                        participantFirstName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        participantId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        participantLastName: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        withdrawalId: faker.number.int({
                            min: undefined,
                            max: undefined
                        })
                    },
                    undefined
                ]),
                fundingContribution: faker.helpers.arrayElement([
                    {
                        expectedPayDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        ucid: faker.word.sample()
                    },
                    undefined
                ]),
                payingFees: faker.helpers.arrayElement([
                    {
                        billingPeriodId: faker.number.int({
                            min: undefined,
                            max: undefined
                        }),
                        periodEndDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        periodStartDate: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        purpose: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ]),
                sourceTransactionId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                tracerId: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                transactionTypeCode: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            })),
        meta: {
            count: faker.number.int({
                min: undefined,
                max: undefined
            })
        },
        ...overrideResponse
    });
export const getGetYetCensusDataPagedResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            birthDate: faker.word.sample(),
            dateOfHire: faker.word.sample(),
            dateOfRehire: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            dateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            employerDiscretionaryMatch: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            employerSafeHarborContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            firstName: faker.word.sample(),
            grossComp: faker.number.int({
                min: undefined,
                max: undefined
            }),
            lastName: faker.word.sample(),
            preTaxContribution: faker.number.int({
                min: undefined,
                max: undefined
            }),
            rothContribution: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            secondDateOfTermination: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            sponsorPlanId: faker.number.int({
                min: undefined,
                max: undefined
            }),
            ssn: faker.word.sample(),
            ytdHours: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetCensusStatusResponseMock = (overrideResponse = {})=>({
        started: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetYetChecklistResponseMock = (overrideResponse = {})=>({
        areOfficersCompleted: faker.datatype.boolean(),
        areOwnerFamilyMembersCompleted: faker.datatype.boolean(),
        areOwnersCompleted: faker.datatype.boolean(),
        hasNoOfficers: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        hasNoOwners: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        isCensusCompleted: faker.datatype.boolean(),
        isQuestionnaireCompleted: faker.datatype.boolean(),
        isYearEndItemComplete: faker.datatype.boolean(),
        isYearEndPackagingCompleted: faker.datatype.boolean(),
        planYear: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetYetConfigResponseMock = (overrideResponse = {})=>({
        shouldDisplayYearEndPlanToDo: faker.helpers.arrayElement([
            faker.datatype.boolean(),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetYetDocumentsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            createdAt: faker.word.sample(),
            documentKey: faker.word.sample(),
            entity: faker.word.sample(),
            entityId: faker.word.sample(),
            etag: faker.word.sample(),
            id: faker.number.int({
                min: undefined,
                max: undefined
            }),
            isEnabled: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            originalFileName: faker.word.sample(),
            testResult: {
                action: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                additionalData: faker.helpers.arrayElement([
                    {},
                    undefined
                ]),
                status: faker.helpers.arrayElement([
                    {
                        status: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        testResultStatusId: faker.helpers.arrayElement([
                            faker.number.int({
                                min: undefined,
                                max: undefined
                            }),
                            undefined
                        ])
                    },
                    undefined
                ]),
                uploadHistoryId: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ])
            },
            uploadPath: faker.word.sample()
        }));
export const getGetYetSponsorQuestionnaireResponseMock = (overrideResponse = {})=>({
        answers: {
            ASSETS_NOT_AT_LT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIOD_NOTICE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BLACKOUT_PERIODS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BOND_AMOUNT_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            BUSINESS_CODE_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_PARTICIPATION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            CONTROLLED_GROUP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            EMPLOYER_MATCH_QUESTION_AMOUNT_AND_FORMULA: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            FEES_AND_COMMISSIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LATE_BENEFITS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_DOCUMENTS: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            LEASED_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            MERGERS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            NONEXEMPT_TRANSACTIONS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_EMPLOYEES_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_BUSINESS_OWNERSHIP_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            OTHER_PLAN_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PLAN_LOSS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_DESCRIPTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            PROFIT_SHARING_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAX_EXTENSION_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            },
            TAXED_AS_QUESTION: {
                selection: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ]),
                text: faker.helpers.arrayElement([
                    faker.word.sample(),
                    undefined
                ])
            }
        },
        questionnaire: faker.word.sample(),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorPlanId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        year: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetSponsorDigitalOnboardingResponseMock = (overrideResponse = {})=>({
        census: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        companyQuestionnaire: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        completedAt: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        payrollAndPayment: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        planDesign: faker.helpers.arrayElement([
            faker.word.sample(),
            null
        ]),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetPlanByIdV2ResponseMock = (overrideResponse = {})=>({
        advisorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        custodianAccountNumber: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        effectiveDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        eligibleParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        employeeBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        employerBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        firmId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        forfeitureBalance: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        hasPriorLoans: faker.datatype.boolean(),
        id: faker.number.int({
            min: undefined,
            max: undefined
        }),
        inboundBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        inboundBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        isActive: faker.datatype.boolean(),
        isBlackout: faker.datatype.boolean(),
        isOffboardingBlackoutActive: faker.datatype.boolean(),
        loanBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        name: faker.word.sample(),
        notes: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutEndDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        offboardingBlackoutStartDate: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        participantsWithBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        participantsWithDeferrals: faker.number.int({
            min: undefined,
            max: undefined
        }),
        programId: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        readyToEnrollParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        recordkeeper: faker.word.sample(),
        recordkeeperId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        registeredParticipants: faker.number.int({
            min: undefined,
            max: undefined
        }),
        rolloverBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        sponsorCompanyName: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        sponsorId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        statefulSchemaTrackingState: faker.helpers.arrayElement([
            faker.word.sample(),
            undefined
        ]),
        status: faker.word.sample(),
        totalBalance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        tpaIds: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>faker.number.int({
                    min: undefined,
                    max: undefined
                })),
            undefined
        ]),
        type: faker.word.sample(),
        ...overrideResponse
    });
export const getGetWhiteLabelResponseMock = (overrideResponse = {})=>({
        legal: {
            copyright: faker.helpers.arrayElement([
                Array.from({
                    length: faker.number.int({
                        min: 1,
                        max: 10
                    })
                }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                undefined
            ]),
            disclosures: faker.helpers.arrayElement([
                {
                    advisor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    participant: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample()),
                    sponsor: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>faker.word.sample())
                },
                undefined
            ]),
            links: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    text: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        links: {
            censusTemplate: faker.word.sample(),
            csvInstructions: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            gustoLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            notExpectingZero: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            payrollErrors: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            qboLearnMore: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        login: {
            accountSetup: faker.helpers.arrayElement([
                {
                    link: faker.helpers.arrayElement([
                        {
                            description: faker.word.sample(),
                            text: faker.word.sample()
                        },
                        undefined
                    ]),
                    page: faker.helpers.arrayElement([
                        {
                            selections: faker.helpers.arrayElement([
                                Array.from({
                                    length: faker.number.int({
                                        min: 1,
                                        max: 10
                                    })
                                }, (_, i)=>i + 1).map(()=>({
                                        description: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        link: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ]),
                                        title: faker.helpers.arrayElement([
                                            faker.word.sample(),
                                            undefined
                                        ])
                                    })),
                                undefined
                            ]),
                            title: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            banner: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            contacts: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                })),
            logo: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            resources: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    description: faker.word.sample(),
                    url: faker.word.sample()
                }))
        },
        metadata: {
            favicon: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            title: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ])
        },
        mfa: {
            advisor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    helpLink: faker.word.sample(),
                    learnMoreLink: faker.word.sample()
                },
                undefined
            ])
        },
        navbar: {
            logo: {
                desktop: faker.word.sample(),
                mobile: faker.word.sample()
            }
        },
        registration: {
            documents: faker.helpers.arrayElement([
                {
                    terms: faker.helpers.arrayElement([
                        {
                            documentKey: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entity: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ]),
                            entityId: faker.helpers.arrayElement([
                                faker.word.sample(),
                                undefined
                            ])
                        },
                        undefined
                    ])
                },
                undefined
            ]),
            exemptionReasons: Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    key: faker.word.sample(),
                    value: faker.word.sample()
                })),
            hasEIN: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            hasSDAT: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            isState: faker.helpers.arrayElement([
                faker.datatype.boolean(),
                undefined
            ]),
            link: faker.word.sample(),
            logo: faker.helpers.arrayElement([
                {
                    desktop: faker.word.sample(),
                    mobile: faker.word.sample()
                },
                undefined
            ]),
            name: faker.word.sample(),
            website: faker.word.sample()
        },
        sponsorOnboarding: faker.helpers.arrayElement([
            Array.from({
                length: faker.number.int({
                    min: 1,
                    max: 10
                })
            }, (_, i)=>i + 1).map(()=>({
                    items: Array.from({
                        length: faker.number.int({
                            min: 1,
                            max: 10
                        })
                    }, (_, i)=>i + 1).map(()=>({
                            details: faker.helpers.arrayElement([
                                faker.word.sample(),
                                null
                            ]),
                            item: faker.word.sample()
                        })),
                    title: faker.word.sample()
                })),
            undefined
        ]),
        subdomain: faker.word.sample(),
        support: {
            advisor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            participant: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ]),
            sponsor: faker.helpers.arrayElement([
                {
                    email: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    link: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    phone: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                undefined
            ])
        },
        theme: {
            palette: {
                primary: {
                    contrastText: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    dark: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ]),
                    main: faker.helpers.arrayElement([
                        faker.word.sample(),
                        undefined
                    ])
                },
                secondary: faker.helpers.arrayElement([
                    {
                        contrastText: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        dark: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ]),
                        main: faker.helpers.arrayElement([
                            faker.word.sample(),
                            undefined
                        ])
                    },
                    undefined
                ])
            }
        },
        whitelabelId: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getPostCreateWithdrawalResponseMock = ()=>faker.number.int();
export const getGetRmdAmountResponseMock = (overrideResponse = {})=>({
        age1: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        age2: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        lifeExpectancy: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        requiredAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        type: faker.helpers.arrayElement([
            {},
            undefined
        ]),
        vestedBalance: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        withdrawalAmount: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        year: faker.helpers.arrayElement([
            faker.number.int({
                min: undefined,
                max: undefined
            }),
            undefined
        ]),
        ...overrideResponse
    });
export const getGetRmdBalanceResponseMock = (overrideResponse = {})=>({
        balance: faker.number.int({
            min: undefined,
            max: undefined
        }),
        year: faker.number.int({
            min: undefined,
            max: undefined
        }),
        ...overrideResponse
    });
export const getGetWithholdingResponseMock = (overrideResponse = {})=>({
        data: {
            code1099: faker.word.sample(),
            federalWithholdingPercent: faker.word.sample(),
            qualifiedRoth: faker.word.sample(),
            rothInitialYear: faker.helpers.arrayElement([
                faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                undefined
            ]),
            stateWithholdingCode: faker.word.sample(),
            stateWithholdingPercent: faker.helpers.arrayElement([
                faker.word.sample(),
                undefined
            ]),
            taxType: faker.word.sample()
        },
        ...overrideResponse
    });
export const getGetWithholdingDetailResponseMock = (overrideResponse = {})=>({
        data: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                code1099: faker.word.sample(),
                federalWithholdingAmount: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                federalWithholdingPercent: faker.number.int({
                    min: undefined,
                    max: undefined
                }),
                isQualifiedRoth: faker.datatype.boolean(),
                isRollover: faker.datatype.boolean(),
                rothInitialYear: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stateWithholdingAmount: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                stateWithholdingCode: faker.word.sample(),
                stateWithholdingPercent: faker.helpers.arrayElement([
                    faker.number.int({
                        min: undefined,
                        max: undefined
                    }),
                    undefined
                ]),
                taxType: faker.word.sample()
            })),
        ...overrideResponse
    });
export const getGetYetNaicsResponseMock = ()=>Array.from({
        length: faker.number.int({
            min: 1,
            max: 10
        })
    }, (_, i)=>i + 1).map(()=>({
            code: faker.word.sample(),
            description: faker.word.sample(),
            naicsCodeId: faker.number.int({
                min: undefined,
                max: undefined
            })
        }));
export const getGetZendeskJwtResponseMock = (overrideResponse = {})=>({
        conversationFields: Array.from({
            length: faker.number.int({
                min: 1,
                max: 10
            })
        }, (_, i)=>i + 1).map(()=>({
                id: faker.word.sample(),
                value: {}
            })),
        jwt: faker.word.sample(),
        key: faker.word.sample(),
        ...overrideResponse
    });
export const getGetAdvisorByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/contact-card', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorContactCardResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAdvisorContactCardMockHandler = (overrideResponse)=>{
    return http.put('*/api/advisor/contact-card', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPutAdvisorContactCardResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/plans', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlansResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlansTrackerMockHandler = ()=>{
    return http.get('*/api/advisor/plans/tracker', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeesMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/employees', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanEmployeesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanEmployeeMockHandler = ()=>{
    return http.get('*/api/advisor/plans/:planId/employees/:employeeId', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelSecuritiesMockHandler = ()=>{
    return http.get('*/api/plans/:planId/models/:modelId/securities', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanStatisticsMockHandler = ()=>{
    return http.get('*/api/sponsor/plans/:planId/stats', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLinkSponsorMockHandler = ()=>{
    return http.post('*/api/advisor/sponsors/link', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorByIdStatsMockHandler = (overrideResponse)=>{
    return http.get('*/api/advisor/statistics', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAdvisorByIdStatsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCarouselMockHandler = (overrideResponse)=>{
    return http.get('*/api/carousel', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCarouselResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetConnectivityMockHandler = (overrideResponse)=>{
    return http.get('*/api/connectivity', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetConnectivityResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCsmMockHandler = (overrideResponse)=>{
    return http.get('*/api/csm', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCsmResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureMockHandler = (overrideResponse)=>{
    return http.get('*/api/disclosure/login', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutLoginDisclosureMockHandler = ()=>{
    return http.put('*/api/disclosure/login', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoginDisclosureAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/api/disclosure/login/agreement', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoginDisclosureAgreementResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentByIdMockHandler = ()=>{
    return http.get('*/api/document', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeleteDocumentByIdMockHandler = ()=>{
    return http.patch('*/api/document', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllDocumentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAgreementMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents/agreement', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAgreementResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostDocumentAgreementMockHandler = ()=>{
    return http.post('*/api/documents/agreement', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentDownloadByIdMockHandler = ()=>{
    return http.get('*/api/documents/download', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentDownloadByKeyMockHandler = ()=>{
    return http.get('*/api/documents/download-by-key', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents/html', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDocumentAsHtmlAndDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/api/documents/html/download', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetDocumentAsHtmlAndDownloadResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPdfMockHandler = (overrideResponse)=>{
    return http.post('*/api/documents/pdf', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostPdfResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadDocumentMockHandler = ()=>{
    return http.post('*/api/documents/upload', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailMockHandler = ()=>{
    return http.post('*/api/email', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEmailPreviewRenderMockHandler = ()=>{
    return http.post('*/api/email/preview/render', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmailPreviewByIdMockHandler = ()=>{
    return http.get('*/api/email/previews', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeHoldingsMockHandler = ()=>{
    return http.get('*/api/employee/holdings', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoansMockHandler = ()=>{
    return http.get('*/api/employee/loans', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeePerformanceMockHandler = ()=>{
    return http.get('*/api/employee/performance', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeTransactionsMockHandler = ()=>{
    return http.get('*/api/employee/transactions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeePendingTransactionsMockHandler = ()=>{
    return http.get('*/api/employee/transactions/pending', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeTransactionsYearsMockHandler = ()=>{
    return http.get('*/api/employee/transactions/years', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelSecuritiesMockHandler = (overrideResponse)=>{
    return http.get('*/api/employee/:employeeId/model-securities/:type', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelSecuritiesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesWithContributionsMockHandler = ()=>{
    return http.get('*/api/employees/contributions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeLoanDetailsMockHandler = ()=>{
    return http.get('*/api/employees/loans/details', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesTransactionsYearsMockHandler = ()=>{
    return http.get('*/api/employees/transactions/years', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaParticipantGoalMockHandler = ()=>{
    return http.patch('*/api/esa/participant/goal', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantGoalsMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/participant/goals', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantGoalsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaParticipantIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/participant/incentives', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaParticipantIncentivesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanCashInterestRateMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/cash-interest-rate', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanCashInterestRateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-balance-over-time', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupBalanceOverTimeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupStatsMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/group-stats', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupStatsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanGroupsMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/groups', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanGroupsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEsaPlanIncentivesMockHandler = (overrideResponse)=>{
    return http.get('*/api/esa/plan/incentives', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEsaPlanIncentivesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEsaWithdrawalMockHandler = ()=>{
    return http.patch('*/api/esa/withdrawal', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorExemptionConfirmationMockHandler = ()=>{
    return http.post('*/api/exempt/confirmation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorExemptionReasonMockHandler = (overrideResponse)=>{
    return http.post('*/api/exempt/reason', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorExemptionReasonResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFi360DownloadMockHandler = ()=>{
    return http.get('*/api/fact-sheets', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesMockHandler = (overrideResponse)=>{
    return http.get('*/api/feature-toggle', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFeatureTogglesListMockHandler = (overrideResponse)=>{
    return http.get('*/api/feature-toggle/list', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFeatureTogglesListResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetFirmByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/firm/entity', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetFirmByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetHealthMockHandler = ()=>{
    return http.get('*/api/health', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetLoanAmortizationPdfMockHandler = (overrideResponse)=>{
    return http.get('*/api/loans/amortization/pdf', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetLoanAmortizationPdfResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidTokenMockHandler = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-link-token', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidTokenResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeleteManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.delete('*/api/managed-accounts/plaid-links', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getDeleteManagedAccountsPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/api/managed-accounts/plaid-links', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetManagedAccountsPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostManagedAccountsPlaidBalancesMockHandler = (overrideResponse)=>{
    return http.post('*/api/managed-accounts/plaid-links/balance/get', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostManagedAccountsPlaidBalancesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetModelPerformanceMockHandler = (overrideResponse)=>{
    return http.get('*/api/model/:modelId/performance', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetModelPerformanceResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantMockHandler = ()=>{
    return http.patch('*/api/participant', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountBalanceByIdMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account-balance', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountBalanceByIdResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantLoanMockHandler = ()=>{
    return http.post('*/api/participant/account/loans', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinkTokenMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-link-token', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinkTokenResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/account/loans/plaid-links', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPlaidLinksMockHandler = (overrideResponse)=>{
    return http.post('*/api/participant/account/loans/plaid-links', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantPlaidLinksResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantLoanCreateMockHandler = ()=>{
    return http.get('*/api/participant/account/loans/request', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantLoanMockHandler = ()=>{
    return http.patch('*/api/participant/account/loans/:loanId', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostLoanManualRepaymentMockHandler = ()=>{
    return http.post('*/api/participant/account/loans/:loanId/payment', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/accounts', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAccountsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBalanceOverTimeMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/balance-over-time', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBalanceOverTimeResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantBankAccountsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/bank-accounts', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantBankAccountsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetBeneficiariesMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/beneficiaries', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetBeneficiariesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantBeneficiariesMockHandler = ()=>{
    return http.put('*/api/participant/beneficiaries', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRecentParticipantDocumentsMockHandler = ()=>{
    return http.get('*/api/participant/documents/recent', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostEsaGoalMockHandler = ()=>{
    return http.post('*/api/participant/esa/goal', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantIdentityVerificationMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/identity-verification', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantIdentityVerificationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantInfoWithEmailsMockHandler = ()=>{
    return http.patch('*/api/participant/info', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGoalFeedbackMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetGoalFeedbackResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionAgeSuggestionMockHandler = ()=>{
    return http.post('*/api/participant/investment-election/age-suggestion', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionRetirementIncomeSuggestionMockHandler = ()=>{
    return http.post('*/api/participant/investment-election/retirement-income-suggestion', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetElectionsSetupMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investment-election/setup', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetElectionsSetupResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostElectionsSetupMockHandler = ()=>{
    return http.post('*/api/participant/investment-election/setup', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInvestmentsModelDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/model', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetInvestmentsModelDisplayResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantModelSecuritiesMockHandler = ()=>{
    return http.get('*/api/participant/investments/options/plans/:planId/models/:modelId/securities', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantStatsMockHandler = ()=>{
    return http.get('*/api/participant/investments/options/plans/:planId/stats', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRebalanceRequestMockHandler = ()=>{
    return http.post('*/api/participant/investments/rebalance-request', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRebalanceSettingsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/rebalance-settings', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRebalanceSettingsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRebalanceSettingsMockHandler = ()=>{
    return http.put('*/api/participant/investments/rebalance-settings', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetStrategiesIndexMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetStrategiesIndexResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAgeBasedMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/age-based', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAgeBasedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutAgeBasedMockHandler = ()=>{
    return http.put('*/api/participant/investments/strategies/age-based', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutCustomAllocationMockHandler = ()=>{
    return http.put('*/api/participant/investments/strategies/custom-allocation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskBasedMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskBasedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutRiskBasedMockHandler = ()=>{
    return http.put('*/api/participant/investments/strategies/risk-based', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRiskModelQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/investments/strategies/risk-based/questionnaire', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRiskModelQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetMailPreferencesMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/mail-preferences', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetMailPreferencesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutMailPreferencesMockHandler = ()=>{
    return http.put('*/api/participant/mail-preferences', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/onboarding', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantOnboardingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantOverviewMockHandler = ()=>{
    return http.get('*/api/participant/overview', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantDiscardPendingPlaidLinksMockHandler = ()=>{
    return http.post('*/api/participant/plaid-links/discard-pending', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPositionsMockHandler = ()=>{
    return http.get('*/api/participant/positions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantRolloverMockHandler = ()=>{
    return http.patch('*/api/participant/rollovers', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverInstructionsMockHandler = ()=>{
    return http.get('*/api/participant/rollovers/instructions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRolloverEligibilityMockHandler = ()=>{
    return http.get('*/api/participant/rollovers/request', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantRolloverMockHandler = ()=>{
    return http.post('*/api/participant/rollovers/request', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantRolloverMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/rollovers/:rolloverId', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantRolloverResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGenerateRolloverLetterMockHandler = ()=>{
    return http.get('*/api/participant/rollovers/:rolloverId/letter', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSavingsDisplayMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/savings', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSavingsDisplayResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSavingsMockHandler = ()=>{
    return http.put('*/api/participant/savings', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSurveyLinkMockHandler = ()=>{
    return http.get('*/api/participant/survey/link', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAggregatedByCategoryTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/transactions/aggregated-by-category', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAggregatedByCategoryTransactionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllowedWithdrawalReasonsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participant/withdrawals', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllowedWithdrawalReasonsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostWithdrawalMockHandler = ()=>{
    return http.post('*/api/participant/withdrawals', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsCountMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/unregistered/count', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetUnregisteredParticipantsCountResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailDownloadMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/download', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailDownloadResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantWelcomeEmailsHistoryMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/welcome-emails/history', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantWelcomeEmailsHistoryResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCalculatedEsaEmployerContributionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/participants/:participantId/calculate-employer-contributions', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCalculatedEsaEmployerContributionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPersonasMockHandler = (overrideResponse)=>{
    return http.get('*/api/personas', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPersonasResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanParticipantsMockHandler = ()=>{
    return http.get('*/api/plan/participants', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanModelMockHandler = ()=>{
    return http.get('*/api/plans/models', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanInvestmentsMockHandler = ()=>{
    return http.get('*/api/plans/:planId/investments', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramFundsMockHandler = (overrideResponse)=>{
    return http.get('*/api/program/funds', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramFundsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProgramModelsMockHandler = (overrideResponse)=>{
    return http.get('*/api/program/models', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetProgramModelsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetProspectusUrlPartsMockHandler = ()=>{
    return http.get('*/api/prospectus/url', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRedirectToPersonasMockHandler = ()=>{
    return http.get('*/api/redirect/personas', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantAddressOptionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/register/address/options', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantAddressOptionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantAddressVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/address/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantAddressVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAdvisorConnectMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/advisor/connect', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostAdvisorConnectResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorFinishMockHandler = ()=>{
    return http.get('*/api/register/advisor/finish', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAdvisorPasswordMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/advisor/password', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostAdvisorPasswordResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostAdvisorVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/advisor/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostAdvisorVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantCompanyOptionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/register/company/options', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetParticipantCompanyOptionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantCompanyVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/company/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantCompanyVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantConnectVerifyMockHandler = ()=>{
    return http.post('*/api/register/connect/verify', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchParticipantContactMockHandler = (overrideResponse)=>{
    return http.patch('*/api/register/contact', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchParticipantContactResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRegistrationContactMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/contact', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRegistrationContactResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/employer', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorAccessCodeRequestMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/employer/access-code-request', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostSponsorAccessCodeRequestResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorConnectMockHandler = ()=>{
    return http.post('*/api/register/employer/connect', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorFinishMockHandler = ()=>{
    return http.get('*/api/register/employer/finish', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPasswordMockHandler = ()=>{
    return http.post('*/api/register/employer/password', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantFinishMockHandler = ()=>{
    return http.get('*/api/register/finish', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantPasswordMockHandler = ()=>{
    return http.post('*/api/register/password', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRegistrationResetMockHandler = ()=>{
    return http.get('*/api/register/reset', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostParticipantVerifyMockHandler = (overrideResponse)=>{
    return http.post('*/api/register/verify', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostParticipantVerifyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRegistrationStateMockHandler = (overrideResponse)=>{
    return http.get('*/api/registration/state', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRegistrationStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchRegistrationStateMockHandler = (overrideResponse)=>{
    return http.patch('*/api/registration/state', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPatchRegistrationStateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAdvisorReportMockHandler = ()=>{
    return http.get('*/api/reports/advisors/:advisorId/:reportType/:fileName', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeReportMockHandler = ()=>{
    return http.get('*/api/reports/employees/:employeeId/:reportType/:fileName', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetUnregisteredParticipantsReportMockHandler = ()=>{
    return http.get('*/api/reports/participants/unregistered', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanReportMockHandler = ()=>{
    return http.get('*/api/reports/plans/:planId/:reportType/:fileName', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorReportMockHandler = ()=>{
    return http.get('*/api/reports/sponsors/:sponsorId/:reportType/:fileName', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsReportMockHandler = ()=>{
    return http.get('*/api/reports/suba-transactions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRetirementPlanner401kManagerQuestionnaireMockHandler = (overrideResponse)=>{
    return http.post('*/api/retirement-planner/401k-manager-questionnaire', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRetirementPlanner401kManagerQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRetirementPlannerActivateMockHandler = (overrideResponse)=>{
    return http.post('*/api/retirement-planner/activate', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRetirementPlannerActivateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRetirementPlannerDeactivateMockHandler = (overrideResponse)=>{
    return http.post('*/api/retirement-planner/deactivate', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRetirementPlannerDeactivateResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRetirementPlannerPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.get('*/api/retirement-planner/preview-allocation', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRetirementPlannerPreviewAllocationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRetirementPlannerPreviewAllocationMockHandler = (overrideResponse)=>{
    return http.post('*/api/retirement-planner/preview-allocation', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostRetirementPlannerPreviewAllocationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetAllSafeHarborContributionTypesMockHandler = (overrideResponse)=>{
    return http.get('*/api/safe-harbor-contribution-types', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetAllSafeHarborContributionTypesResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSessionMockHandler = ()=>{
    return http.get('*/api/session', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorAbilitiesMockHandler = ()=>{
    return http.get('*/api/sponsor/abilities', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusParticipantsMockHandler = ()=>{
    return http.get('*/api/sponsor/census/participants', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetBankAccountMockHandler = ()=>{
    return http.get('*/api/sponsor/company/bank-account', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostBankAccountMockHandler = ()=>{
    return http.post('*/api/sponsor/company/bank-account', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutBankAccountMockHandler = ()=>{
    return http.put('*/api/sponsor/company/bank-account', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchSponsorMockHandler = ()=>{
    return http.patch('*/api/sponsor/company/company-info', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorTeammatesMockHandler = ()=>{
    return http.get('*/api/sponsor/company/manage-teammate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeleteTeammateMockHandler = ()=>{
    return http.patch('*/api/sponsor/company/manage-teammate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSendUserInviteMockHandler = ()=>{
    return http.post('*/api/sponsor/company/manage-teammate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostFileHeadersUpdateMockHandler = ()=>{
    return http.post('*/api/sponsor/contribution/headers/mapping', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionsLandingPageDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCancelSubmissionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/cancel', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCancellationSubmissionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/cancellation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetParticipantsLoansMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/loans', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOffCycleContributionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/offcycle', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostResumeSubmissionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/resume', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIngestionFlowValidationMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/validate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionValidationMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/validation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionSubmissionDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionConfirmationMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/confirm', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionConfirmationDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/confirmation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionCorrectionMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/correction', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionCorrectionsMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/corrections', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionDetailsMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/details', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/display', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionUploadMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/document-category/:categoryId/upload', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDownloadContributionFileMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/file', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeitureMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/forfeiture', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostForfeitureMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/forfeiture', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionHeaderValidationsMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/headers', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetNormalizedContributionDataMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/normalized', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostIngestionFlowStartMockHandler = ()=>{
    return http.post('*/api/sponsor/contributions/:ucid/start', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDownloadContributionTemplateMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/template.xlsx', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionValidationPageDisplayMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/validate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionValidationMockHandler = ()=>{
    return http.get('*/api/sponsor/contributions/:ucid/validation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetDeferralChangesMockHandler = ()=>{
    return http.get('*/api/sponsor/deferral/changes', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchDeferralChangesActivitiesMockHandler = ()=>{
    return http.patch('*/api/sponsor/deferral/changes', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantMockHandler = ()=>{
    return http.put('*/api/sponsor/employee', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeesMockHandler = ()=>{
    return http.get('*/api/sponsor/employees', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantsMockHandler = ()=>{
    return http.put('*/api/sponsor/employees', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostValidateEmployeeMockHandler = ()=>{
    return http.post('*/api/sponsor/employees/validate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEmployeeDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/employees/:employeeId', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetEmployeeDetailsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchEmployeeMockHandler = ()=>{
    return http.patch('*/api/sponsor/employees/:employeeId', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContactInfoMockHandler = ()=>{
    return http.post('*/api/sponsor/employees/:employeeId/address', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutParticipantContributionsMockHandler = ()=>{
    return http.put('*/api/sponsor/employees/:employeeId/contributions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEntityMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/entity', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEntityResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetForfeiturePreferenceMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/forfeiture-preference', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetForfeiturePreferenceResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutForfeiturePreferenceMockHandler = ()=>{
    return http.put('*/api/sponsor/forfeiture-preference', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetHeapDataMockHandler = ()=>{
    return http.get('*/api/sponsor/heap', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostOnboardingMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutOnboardingMockHandler = ()=>{
    return http.put('*/api/sponsor/onboarding', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingInformationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding-information', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorOnboardingInformationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostUploadCensusMockHandler = (overrideResponse)=>{
    return http.post('*/api/sponsor/onboarding/add-employees', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostUploadCensusResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetInitialCensusMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/census', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorEsaProgramMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/esa-program', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorEsaProgramResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetOnboardingExistsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/exists', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetOnboardingExistsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostFinishOnboardingMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/finish', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorOnboardingTeammatesMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/manage-teammate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSendOnboardingUserInviteMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/manage-teammate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetNextPayrollDatesMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/payroll-dates', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollProvidersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/onboarding/payroll-providers', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPayrollProvidersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorPlaidLinkTokenMockHandler = ()=>{
    return http.get('*/api/sponsor/onboarding/plaid-link-token', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostGetSponsorPlaidLinksMockHandler = ()=>{
    return http.post('*/api/sponsor/onboarding/plaid-links', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollConnectionStatusMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/connection-status', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollDatesMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/dates', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollInfoMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/info', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollSetupsMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/setup', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/setup', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPayrollFundingSetupsMockHandler = ()=>{
    return http.get('*/api/sponsor/payroll/setup/funding', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollProviderMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/provider', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSkipStatusMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/skip', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutSkipSubmissionMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/skipping', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePayrollSetupMockHandler = ()=>{
    return http.delete('*/api/sponsor/payroll/setup/:payrollSetupId', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollDatesMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/:payrollSetupId/dates', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollSetupDisconnectionMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/setup/:payrollSetupId/disconnect', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPayrollSetupInfoMockHandler = ()=>{
    return http.put('*/api/sponsor/payroll/setup/:payrollSetupId/info', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPayrollValidationsMockHandler = ()=>{
    return http.post('*/api/sponsor/payroll/validate', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanFeaturesMockHandler = ()=>{
    return http.get('*/api/sponsor/plan-features', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOnboardingStatusMockHandler = ()=>{
    return http.get('*/api/sponsor/plan/onboarding/status', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostSponsorPlanDisconnectionMockHandler = ()=>{
    return http.post('*/api/sponsor/plan/:planId/disconnect', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanConfigurationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/configuration', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanConfigurationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanConfigurationMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/configuration', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanGrossCompensationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/gross-compensation', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanGrossCompensationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeGrossCompensationMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/gross-compensation', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetGrossCompensationTemplateMockHandler = ()=>{
    return http.get('*/api/sponsor/pocet/gross-compensation/download/template', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeGrossCompensationUploadMockHandler = ()=>{
    return http.post('*/api/sponsor/pocet/gross-compensation/upload', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanNonEmployeeOwnerMockHandler = ()=>{
    return http.post('*/api/sponsor/pocet/non-employee-owner', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOfficersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/officers', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOfficersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOfficerStatusMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/officers', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnerMockHandler = ()=>{
    return http.delete('*/api/sponsor/pocet/owners', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPlanEmployeeOwnerMockHandler = ()=>{
    return http.post('*/api/sponsor/pocet/owners', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanEmployeeOwnerMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/owners', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getDeletePlanOwnersFamilyMockHandler = ()=>{
    return http.delete('*/api/sponsor/pocet/owners-family', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanOwnersFamilyMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/pocet/owners-family', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanOwnersFamilyResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPutPlanOwnersFamilyMockHandler = ()=>{
    return http.put('*/api/sponsor/pocet/owners-family', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetTrackerDetailsMockHandler = ()=>{
    return http.get('*/api/sponsor/pocet/tracker', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostPriorProviderMockHandler = ()=>{
    return http.post('*/api/sponsor/prior-provider', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPriorProvidersMockHandler = ()=>{
    return http.get('*/api/sponsor/prior-providers', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPatchSponsorQuestionnaireMockHandler = ()=>{
    return http.patch('*/api/sponsor/questionnaire', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetQuestionnaireInformationMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/questionnaire-information', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetQuestionnaireInformationResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetContributionsMockHandler = ()=>{
    return http.get('*/api/sponsor/sponsor-plan/contributions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaPlanDetailsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-plan-details', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaPlanDetailsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSubaTransactionsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/suba-transactions', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSubaTransactionsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusAutosaveMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/autosave', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataDownloadMockHandler = ()=>{
    return http.get('*/api/sponsor/yet/census/download', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetCensusDataPagedMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/paged', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetCensusDataPagedResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartCensusMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/restart', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusStartMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/start', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetCensusStatusMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/census/status', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetCensusStatusResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusSubmitMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/submit', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetCensusUploadMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/census/upload', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetChecklistMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/checklist', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetChecklistResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetConfigMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/config', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetConfigResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsFundMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/contributions/fund', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostContributionsRefundMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/contributions/refund', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetDocumentsMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/documents', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetDocumentsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostStartOfPackagingMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/packaging/start', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetSponsorQuestionnaireMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/yet/questionnaire', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetSponsorQuestionnaireResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostYetSponsorQuestionnaireMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/questionnaire', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostRestartTestingProcessMockHandler = ()=>{
    return http.post('*/api/sponsor/yet/restart', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetStatusMockHandler = ()=>{
    return http.get('*/api/sponsor/yet/status', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYtdContributionsMockHandler = ()=>{
    return http.get('*/api/sponsor/ytd-contributions', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetSponsorDigitalOnboardingMockHandler = (overrideResponse)=>{
    return http.get('*/api/sponsor/:sponsorId/digital-onboarding', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetSponsorDigitalOnboardingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetPlanByIdV2MockHandler = (overrideResponse)=>{
    return http.get('*/api/v2/plans', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetPlanByIdV2ResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWhiteLabelMockHandler = (overrideResponse)=>{
    return http.get('*/api/whitelabel', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWhiteLabelResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPostCreateWithdrawalMockHandler = (overrideResponse)=>{
    return http.post('*/api/withdrawal', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getPostCreateWithdrawalResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdAmountMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-amount', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdAmountResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetRmdBalanceMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/rmd-balance', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetRmdBalanceResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetWithholdingDetailMockHandler = (overrideResponse)=>{
    return http.get('*/api/withdrawal/withholding/total-estimate', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetWithholdingDetailResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetYetNaicsMockHandler = (overrideResponse)=>{
    return http.get('*/api/yet/naics', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetYetNaicsResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetZendeskJwtMockHandler = (overrideResponse)=>{
    return http.get('*/api/zendesk/jwt', async (info)=>{
        await delay(1000);
        return new HttpResponse(JSON.stringify(overrideResponse !== undefined ? typeof overrideResponse === "function" ? overrideResponse(info) : overrideResponse : getGetZendeskJwtResponseMock()), {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getGetEntitySessionMockHandler = ()=>{
    return http.get('*/api/:entity/session', async ()=>{
        await delay(1000);
        return new HttpResponse(null, {
            status: 200,
            headers: {
                'Content-Type': 'application/json'
            }
        });
    });
};
export const getPortalMiddlewareHooksMock = ()=>[
        getGetAdvisorByIdMockHandler(),
        getGetAdvisorContactCardMockHandler(),
        getPutAdvisorContactCardMockHandler(),
        getGetPlansMockHandler(),
        getGetPlansTrackerMockHandler(),
        getGetPlanEmployeesMockHandler(),
        getGetPlanEmployeeMockHandler(),
        getGetPlanModelSecuritiesMockHandler(),
        getGetPlanStatisticsMockHandler(),
        getPostLinkSponsorMockHandler(),
        getGetAdvisorByIdStatsMockHandler(),
        getGetCarouselMockHandler(),
        getGetConnectivityMockHandler(),
        getGetCsmMockHandler(),
        getGetLoginDisclosureMockHandler(),
        getPutLoginDisclosureMockHandler(),
        getGetLoginDisclosureAgreementMockHandler(),
        getGetDocumentByIdMockHandler(),
        getPatchDeleteDocumentByIdMockHandler(),
        getGetAllDocumentsMockHandler(),
        getGetDocumentAgreementMockHandler(),
        getPostDocumentAgreementMockHandler(),
        getGetDocumentDownloadByIdMockHandler(),
        getGetDocumentDownloadByKeyMockHandler(),
        getGetDocumentAsHtmlMockHandler(),
        getGetDocumentAsHtmlAndDownloadMockHandler(),
        getPostPdfMockHandler(),
        getPostUploadDocumentMockHandler(),
        getPostEmailMockHandler(),
        getPostEmailPreviewRenderMockHandler(),
        getGetEmailPreviewByIdMockHandler(),
        getGetEmployeeHoldingsMockHandler(),
        getGetEmployeeLoansMockHandler(),
        getGetEmployeePerformanceMockHandler(),
        getGetEmployeeTransactionsMockHandler(),
        getGetEmployeePendingTransactionsMockHandler(),
        getGetEmployeeTransactionsYearsMockHandler(),
        getGetProgramModelSecuritiesMockHandler(),
        getGetEmployeesWithContributionsMockHandler(),
        getGetEmployeeLoanDetailsMockHandler(),
        getGetEmployeesTransactionsYearsMockHandler(),
        getPatchEsaParticipantGoalMockHandler(),
        getGetEsaParticipantGoalsMockHandler(),
        getGetEsaParticipantIncentivesMockHandler(),
        getGetEsaPlanCashInterestRateMockHandler(),
        getGetEsaPlanGroupBalanceOverTimeMockHandler(),
        getGetEsaPlanGroupStatsMockHandler(),
        getGetEsaPlanGroupsMockHandler(),
        getGetEsaPlanIncentivesMockHandler(),
        getPatchEsaWithdrawalMockHandler(),
        getPostSponsorExemptionConfirmationMockHandler(),
        getPostSponsorExemptionReasonMockHandler(),
        getGetFi360DownloadMockHandler(),
        getGetFeatureTogglesMockHandler(),
        getGetFeatureTogglesListMockHandler(),
        getGetFirmByIdMockHandler(),
        getGetHealthMockHandler(),
        getGetLoanAmortizationPdfMockHandler(),
        getGetManagedAccountsPlaidTokenMockHandler(),
        getDeleteManagedAccountsPlaidLinksMockHandler(),
        getGetManagedAccountsPlaidLinksMockHandler(),
        getPostManagedAccountsPlaidLinksMockHandler(),
        getPostManagedAccountsPlaidBalancesMockHandler(),
        getGetModelPerformanceMockHandler(),
        getGetParticipantByIdMockHandler(),
        getPatchParticipantMockHandler(),
        getGetParticipantAccountBalanceByIdMockHandler(),
        getPostParticipantLoanMockHandler(),
        getGetParticipantPlaidLinkTokenMockHandler(),
        getGetParticipantPlaidLinksMockHandler(),
        getPostParticipantPlaidLinksMockHandler(),
        getGetParticipantLoanCreateMockHandler(),
        getPatchParticipantLoanMockHandler(),
        getPostLoanManualRepaymentMockHandler(),
        getGetParticipantAccountsMockHandler(),
        getGetParticipantBalanceOverTimeMockHandler(),
        getGetParticipantBankAccountsMockHandler(),
        getGetBeneficiariesMockHandler(),
        getPutParticipantBeneficiariesMockHandler(),
        getGetRecentParticipantDocumentsMockHandler(),
        getPostEsaGoalMockHandler(),
        getGetParticipantIdentityVerificationMockHandler(),
        getPatchParticipantInfoWithEmailsMockHandler(),
        getGetGoalFeedbackMockHandler(),
        getPostElectionAgeSuggestionMockHandler(),
        getPostElectionRetirementIncomeSuggestionMockHandler(),
        getGetElectionsSetupMockHandler(),
        getPostElectionsSetupMockHandler(),
        getGetInvestmentsModelDisplayMockHandler(),
        getGetPlanParticipantModelSecuritiesMockHandler(),
        getGetPlanParticipantStatsMockHandler(),
        getPostRebalanceRequestMockHandler(),
        getGetRebalanceSettingsMockHandler(),
        getPutRebalanceSettingsMockHandler(),
        getGetStrategiesIndexMockHandler(),
        getGetAgeBasedMockHandler(),
        getPutAgeBasedMockHandler(),
        getPutCustomAllocationMockHandler(),
        getGetRiskBasedMockHandler(),
        getPutRiskBasedMockHandler(),
        getGetRiskModelQuestionnaireMockHandler(),
        getGetMailPreferencesMockHandler(),
        getPutMailPreferencesMockHandler(),
        getGetParticipantOnboardingMockHandler(),
        getGetParticipantOverviewMockHandler(),
        getPostParticipantDiscardPendingPlaidLinksMockHandler(),
        getGetPositionsMockHandler(),
        getPatchParticipantRolloverMockHandler(),
        getGetRolloverInstructionsMockHandler(),
        getGetRolloverEligibilityMockHandler(),
        getPostParticipantRolloverMockHandler(),
        getGetParticipantRolloverMockHandler(),
        getGetGenerateRolloverLetterMockHandler(),
        getGetSavingsDisplayMockHandler(),
        getPutSavingsMockHandler(),
        getGetSurveyLinkMockHandler(),
        getGetParticipantAggregatedByCategoryTransactionsMockHandler(),
        getGetAllowedWithdrawalReasonsMockHandler(),
        getPostWithdrawalMockHandler(),
        getGetUnregisteredParticipantsMockHandler(),
        getGetUnregisteredParticipantsCountMockHandler(),
        getGetParticipantWelcomeEmailDownloadMockHandler(),
        getGetParticipantWelcomeEmailsHistoryMockHandler(),
        getGetCalculatedEsaEmployerContributionsMockHandler(),
        getGetPersonasMockHandler(),
        getGetPlanParticipantsMockHandler(),
        getGetPlanModelMockHandler(),
        getGetPlanInvestmentsMockHandler(),
        getGetProgramFundsMockHandler(),
        getGetProgramModelsMockHandler(),
        getGetProspectusUrlPartsMockHandler(),
        getGetRedirectToPersonasMockHandler(),
        getGetParticipantAddressOptionsMockHandler(),
        getPostParticipantAddressVerifyMockHandler(),
        getPostAdvisorConnectMockHandler(),
        getGetAdvisorFinishMockHandler(),
        getPostAdvisorPasswordMockHandler(),
        getPostAdvisorVerifyMockHandler(),
        getGetParticipantCompanyOptionsMockHandler(),
        getPostParticipantCompanyVerifyMockHandler(),
        getPostParticipantConnectVerifyMockHandler(),
        getPatchParticipantContactMockHandler(),
        getPostRegistrationContactMockHandler(),
        getPostSponsorVerifyMockHandler(),
        getPostSponsorAccessCodeRequestMockHandler(),
        getPostSponsorConnectMockHandler(),
        getGetSponsorFinishMockHandler(),
        getPostSponsorPasswordMockHandler(),
        getGetParticipantFinishMockHandler(),
        getPostParticipantPasswordMockHandler(),
        getGetRegistrationResetMockHandler(),
        getPostParticipantVerifyMockHandler(),
        getGetRegistrationStateMockHandler(),
        getPatchRegistrationStateMockHandler(),
        getGetAdvisorReportMockHandler(),
        getGetEmployeeReportMockHandler(),
        getGetUnregisteredParticipantsReportMockHandler(),
        getGetPlanReportMockHandler(),
        getGetSponsorReportMockHandler(),
        getGetSubaTransactionsReportMockHandler(),
        getPostRetirementPlanner401kManagerQuestionnaireMockHandler(),
        getPostRetirementPlannerActivateMockHandler(),
        getPostRetirementPlannerDeactivateMockHandler(),
        getGetRetirementPlannerPreviewAllocationMockHandler(),
        getPostRetirementPlannerPreviewAllocationMockHandler(),
        getGetAllSafeHarborContributionTypesMockHandler(),
        getGetSessionMockHandler(),
        getGetSponsorAbilitiesMockHandler(),
        getGetCensusParticipantsMockHandler(),
        getGetBankAccountMockHandler(),
        getPostBankAccountMockHandler(),
        getPutBankAccountMockHandler(),
        getPatchSponsorMockHandler(),
        getGetSponsorTeammatesMockHandler(),
        getPatchDeleteTeammateMockHandler(),
        getPostSendUserInviteMockHandler(),
        getPostFileHeadersUpdateMockHandler(),
        getGetContributionsLandingPageDisplayMockHandler(),
        getPostContributionMockHandler(),
        getPostCancelSubmissionMockHandler(),
        getPostCancellationSubmissionMockHandler(),
        getGetParticipantsLoansMockHandler(),
        getPostOffCycleContributionMockHandler(),
        getPostResumeSubmissionMockHandler(),
        getPostIngestionFlowValidationMockHandler(),
        getPostContributionValidationMockHandler(),
        getGetContributionSubmissionDisplayMockHandler(),
        getPostContributionConfirmationMockHandler(),
        getGetContributionConfirmationDisplayMockHandler(),
        getPostContributionCorrectionMockHandler(),
        getGetContributionCorrectionsMockHandler(),
        getGetContributionDetailsMockHandler(),
        getGetContributionDisplayMockHandler(),
        getPostContributionUploadMockHandler(),
        getGetDownloadContributionFileMockHandler(),
        getGetForfeitureMockHandler(),
        getPostForfeitureMockHandler(),
        getGetContributionHeaderValidationsMockHandler(),
        getGetNormalizedContributionDataMockHandler(),
        getPostIngestionFlowStartMockHandler(),
        getGetDownloadContributionTemplateMockHandler(),
        getGetContributionValidationPageDisplayMockHandler(),
        getGetContributionValidationMockHandler(),
        getGetDeferralChangesMockHandler(),
        getPatchDeferralChangesActivitiesMockHandler(),
        getPutParticipantMockHandler(),
        getGetEmployeesMockHandler(),
        getPutParticipantsMockHandler(),
        getPostValidateEmployeeMockHandler(),
        getGetEmployeeDetailsMockHandler(),
        getPatchEmployeeMockHandler(),
        getPostContactInfoMockHandler(),
        getPutParticipantContributionsMockHandler(),
        getGetSponsorEntityMockHandler(),
        getGetForfeiturePreferenceMockHandler(),
        getPutForfeiturePreferenceMockHandler(),
        getGetHeapDataMockHandler(),
        getGetOnboardingMockHandler(),
        getPostOnboardingMockHandler(),
        getPutOnboardingMockHandler(),
        getGetSponsorOnboardingInformationMockHandler(),
        getPostUploadCensusMockHandler(),
        getGetInitialCensusMockHandler(),
        getGetSponsorEsaProgramMockHandler(),
        getGetOnboardingExistsMockHandler(),
        getPostFinishOnboardingMockHandler(),
        getGetSponsorOnboardingTeammatesMockHandler(),
        getPostSendOnboardingUserInviteMockHandler(),
        getGetNextPayrollDatesMockHandler(),
        getGetPayrollProvidersMockHandler(),
        getGetSponsorPlaidLinkTokenMockHandler(),
        getPostGetSponsorPlaidLinksMockHandler(),
        getGetPayrollConnectionStatusMockHandler(),
        getGetPayrollDatesMockHandler(),
        getGetPayrollInfoMockHandler(),
        getGetPayrollSetupsMockHandler(),
        getPostPayrollSetupMockHandler(),
        getGetPayrollFundingSetupsMockHandler(),
        getPutPayrollProviderMockHandler(),
        getPutPayrollSkipStatusMockHandler(),
        getPutSkipSubmissionMockHandler(),
        getDeletePayrollSetupMockHandler(),
        getPutPayrollDatesMockHandler(),
        getPostPayrollSetupDisconnectionMockHandler(),
        getPutPayrollSetupInfoMockHandler(),
        getPostPayrollValidationsMockHandler(),
        getGetPlanFeaturesMockHandler(),
        getGetPlanOnboardingStatusMockHandler(),
        getPostSponsorPlanDisconnectionMockHandler(),
        getGetPlanConfigurationMockHandler(),
        getPutPlanConfigurationMockHandler(),
        getGetPlanGrossCompensationMockHandler(),
        getPutPlanEmployeeGrossCompensationMockHandler(),
        getGetGrossCompensationTemplateMockHandler(),
        getPostPlanEmployeeGrossCompensationUploadMockHandler(),
        getPostPlanNonEmployeeOwnerMockHandler(),
        getGetPlanOfficersMockHandler(),
        getPutPlanOfficerStatusMockHandler(),
        getDeletePlanOwnerMockHandler(),
        getGetPlanOwnersMockHandler(),
        getPostPlanEmployeeOwnerMockHandler(),
        getPutPlanEmployeeOwnerMockHandler(),
        getDeletePlanOwnersFamilyMockHandler(),
        getGetPlanOwnersFamilyMockHandler(),
        getPutPlanOwnersFamilyMockHandler(),
        getGetTrackerDetailsMockHandler(),
        getPostPriorProviderMockHandler(),
        getGetPriorProvidersMockHandler(),
        getGetSponsorQuestionnaireMockHandler(),
        getPatchSponsorQuestionnaireMockHandler(),
        getGetQuestionnaireInformationMockHandler(),
        getGetContributionsMockHandler(),
        getGetSubaPlanDetailsMockHandler(),
        getGetSubaTransactionsMockHandler(),
        getPostYetCensusAutosaveMockHandler(),
        getGetYetCensusDataDownloadMockHandler(),
        getGetYetCensusDataPagedMockHandler(),
        getPostRestartCensusMockHandler(),
        getPostYetCensusStartMockHandler(),
        getGetCensusStatusMockHandler(),
        getPostYetCensusSubmitMockHandler(),
        getPostYetCensusUploadMockHandler(),
        getGetYetChecklistMockHandler(),
        getGetYetConfigMockHandler(),
        getPostContributionsFundMockHandler(),
        getPostContributionsRefundMockHandler(),
        getGetYetDocumentsMockHandler(),
        getPostStartOfPackagingMockHandler(),
        getGetYetSponsorQuestionnaireMockHandler(),
        getPostYetSponsorQuestionnaireMockHandler(),
        getPostRestartTestingProcessMockHandler(),
        getGetYetStatusMockHandler(),
        getGetYtdContributionsMockHandler(),
        getGetSponsorDigitalOnboardingMockHandler(),
        getGetPlanByIdV2MockHandler(),
        getGetWhiteLabelMockHandler(),
        getPostCreateWithdrawalMockHandler(),
        getGetRmdAmountMockHandler(),
        getGetRmdBalanceMockHandler(),
        getGetWithholdingMockHandler(),
        getGetWithholdingDetailMockHandler(),
        getGetYetNaicsMockHandler(),
        getGetZendeskJwtMockHandler(),
        getGetEntitySessionMockHandler()
    ];

//# sourceMappingURL=index.js.map